<template>
   
  <v-container fluid class="container-full-bg-gray"> 
   <div>
    <MessagePopup :message="message" :show_message="show_config_dialog" @close-message="show_config_dialog = false"></MessagePopup>

    <v-dialog v-model="showMessages.pending_training.show" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>{{ showMessages.pending_training.message }}</v-card-text>
        <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn id="ok-btn" color="white" text class="primary-bckground" @click="inactiveTrainingMessage()">OK</v-btn>
       </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMessages.init_instalation.show" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Iniciar Instalación</v-card-title>
        <v-card-text>{{ showMessages.init_instalation.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="inactiveInstalationMessage()">No</v-btn> 
          <v-btn color="white" text class="primary-bckground" @click="initInstalation()">Sí</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show_message" persistent max-width="500">
     <v-card>
       <v-card-title class="headline"></v-card-title>
       <v-card-text>Configurando connector con {{currentCompanydbType.name}}...</v-card-text>
       <v-card-text v-if="companydb">{{companydb.last_operation_state}}</v-card-text>
       <v-card-actions id="configuring-connector">
         <v-spacer></v-spacer>
         <v-btn id="ok-btn" color="white" text class="primary-bckground" @click="closeMessage()">OK</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

   <app-modal-prompt
       v-model="createUserDialog"
       :loading="createUserLoading"
       @confirm="confirmCreateUser()"
       @cancel="cancelCreateUser()"
   >
     <template #title>
         Nuevo usuario
     </template>
      <v-form ref="createUserDialogForm">
        <app-modal-container>
          <app-modal-row>
            <app-modal-col cols="12">
              <app-text-field
                  v-model="newUserValues.username"
                  label="Nombre de usuario"
                  prepend-inner-icon="mdi-account"
                  @keyup="usernameToLowerCase"
                  :rules="[validationRules.required, validationRules.notBlankSpace]"
              />
            </app-modal-col>
            <app-modal-col cols="12">
              <app-text-field
                  v-model="newUserValues.email"
                  label="Email"
                  prepend-inner-icon="mdi-email"
                  :rules="[validationRules.required, validationRules.emailFormat]"
              />
            </app-modal-col>
            <app-modal-col cols="12">
              <app-text-field
                  v-model="newUserValues.password"
                  counter
                  label="Contraseña"
                  prepend-inner-icon="mdi-lock-outline"
                  :hint="textPassMinLength"
                  :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace]"
                  :type="showPassCreateUserDialog ? 'text' : 'password'"
                  :append-icon="showPassCreateUserDialog ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassCreateUserDialog = !showPassCreateUserDialog"
              />
            </app-modal-col>
            <app-modal-col>
              <app-text-field
                  v-model="newUserValues.password_repeat"
                  counter
                  label="Repetir contraseña"
                  prepend-inner-icon="mdi-lock-outline"
                  :hint="textPassMinLength"
                  :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace, validationRules.createUserPassEqRepeat]"
                  :type="showPassCreateUserDialog2 ? 'text' : 'password'"
                  :append-icon="showPassCreateUserDialog2 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassCreateUserDialog2 = !showPassCreateUserDialog2"
              />
            </app-modal-col>
            </app-modal-row>
            <app-modal-row v-if="canCreateWriterUsers()">                  
              <app-modal-col cols="12">
                <app-select
                    v-model="newUserValues.friendship_kind"
                    filled
                    color="primary"
                    class="rounded-lg"
                    label="Rol"
                    item-text="name"
                    item-value="value"
                    prepend-inner-icon="mdi-account-hard-hat"
                    :items="friendship_kind_select"
                    :rules="[validationRules.required]"
                    :clearable="true"
                    @click:clear="clearNewUserRoleKind"
                    @change="clearNewUserRoleKind"
                />
              </app-modal-col>
              <app-modal-col cols="12">
                <app-select
                  v-model="newUserValues.role_kind"
                  filled
                  color="primary"
                  class="rounded-lg"
                  label="Permiso"
                  item-text="name"
                  item-value="value"
                  prepend-inner-icon="mdi-account-eye"
                  :items="roleKindSelectItems('create_user')"
                  :rules="[validationRules.required]"
                  :clearable="true"
                />
                </app-modal-col>
            </app-modal-row>
            <app-modal-row>
              <app-modal-col cols="12">
                  <v-checkbox v-model="newUserValues.view_invoices" class="modalCheckBox">
                      <template v-slot:label>
                          Acceso a facturas
                      </template>
                  </v-checkbox>
              </app-modal-col>
              <app-modal-col cols="12">
                  <v-checkbox v-model="newUserValues.view_banks" class="modalCheckBox">
                      <template v-slot:label>
                          Acceso a bancos
                      </template>
                  </v-checkbox>
              </app-modal-col>
              <app-modal-col cols="12">
                  <v-checkbox v-model="newUserValues.view_e_invoice" class="modalCheckBox">
                      <template v-slot:label>
                          Acceso a factura electrónica
                      </template>
                  </v-checkbox>
              </app-modal-col>
            </app-modal-row>
        </app-modal-container>
      </v-form> 
   </app-modal-prompt>

   <app-modal-prompt
       v-model="addUserDialog"
       :loading="addUserLoading"
       @confirm="confirmAddUser()"
       @cancel="cancelAddUser()"
   >
     <template #title>
         Añadir permiso
     </template>
      <v-form ref="addUserDialogForm">
        <app-modal-row>
          <app-modal-col cols="12">
            <app-autocomplete-with-api
                label="Usuario"
                v-model="modal_add_user.user"
                :starting_items="modal_add_user.list_users_select"
                :url="'get_free_invited_users/?companydb='+this.id"
                item_text="username"
                item_value="id"
                item_search_field="username"
                :return_object="true"
                class="pt-0"
                :rules="[validationRules.required]"
                prepend-inner-icon="mdi-account"
                :clearable="true"
                @input="clearAddUserRoleKind"
            ></app-autocomplete-with-api>
          </app-modal-col>
          <app-modal-col cols="12" v-if="canCreateWriterUsers()">
            <app-select
                v-model="modal_add_user.role_kind"
                filled
                color="primary"
                class="rounded-lg"
                label="Permiso"
                item-text="name"
                item-value="value"
                prepend-inner-icon="mdi-account-eye"
                :items="roleKindSelectItems('add_user')"
                :rules="[validationRules.required]"
                :clearable="true"
            />
          </app-modal-col>
        </app-modal-row>
      </v-form>
   </app-modal-prompt>

   <app-modal-prompt
       v-model="amProjectDialog"
       :loading="amProjectLoading"
       @confirm="confirmAMProject()"
       @cancel="cancelAMProject()"
   >
       <template #title>
         {{ projectToUpdate?'Editar':'Nuevo' }} Proyecto
       </template>
       <v-form ref="amProjectDialogForm">
           <app-text-field
             v-model="newProject.name"
             label="Nombre del proyecto"
             :rules="[validationRules.required]"
           />
           <app-text-field
             v-model="newProject.external_id"
             :label="'Código de ' + currentCompanydbType.name"
             :rules="[validationRules.required]"
           />
           <template v-if="feature_project_by_reference">
             <span v-for="(ref,i) in newProject.references" :key="i" >
               <app-text-field
                 :label="'Referencia ' + i.toString()"
                 v-model="newProject.references[i]"
                 :rules="[validationRules.required]"
                 :append-icon="'mdi-delete'"
                 @click:append="del_ref(parseInt(i))"
                 >
               </app-text-field>
             </span>
             <v-btn @click="add_ref()" color="primary" icon>
                 <v-icon>mdi-plus</v-icon>
             </v-btn>
             Añadir referencia
           </template>
       </v-form>
   </app-modal-prompt>

   <app-modal-prompt
       v-model="amCompanyRefsDialog"
       :loading="amCompanyRefsLoading"
       @confirm="confirmAMCompanyRefs()"
       @cancel="cancelAMCompanyRefs()"
   >
       <template #title>
         {{ companyRefToUpdate?'Editar':'Nueva' }} Referencia
       </template>
       <v-form ref="amCompanyRefsDialogForm">
           <app-autocomplete
             v-model="newCompanyReference.company_id"
             label="Empresa"
             itemValue="id"
             itemText="name"
             :items="referencable_companydbs"
             :rules="[validationRules.required]"
           />
           <app-text-field
             v-model="newCompanyReference.reference"
             label="Referencia"
             :rules="[validationRules.required]"
           />
           <v-btn @click="deleteCompanyRef()"><v-icon v-once>
             mdi-delete
           </v-icon></v-btn>

       </v-form>
   </app-modal-prompt>

   <app-modal-prompt
       v-model="amChannelDialog"
       :loading="amChannelLoading"
       @confirm="confirmAMChannel()"
       @cancel="cancelAMChannel()"
   >
       <template #title>
         {{ projectToUpdate?'Editar':'Nuevo' }} Canal
       </template>
       <v-form ref="amChannelDialogForm">
           <app-text-field
             v-model="newChannel.name"
             label="Nombre del canal"
             :rules="[validationRules.required]"
           />
           <app-text-field
             v-model="newChannel.external_id"
             :label="'Código de ' + currentCompanydbType.name"
             :rules="[validationRules.required]"
           />
           <template>
             <span v-for="(ref,i) in newChannel.references" :key="i" >
               <app-text-field
                 :label="'Referencia ' + i.toString()"
                 v-model="newChannel.references[i]"
                 :rules="[validationRules.required]"
                 :append-icon="'mdi-delete'"
                 @click:append="del_channel_ref(parseInt(i))"
                 >
               </app-text-field>
             </span>
             <v-btn @click="add_channel_ref()" color="primary" icon>
                 <v-icon>mdi-plus</v-icon>
             </v-btn>
             Añadir referencia
           </template>
       </v-form>
   </app-modal-prompt>


   <app-modal-prompt
       v-model="amActivityDialog"
       :loading="amActivityLoading"
       @confirm="confirmAMActivity()"
       @cancel="cancelAMActivity()"
   >
       <template #title>
         {{ activityToUpdate?'Editar':'Nueva' }} Actividad
       </template>
       <app-modal-container>
         <v-form ref="amActivityDialogForm">
           <app-modal-row>
             <app-modal-col cols="12">
               <app-text-field
                   v-model="newActivity.name"
                   label="Nombre de la Actividad"
                   :rules="[validationRules.required]"
               />
             </app-modal-col>
             <app-modal-col cols="12">
               <app-text-field
                   v-model="newActivity.code"
                   :label="'Código de ' + currentCompanydbType.name"
                   :rules="[validationRules.required]"
                   :type= "activity_type"
               />
             </app-modal-col>
           </app-modal-row>
         </v-form>
       </app-modal-container>
   </app-modal-prompt>

    <app-confirm-modal
        v-model="loadPathAlertPopup"
        :text-msg="loadPathAlertMsg"
        @confirm="confirmLoadPathAlertPopup(true)"
        @cancel="confirmLoadPathAlertPopup(false)"
      >
    </app-confirm-modal>

   <app-modal-prompt
       v-model="amLoadPathDialog"
       :loading="amLoadPathLoading"
       @confirm="confirmAMLoadPath()"
       @cancel="cancelAMLoadPath()"
       :width="1200"
   >
       <template #title>
         {{ loadPathToUpdate?'Editar':'Nuevo' }} Punto de Carga
       </template>
       <app-modal-container>
         <div class="text-center" v-if="loading_load_path_dialog">
           <v-progress-circular indeterminate color="primary" class="progress-circular" :size="50" :width="5">
           </v-progress-circular>
         </div>
         <div v-else>
           <v-form 
             ref="amLoadPathDialogForm"
             >
             <app-modal-row>
               <app-modal-col cols="6" class="pr-4">
                 <app-select
                     v-model="newLoadPath.load_path_type"
                     outlined
                     color="primary"
                     class="rounded-lg"
                     label="Tipo de Punto de Carga"
                     item-text="name"
                     item-value="id"
                     :items="load_path_types"
                     :rules="[validationRules.required]"
                     @change="load_path_type_selected()"
                     :disabled="canUpdateLoadPathPrimaryData"
                 >
                   <template v-slot:selection="data">
                     <v-icon color="primary">
                       {{ data.item.params.icon }}
                     </v-icon>
                     <v-flex class='ml-2'>
                       {{ data.item.name }}
                     </v-flex>
                   </template>
                   
                   <template v-slot:item="data">
                     <v-list-item-icon class='mr-2'>
                       <v-icon color="primary">
                         {{ data.item.params.icon }}
                       </v-icon>
                     </v-list-item-icon>
                     <v-list-item-content>
                       <v-list-item-title v-html="data.item.name"></v-list-item-title>
                     </v-list-item-content>
                   </template>
                 </app-select>
               </app-modal-col>

               <app-modal-col cols="6" class="pl-4" v-if="newLoadPath.load_path_type && loadPathSessionlabel != 'Email'">
                 <app-autocomplete
                   :label="'Sesiones de '+loadPathSessionlabel"
                   v-model="newLoadPath.oauth_session"
                   :items="storageOpenidUsersByValue"
                   item-text="account_name"
                   item-value="id"
                   :rules="[validationRules.required]"
                   :disabled="canUpdateLoadPathPrimaryData"
                   @change="storage_session_selected()"
                   hide-search
                   hide-details
                   outlined
                 />
               </app-modal-col>
             </app-modal-row>
             <div v-if="newLoadPath.oauth_session || loadPathSessionlabel == 'Email'">
               <app-modal-row>
                 <app-modal-col cols="6" class="pr-4" v-if="loadPathSessionlabel != 'Email'">
                   <app-text-field
                     v-model="newLoadPath.path.display_path"
                     label="Ruta"
                     :rules="[validationRules.required]"
                     :disabled="canUpdateLoadPathPrimaryData && currentLoadPathType.value == 'drive'"
                     readonly
                     outlined
                     @click="openFolderSelector()"
                   />
                 </app-modal-col>
                 <template v-else>
                 <app-modal-col cols="3" class="pr-4" >
                   <app-text-field
                     v-model="newLoadPath.email_prefix"
                     label="Dirección de correo"
                     :rules="[validationRules.required]"
                   />
                 </app-modal-col>
                 <app-modal-col cols="3" class="pr-4" >
                   <app-text-field
                     v-model="userData.email_entrypoint_domain"
                     label="Dominio"
                     readonly
                   />
                 </app-modal-col>
                 </template>
                 <app-modal-col cols="6" class="pl-4">
                   <app-select
                     v-model="newLoadPath.doc_kind"
                     outlined
                     label="Tipo de documento"
                     item-value="id"
                     item-text="text"
                     :items="availableDocs"
                     :rules="[validationRules.required]"
                   />
                 </app-modal-col>

               </app-modal-row>
               <app-modal-row>
                 <app-modal-col cols="6" class="pr-4">
                   <app-select
                     v-model="newLoadPath.accounting_date"
                     outlined
                     label="Fecha contable"
                     item-value="id"
                     item-text="text"
                     :items="ACCOUNTING_DATE_OPTIONS"
                     :rules="[validationRules.required]"
                   />
                 </app-modal-col>
                 <app-modal-col cols="6" class="pl-4">
                   <app-date-picker
                     v-if="newLoadPath.accounting_date == 'configurated'"
                     aucomplete="off"
                     label="Fecha (dd/mm/yyyy)"
                     v-model="newLoadPath.configurated"
                     date_format="YYYY-MM-DDThh:mm:ssZ"
                     :rules="[validationRules.dateLoadPathRequired, validationRules.dateFormat]"
                     outlined
                   ></app-date-picker>
                 </app-modal-col>
               </app-modal-row>
               <app-modal-row>
                 <app-modal-col cols="6" class="pr-4" v-if="showActivityField('actividad') && got_feature('feature_actividad_selector') && activities.length > 0">
                   <app-autocomplete
                     label="Actividad"
                     v-model="newLoadPath.activity"
                     :items="activities"
                     item-value="code"
                     item-text="name"
                     :clearable="true"
                     outlined
                   />
                 </app-modal-col>
                 <app-modal-col cols="6" class="pr-4" v-else-if="showActivityField('actividad')">
                   <app-text-field
                     v-model="newLoadPath.activity"
                     label="Actividad"
                     type="number"
                     outlined
                     autocomplete="off"
                   />
                 </app-modal-col>
                 <app-modal-col cols="6" class="pr-4" v-if="showProjectsMasterCanHide()">
                   <app-autocomplete
                     label="Proyecto"
                     v-model="newLoadPath.project"
                     :items="currentCon.projects"
                     item-value="id"
                     item-text="name"
                     :clearable="true"
                     outlined
                   />
                 </app-modal-col>
                 <app-modal-col cols="6" class="pl-4">
                   <v-checkbox
                     label="Separar Páginas"
                     v-model="newLoadPath.split_doc"
                   ></v-checkbox>
                 </app-modal-col>
                 <app-modal-col cols="6" class="pl-4">
                   <v-row v-if="loadPathSessionlabel != 'Email'" class="align-center">
                    <v-col>
                      <v-checkbox
                        v-if="newLoadPath.allow_check_only_new_files"
                        label="Cargar solo ficheros nuevos"
                        v-model="newLoadPath.only_new_files"
                        checked="true"
                      ></v-checkbox>
                    </v-col>
                    <v-col v-if="loadPathToUpdate">
                      <div class="d-flex align-center justify-end">
                        <v-btn @click="popupExcludedFiles=true" small class="excluded__files rounded-lg" elevation="0">
                          Ficheros excluidos
                        </v-btn>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="forceLoadPathDownload()" color="primary" icon v-bind="attrs" v-on="on" :loading="forceDownloadLoading">
                              <v-icon>mdi-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Forzar descarga</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                  <v-checkbox
                    v-if="loadPathSessionlabel == 'Email'"
                    label="Cargar solo documentos PDF"
                    v-model="newLoadPath.accept_pdf_only"
                  ></v-checkbox>
                 </app-modal-col>

               </app-modal-row>
               <!-- <app-modal-row>
                 <app-modal-col cols="6" v-for="(extra_field, index) in currentLoadPathType.params['extra_fields']" :key="extra_field['key']">
                   <app-text-field
                     v-model="newLoadPath.values[extra_field['key']]"
                     :label="extra_field['label']"
                     outlined
                     :class="{'pr-4': index%2==0,  'pl-4': index%2!=0}"
                   />
                 </app-modal-col>
               </app-modal-row> -->
               <app-modal-row v-if="got_feature('feature_received_emails_list') && loadPathToUpdate && loadPathSessionlabel == 'Email'">
                 <b> Emails recibidos:</b> 
                 <app-col cols="12" style="overflow-y:auto; height:500px">
                   <app-simple-table-with-api2
                     ref="receivedEmails"
                     :key="loadPathToUpdate.id"
                     :headers="receivedEmailsHeaders"
                     :url="'query'"
                     :api_params="{query:'entrypoint.received.emails',args:{entrypoint_id:loadPathToUpdate.id},limit:100}"
                     :showSelect="false"
                     :search-filters="[]"
                   >
                   </app-simple-table-with-api2>
                 </app-col>
               </app-modal-row>
             </div>
           </v-form>
         </div>
       </app-modal-container>
   </app-modal-prompt>

  <v-dialog v-model="popupExcludedFiles" v-if="loadPathToUpdate && popupExcludedFiles" max-width="800">
    <ExcludedFilesTable
        :load_path_id="loadPathToUpdate.id"
        :key="popupExcludedFilesKey"
        @excluded-files-updated="updateExcludedFiles(true)"
        @excluded-files-updated-error="updateExcludedFiles(false)"
    ></ExcludedFilesTable>
  </v-dialog>

   <app-confirm-modal
       v-model="pathConfirmationDialog"
       :text-msg="folderWarningMessage"
       @confirm="setPathFolder()"
       @cancel="reOpenFolderSelector()"
   >
   </app-confirm-modal>

   <app-modal-prompt
       v-model="folderManagerDialog"
       :loading="false"
       @confirm="validatePathFolder()"
       @cancel="noSetPathFolder()"
   >
       <template #title>
         Archivos de {{loadPathSessionlabel}}
       </template>

       <JobProgress v-model="openFolderSelectorJobState" v-on:done="openFolderSelectorJobDone()" :job_id="openFolderSelectorJobId" class="progress_circular">
         <template v-slot:progress>
           <v-progress-circular
               v-if="openFolderSelectorJobState==='running'"
               indeterminate           
               color="primary"
               class="progress_circle"
           ></v-progress-circular>
         </template>
         <template v-slot:done>
           <div>
             <v-form>
               <v-treeview
                   :active.sync="activeFolder"
                   :open.sync="openFolder"
                   :items="folderItems"
                   activatable
                   item-key="path"
                   return-object
                   dense
                   :load-children="loadChildren"
                 >
                   <template v-slot:prepend="{ item, open }">
                     <v-icon v-if="!item.is_shared">
                       {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                     </v-icon>
                     <v-icon v-else v-once>
                       {{ 'mdi-folder-network' }}
                     </v-icon>
                   </template>
               </v-treeview>
             </v-form>
           </div>
         </template>
       </JobProgress>
   </app-modal-prompt>

   <app-modal-prompt
       v-model="amAccountDialog"
       :loading="amAccountLoading"
       @confirm="confirmAMAccount()"
       @cancel="cancelAMAccount()"
   >
       <template #title>
         {{ accountToUpdate?'Editar':'Nueva' }} Cuenta
       </template>
       <v-form ref="amAccountDialogForm">
         <account-field
             v-model="newAccount.account"
             label="Número de cuenta"
             :rules="[validationRules.required, validationRules.notBlankSpace]"
         ></account-field>
         <app-text-field
             v-model="newAccount.description"
             label="Descripción"
             :rules="[validationRules.required]"
         >
         </app-text-field>
       </v-form>
   </app-modal-prompt>

   <app-confirm-modal
       v-model="deleteUserDialog"
       :text-msg="deleteUserMsg"
       @confirm="deleteUser()"
       @cancel="noDeleteUser()"
   >
   </app-confirm-modal>

   <app-modal-prompt
       v-model="changePassUserDialog"
       :loading="changePassLoading"
       @confirm="confirmChangePassUserDialog()"
       @cancel="cancelChangePassUserDialog()"
   >
       <template #title>
           Cambiar Contraseña
       </template>
       <app-modal-container>
         <v-form ref="changePassUserDialogForm">
           <app-modal-row>
             <app-modal-col cols="12">
               <app-text-field
                   v-model="newPassValues.password"
                   counter
                   label="Nueva contraseña"
                   prepend-inner-icon="mdi-lock-outline"
                   :hint="textPassMinLength"
                   :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace]"
                   :type="showPassChangePass ? 'text' : 'password'"
                   :append-icon="showPassChangePass ? 'mdi-eye' : 'mdi-eye-off'"
                   @click:append="showPassChangePass = !showPassChangePass"
               />
             </app-modal-col>
             <app-modal-col cols="12">
               <app-text-field
                   v-model="newPassValues.password_repeat"
                   counter
                   label="Repetir nueva contraseña"
                   prepend-inner-icon="mdi-lock-outline"
                   :hint="textPassMinLength"
                   :rules="[validationRules.required, validationRules.passMinLength, validationRules.notBlankSpace, validationRules.changePassEqRepeat]"
                   :type="showPassChangePass2 ? 'text' : 'password'"
                   :append-icon="showPassChangePass2 ? 'mdi-eye' : 'mdi-eye-off'"
                   @click:append="showPassChangePass2 = !showPassChangePass2"
               />
             </app-modal-col>
           </app-modal-row>
         </v-form>
       </app-modal-container>
   </app-modal-prompt>

   <app-confirm-modal
       v-model="deleteProjectDialog"
       :text-msg="deleteProjectMsg"
       @confirm="deleteProject()"
       @cancel="noDeleteProject()"
   >
   </app-confirm-modal>


   <app-confirm-modal
     v-model="deleteChannelDialog"
     :text-msg="deleteChannelMsg"
     @confirm="deleteChannel()"
     @cancel="noDeleteChannel()"
   ></app-confirm-modal>

   <app-confirm-modal
       v-model="deleteActivityDialog"
       :text-msg="deleteActivityMsg"
       @confirm="deleteActivity()"
       @cancel="noDeleteActivity()"
   >
   </app-confirm-modal>

   <app-confirm-modal
       v-model="deleteLoadPathDialog"
       :text-msg="deleteLoadPathMsg"
       @confirm="deleteLoadPath()"
       @cancel="noDeleteLoadPath()"
   >
   </app-confirm-modal>

   <app-confirm-modal
       v-model="deleteAccountsDialog"
       :text-msg="deleteAccountsMsg"
       @confirm="deleteAccounts()"
       @cancel="noDeleteAccounts()"
   >
   </app-confirm-modal>
   <app-confirm-modal
      v-model="deleteExpensIncomeTypeDialog"
      :text-msg="deleteExpensIncomeTypeMsg"
      @confirm="deleteExpensIncomeType()"
      @cancel="noDeleteExpensIncomeType()"
   ></app-confirm-modal>

   <v-dialog v-model="errorDialog" persistent max-width="500">
     <v-card>
       <v-card-title class="headline title-color"></v-card-title>
       <v-card-text>{{ errorMsg }}</v-card-text>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="white" text class="primary-bckground" @click="closeErrorDialog()">Ok</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

   <v-dialog v-model="import_errors_dialog" max-width="500">
     <v-card>
       <v-card-title class="headline title-color">Errores:</v-card-title>
       <v-card-text>
         <v-row>
           <template cols="12" v-for="i in Object.keys(importErrors)">
             <template v-if="importErrors[i].length">
               <template v-for="error, index in importErrors[i]">
                 <v-col cols="12" :key="i + '_' + index">En la línea {{i}}: {{error}}</v-col>
               </template>
             </template>
           </template>
         </v-row>
       </v-card-text>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="white" text class="primary-bckground" @click="import_errors_dialog = false">Ok</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>


       <!-- <v-tabs v-model="currantCSVTab">
         <v-tab
           key="csv_one_line"
           @click.native.stop
         >
           Columnas CSV
         </v-tab>
         <v-tab
           key="csv_multi_line"
           @click.native.stop
         >
           Columnas CSV Multilínea
         </v-tab>
       </v-tabs> -->
       <!-- <v-tabs-items v-model="currantCSVTab"> -->
         <!-- <v-tab-item key="csv_one_line"> -->
           
           <draggable-show-hide-dialog
             v-model="csv_one_line_dialog"
             title="Selector de Columnas CSV"
             :show_columns="csv_one_line_headers"
             :hide_columns="csv_one_line_hidden_headers"
             show_columns_header="Columnas ordenadas del CSV"
             hide_columns_header="Columnas excluidas del CSV"
             :key="csv_one_line_dialog"
             @update="updateCSVOneLineColumns"
             @cancel="csv_one_line_dialog=false"
           >
             <template v-slot:top_actions v-if="feature_copy_config_from_cdb">
               <copy-settings 
                   @copy-settings="copySettings"
                   :cdb_id="id"
                   code="csv_facturas_one_line_headers"
                   :copying="copying"  
               />
             </template>
           </draggable-show-hide-dialog>

           <excel-draggable-show-hide-dialog
           v-model="excel_columns_dialog"
           title="Selector de Columnas Excel"
           :show_columns="excel_headers"
           :hide_columns="excel_hidden_headers"
           show_columns_header="Columnas ordenadas del Excel"
           hide_columns_header="Columnas excluidas del Excel"
           :key="'excel_dialog_k'+excel_columns_dialog"
           :loading="excel_dialog_loading"
           @update="updateExcelColumns"
           @cancel="excel_columns_dialog=false"
       >
        <template v-slot:top_actions>
          <i> 
              * Esta configuración prevalece sobre la configuración de usuario.
          </i>
        </template>
       </excel-draggable-show-hide-dialog>
         <!-- </v-tab-item> -->
         <!-- <v-tab-item key="csv_multi_line">
           <draggable-show-hide-dialog
             :show_columns="csv_multi_line_headers"
             :hide_columns="csv_multi_line_hidden_headers"
             show_columns_header="Columnas ordenadas del CSV"
             hide_columns_header="Columnas excluidas del CSV"
             :key="csv_one_line_dialog"
             @update="updateCSVOneLineColumns"
             @cancel="csv_one_line_dialog=false"
           ></draggable-show-hide-dialog>
         </v-tab-item>
       </v-tabs-items> -->
     <csv-fields-values 
       v-model="csv_one_line_field_values_dialog" 
       @cancel="csv_one_line_field_values_dialog = false" 
       :cdb_id="id+''" :is_cdb_required="true"
       title="Configurar valores celdas CSV"
     >
      <template v-slot:top_actions v-if="feature_copy_config_from_cdb">
        <copy-settings
          @copy-settings="copySettingsValues"
          :cdb_id="id"
          code="csv_facturas_one_line_configure_field_values" 
          :copying="copying"
        ></copy-settings>
      </template>
     </csv-fields-values>

   <v-dialog v-model="info_dialog" max-width="900px">
     <v-card>
       <v-card-title class="headline title-color"></v-card-title>
       <v-card-text v-html="this.currentCompanydbType['extra_info']"></v-card-text>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn color="white" text class="primary-bckground" @click="info_dialog = false">Ok</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

   <oauth-prompt
       v-if="connectDialog"
       v-model="connectDialog"
       :text-msg="oauth_message"
       :path-label="SessionLabel"
       :show-mail-field="showMailField"
       @confirm="confirmConnectOuth2User"
       @cancel="closeSessionDialog()"
   >
   </oauth-prompt>

   <SignContract
     v-if="contract_dialog" 
     :show_dialog="contract_dialog"
     title="Actualización de las Políticas de Privacidad"
     @desagree="closeTermsDialog" 
     @agree="saveTermsDialog"
   >
     <LegalContract kind="privacy_policy" @contract-data="getContractData"/>
   </SignContract>

   <app-page-card>
     <template #header>
         {{ textScreenTitle }}{{currentCon.name||currentCon.cif ? ': ' : '' }} <span v-if="currentCon.name||currentCon.cif" class="connector-detail__title__company-name">{{currentCon.name}} ({{currentCon.cif}})</span>
     </template>
     <template #tabs-title>
         <div class="px-8 pt-2 tabs-title-div-bck">
             <v-row align="center">
                 <v-col cols="9" class="pt-0">
                   <v-tabs v-model="currentZone">
                     <v-tab
                       v-for="item in connectorTabs"
                       :key="item.key"
                       @click.native.stop
                       @click="TabSelected(item.key)"
                       :href="`#${item.key}`"
                       class="prova"
                     >
                       {{item.name}}
                     </v-tab>
                   </v-tabs>
                </v-col>

                <v-col cols="3" class="d-flex align-center justify-space-around">
                  <v-spacer/>
                  <template v-if="!imInboxType" >
                    <v-tooltip top v-if="(currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('nst_files')) && refreshProgressState != 'error' && refreshProgressState != 'pending'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn  
                          @click="refresh_contanet_paths()" 
                          v-bind="attrs" 
                          v-on="on"
                          icon
                          class="mr-2"
                          >
                          <img src="/company/refresh_contanet_paths.svg"></img>
                        </v-btn>
                      </template>
                      <span>Refrescar las rutas al fichero .NST de Contanet</span>
                    </v-tooltip>
                    <div v-if="(currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('nst_files')) && refreshProgressState === 'pending'" class="d-flex justify-center">
                      <v-progress-circular indeterminate color="primary" />
                    </div>
                    <v-tooltip top v-else-if="userData.available_features['feature_configure_csv_fields_values'] && (currentCompanydbType && currentCompanydbType.params && currentCompanydbType.params.contabilize_on_csv)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn  
                          @click="csv_one_line_field_values_dialog = true" 
                          v-bind="attrs" 
                          v-on="on"
                          icon
                          class="mr-2"
                          >
                          <img src="/company/config_column_csv.svg"/>
                        </v-btn>
                      </template>
                      <span>Configurar valores del CSV</span>
                    </v-tooltip>
                    <v-tooltip top v-else-if="currentCon.id && got_feature('feature_upload_excel')">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn  
                          @click="openExcelColumnsDialog" 
                          v-bind="attrs" 
                          v-on="on"
                          icon
                          class="mr-2"
                          >
                          <img src="/company/config_column_excel.svg"/>
                        </v-btn>
                      </template>
                      <span>Configurar columnas excel</span>
                    </v-tooltip>
                  </template>
                  <template v-if="!imInboxType || got_feature('feature_force_show_sync_thirds')">
                    <v-tooltip top v-if="currentCon.id && !['pending','running_batch'].includes(refreshAccountsState) && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('sync_thirds'))))">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn  @click="refresh_accounts()" v-bind="attrs" v-on="on" icon class="mr-2">
                          <img src="/company/refresh_accounts.svg"/>
                        </v-btn>
                      </template>
                      <span>Actualizar Proveedores y Clientes de la Empresa</span>
                    </v-tooltip>
                    <v-tooltip top v-else-if="userData.available_features.feature_config_settings && (currentCompanydbType && currentCompanydbType.params && currentCompanydbType.params.contabilize_on_csv)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="openColumnOrderDialog" v-bind="attrs" v-on="on" icon class="mr-2">
                          <img src="/company/config_settings_csv.svg"/>
                        </v-btn>
                      </template>
                      <span>Actualizar Orden de Columnas del CSV</span>
                    </v-tooltip>
                    <div v-if="['pending','running_batch'].includes(refreshAccountsState)" class="d-flex justify-center">
                      <v-progress-circular indeterminate color="primary" />
                    </div>
                  </template>

                  <template v-if="['Datos', 'Emisor de Facturas'].includes(currentZone)">
                   <v-btn
                     v-if="currentCon && currentCon.id"
                     color="primary"
                     :loading="creating"
                     class="connector-detail__tab-bar__action-btn"
                     :disabled="disabled_save()"
                     @click="update()"
                   >
                     Guardar
                   </v-btn>
                   <v-btn
                     v-else
                     color="primary"
                     :loading="creating"
                     class="connector-detail__tab-bar__action-btn"
                     :disabled="disabled_save()"
                     @click="create()"
                   >
                     Guardar
                   </v-btn>
                  </template>
                 <template v-if="currentZone == 'Suscripcion'">
                   <v-btn
                     color="primary"
                     :loading="creating"
                     icon
                     :disabled="webhook.loading"
                     @click="saveWebhook()"
                   >
                     <v-icon large>mdi-content-save</v-icon>
                   </v-btn>
                  </template>
                </v-col>                 
             </v-row>
         </div>
     </template>
     <template>
       <v-tabs-items v-model="currentZone" class="ma-0 items-tabs">
         <v-tab-item
           key="Datos"
           value="Datos"
         >
         <app-container fluid v-if="loading">
           <app-row>
             <app-col>
               <v-progress-circular 
                 indeterminate
                 color="primary">
               </v-progress-circular>
             </app-col>
           </app-row>
         </app-container>
           <app-container fluid v-else-if="!loading && currentCon">
             <app-row>
               <v-expand-transition>
                 <app-col cols="12" class="pt-8" v-show="Object.keys(this.errors).length">
                   <v-alert
                     outlined
                     prominent
                     text
                     type="error"
                   >
                     {{this.errors[Object.keys(this.errors)[0]]}}
                   </v-alert>
                 </app-col>
               </v-expand-transition>
             </app-row>
             <app-row>
               <app-col contains-input-fields cols="3" id="select-connector-type">
                 <app-select
                   ref="selectTypeRef"
                   v-model="currentCon.companydb_type"
                   :readonly="Boolean(currentCon.id)"
                   :items="companydb_types"
                   label="Tipo"
                   @change="type_selected()"
                   return-object
                   item-text="name"
                 ></app-select>
               </app-col>
               <app-col contains-input-fields v-if="!imInboxType" cols="3">
                 <app-text-field 
                   v-if="showNameField()"
                   v-model="currentCon.cif"
                   label="CIF de la empresa"
                 ></app-text-field>
               </app-col>
               <app-col contains-input-fields cols="3">
                 <app-text-field 
                   v-if="showNameField()"
                   v-model="currentCon.name"
                   label="Nombre de la empresa"
                 ></app-text-field>
               </app-col>
               <app-col contains-input-fields v-if="!imInboxType" cols="3">
                 <app-select
                   v-if="showNameField()"
                   v-model="currentCon.tax_type"
                   :items="getTaxType"
                   label="Tipo de impuestos"
                 ></app-select>
               </app-col>
              </app-row>

              <app-row>
                <app-col contains-input-fields has-input-fields-above cols="3"
                  v-if="currentCompanydbType.params && currentCompanydbType.params.auth_type && currentCompanydbType.params.auth_type == 'openid'">
                  <app-autocomplete 
                    v-model="currentCon.oauth_session"
                    :items="openid_users"
                    label="Sesiones de Innuva"
                    item-text="account_full_name"
                    item-value="id"
                    hide-search
                    @change="session_selected()"
                    :readonly="Boolean(currentCon.id)"
                  >                        
                  </app-autocomplete>
                </app-col>  
              </app-row>

              <app-row v-if="!imInboxType">
                <app-col 
                  contains-input-fields
                  has-input-fields-above
                  cols="3" 
                  v-if="currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('num_digits')))"
                >
                  <v-text-field
                    autocomplete="off"
                    label="Dígitos plan"
                    v-model.number="currentCon.num_digits"
                    class="rounded-lg app-text-field-no-border"
                    filled
                  />
                </app-col>                              
                <app-col 
                    contains-input-fields
                    has-input-fields-above
                    cols="3" 
                    v-if="feature_decimal_separator">
                  <app-select
                    v-model="currentCon.decimal_separator"
                    :items="decimal_separator_choices"
                    label="Separador decimal (en ambigüedad)"
                  ></app-select>
                </app-col>
                <app-col 
                    contains-input-fields
                    has-input-fields-above
                    cols="3"
                >
                  <v-text-field
                    type="number"
                    step="0.01"
                    min="0.001"
                    max="0.99"
                    :disabled="!currentCon.id"
                    :label='got_feature("feature_tolerancy_not_applies_total_amount") ? "Tolerancia de descuadre para bases y cuotas" : "Tolerancia de descuadre"'
                    v-model="currentCon.tolerancy"
                    class="rounded-lg app-text-field-no-border"
                    filled
                  ></v-text-field>
                </app-col>
                <app-col contains-input-fields has-input-fields-above cols="3" 
                  v-if="company_has_locations">
                  <app-select
                    v-model="currentCon.location_fk_id"
                    :items="locations"
                    label="Ruta de la empresa"
                    item-text="name"
                    item-value="id"
                    clearable
                  ></app-select>
                </app-col>  
              </app-row>


              <app-row>
                <app-col cols="12">
                  <v-expansion-panels v-model="panel" >
                    <app-expansion-panel>                      
                      <template #title>
                        Ejercicios
                      </template>
                      <template>
                        <app-simple-table colspan="3">
                          <template #action-bar>
                            <th
                                :colspan="userData.available_features['feature_prorate'] && currentCon.prorate ? 6 : 5"
                            >
                              <app-modal-row class="pa-2" align="center">
                                <app-modal-col cols="2" v-if="!imInboxType">
                                  <v-btn small text color="primary" class="text-none" 
                                    @click="add_link()"
                                    :disabled="!currentCompanydbType"
                                  >
                                    <v-icon small color="primary">
                                      mdi-plus
                                    </v-icon>
                                    Añadir ejercicio
                                  </v-btn>
                                </app-modal-col>
                                <app-modal-col cols="2">
                                  <v-checkbox
                                      v-if="userData.available_features['feature_prorate'] && !imInboxType"
                                      dense hide-details
                                      :disabled="!currentCon.id"
                                      label="Prorratas"
                                      color="primary"
                                      class="ma-0 pa-0 text-caption"
                                      v-model="currentCon.prorate"
                                  ></v-checkbox>
                                </app-modal-col>
                                <app-modal-col cols="6">
                                  <doc-text-field
                                      v-if="currentCon.prorate && got_feature('feature_negative_adjustment_account')"
                                      dense
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.negative_adjustment_account"
                                      label="Cuenta ajustes negativos en la imposición indirecta"
                                      class="text-caption"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></doc-text-field>
                                </app-modal-col>
                              </app-modal-row>
                            </th>
                          </template>
                          <template #column-headers>
                            <tr>
                              <template v-if="userData.available_features['feature_periodo_ejercicio']">
                                <th>
                                  Fecha inicio ejercicio
                                </th>
                                <th>
                                  Fecha fin ejercicio
                                </th>
                                <th>
                                  Año ejercicio
                                </th>
                              </template>
                              <th>
                                Fecha mínima de las facturas
                              </th>
                              <th>
                                Fecha máxima de las facturas
                              </th>
                              <th>
                                {{ label_path }}
                              </th>
                              <th v-if="userData.available_features['feature_prorate'] && currentCon.prorate">
                                Porcentaje Prorrata
                              </th>
                              <th>
                                Activo
                              </th>
                              <th v-if="got_feature('feature_validate_link')">
                                Validación
                              </th>
                              <th>
                                Acciones
                              </th>
                            </tr>
                          </template>
                          <tbody>
                          <tr v-for="(link, index) in currentCon.links" :key="index" v-if="!imInboxType">
                            <template v-if="link!=undefined && !link.deleted">
                              <template v-if="userData.available_features['feature_periodo_ejercicio']">
                                <td>
                                  <date-picker
                                      dense
                                      v-model="link.start_ejercicio"
                                      :readonly="!currentCompanydbType.value || !can_edit_ejercicio(link)"
                                      :error="errorLinks[index].indexOf('start_ejercicio') > -1"
                                  />
                                </td>
                                <td>
                                  <date-picker
                                      dense
                                      v-model="link.end_ejercicio"
                                      :readonly="!currentCompanydbType.value || !can_edit_ejercicio(link)"
                                      :error="errorLinks[index].indexOf('end_ejercicio') > -1"
                                  />
                                </td>
                                <td>
                                  <v-text-field
                                    dense
                                    v-model="link.year_ejercicio"
                                    type="number"
                                    :disabled="!currentCon.companydb_type || Boolean(link.id)"
                                    :error="errorLinks[index].indexOf('year_ejercicio') > -1"
                                ></v-text-field>
                                </td>
                              </template>
                              <td>
                                <date-picker
                                    dense
                                    v-model="link.min_date"
                                    :readonly="!currentCompanydbType.value"
                                    :error="errorLinks[index].indexOf('min_date') > -1"
                                />
                              </td>
                              <td>
                                <date-picker
                                    dense
                                    v-model="link.max_date"
                                    :readonly="!currentCompanydbType.value"
                                    :error="errorLinks[index].indexOf('max_date') > -1"
                                />
                              </td>
                              <td>
                                <app-row class="ma-0 pa-0">
                                  <app-col class="ma-0 pa-0" :cols="hasInfo ? 11 : 12">
                                    <v-combobox
                                        v-if="currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('nst_files')"
                                        dense
                                        id="connector-link-path"
                                        :background-color="(!link.link_path || errors.hasOwnProperty('link_path')) ? '#ff9898' : 'white'"
                                        autocomplete="off"
                                        style="font-size: 0.9em"
                                        :label="label_path"
                                        v-model="link.link_path_aux"
                                        :items="nstpaths"
                                        item-text="path"
                                        :return-object="false"
                                        :disabled="!currentCon.companydb_type"
                                        @input.native="e => {link.link_path = e.target.value}"
                                        @change="link.link_path = link.link_path_aux"
                                    ></v-combobox>
                                    <app-row
                                        v-else-if="currentCompanydbType.params && currentCompanydbType.params.auth_type && currentCompanydbType.params.auth_type == 'openid' && !Boolean(currentCon.id)"
                                        class="ma-0 pa-0"
                                    >
                                      <app-col cols="11" class="ma-0 pa-0">
                                        <v-autocomplete
                                            v-model="openid_company"
                                            dense
                                            :items="openid_companies"
                                            label="Empresas"
                                            item-text="companyName"
                                            return-object
                                            hide-selected
                                            hide-search
                                            hide-details
                                            @change="set_link_values(index)"
                                            :loading="loading_oauth_cdbs"
                                        ></v-autocomplete>
                                      </app-col>
                                      <app-col cols="1">
                                        <v-progress-circular
                                            v-if="loading_oauth_cdbs"
                                            indeterminate
                                            color="primary">
                                        </v-progress-circular>
                                      </app-col>
                                    </app-row>
                                    <v-text-field
                                        v-else-if="(Boolean(currentCon.id) && currentCon.oauth_session)"
                                        dense
                                        id="connector-link-path"
                                        :background-color="(!is_link_path_correct(link) || errors.hasOwnProperty('link_path')) ? '#ff9898' : 'white'"
                                        style="font-size: 0.9em"
                                        v-model="link.link_name"
                                        :disabled="!currentCon.companydb_type"                                        
                                        readonly
                                    />
                                    <v-text-field
                                        v-else
                                        dense
                                        id="connector-link-path"
                                        :background-color="(!is_link_path_correct(link) || errors.hasOwnProperty('link_path')) ? '#ff9898' : 'white'"
                                        style="font-size: 0.9em"
                                        v-model="link.link_path"
                                        :disabled="!currentCon.companydb_type"                                        
                                    />
                                  </app-col>
                                  <app-col cols="1" class="ma-0 pa-0 d-flex align-center">
                                    <v-btn v-if="hasInfo" @click="openInfo" color="primary" icon>
                                      <v-icon v-once>
                                        mdi-information-variant
                                      </v-icon>
                                    </v-btn>
                                  </app-col>
                                </app-row>
                                <!--
                                <span v-if="!link.link_path">Este campo es obligatorio</span>
                                <span v-else-if="currentCompanydbType.params && currentCompanydbType.params.company_num_format && !RegExp(currentCompanydbType.params.company_num_format.value).test(link.link_path)">Este campo debe tener el formato {{currentCompanydbType.params.company_num_format.text}}</span>
                                -->
                              </td>
                              <td v-if="userData.available_features['feature_prorate'] && currentCon.prorate">
                                <v-text-field
                                    dense
                                    :background-color="is_prorate_percent_correct(link.prorate_percent) ? 'white':'#ff9898'"
                                    v-model="link.prorate_percent"
                                    :disabled="!currentCon.companydb_type"
                                ></v-text-field>
                              </td>
                              <td>
                                <v-checkbox v-model="link.active" :disabled="!currentCompanydbType"></v-checkbox>
                              </td>
                              <td v-if="got_feature('feature_validate_link')">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <div>
                                      <v-icon :style="{ color: getValidationCircleColor(link) }"
                                        v-on="on" v-bind="attrs">
                                                  mdi-circle
                                      </v-icon>
                                    </div>
                                  </template>
                                  <span >{{getValidationTooltipText(link)}}</span>
                                </v-tooltip>
                              </td>
                              <td>
                                <v-btn icon @click="delete_link(link)" :disabled="isDeleteLinkDisabled">
                                  <v-icon v-once>
                                    mdi-delete-outline
                                  </v-icon>
                                </v-btn>
                              </td>
                            </template>
                          </tr>
                          </tbody>
                        </app-simple-table>
                      </template>
                    </app-expansion-panel>
                    





                    <app-expansion-panel class="my-5">
                      <template #title>
                        Impuestos y retenciones
                      </template>
                      
                      <template #tabs>
                        <v-tabs
                            v-if="currentCompanydbType.value && currentCon && currentCon.configuration && currentCon.configuration['tipos_iva']"
                            v-model="currentTab"
                        >
                          <v-tab v-for="tab in tabs" :key="tab.code" v-show="showTiposIvaTabs(tab.code) || showTiposIvaAndorraTab(tab.code) || showWithholdingTab(tab.code) || showOtherTab(tab.code)">
                            {{ tab.text }}
                          </v-tab>
                        </v-tabs>
                      </template>
                      <template>
                        <v-tabs-items
                            v-if="currentCompanydbType.value && currentCon && currentCon.configuration && currentCon.configuration['tipos_iva']"
                            v-model="currentTab"
                            class="ma-3"
                        >
                          <v-tab-item
                              :key="tab.tab"
                              v-for="tab in tabs"
                          >
                            <app-simple-table v-if="showTiposIvaTabs(tab.code) || showTiposIvaAndorraTab(tab.code)">
                              <template #column-headers>
                                <tr>
                                  <th>
                                    Tipo
                                  </th>
                                  <th>
                                    Cta. {{ table_headers[tabs[currentTab].code] }} Soportado
                                  </th>
                                  <th>
                                    Id {{ table_headers[tabs[currentTab].code] }} Sop.
                                  </th>
                                  <th>
                                    Cta. {{ table_headers[tabs[currentTab].code] }} Repercutido
                                  </th>
                                  <th>
                                    Id {{ table_headers[tabs[currentTab].code] }} Rep.
                                  </th>
                                </tr>
                              </template>
                              <tbody>
                              <tr v-for="tipo_iva in currentCon.configuration['tipos_iva']" :key="'row_'+tipo_iva.tipo">
                                <template v-if="show_vat(tipo_iva.iva)">
                                  <template
                                      v-if="tipo_iva.tipo && showTipoImpuestoLine(tipo_iva.tipo, tabs[currentTab].name) && vats[currentCompanydbType.value] && vats[currentCompanydbType.value].includes(tipo_iva.tipo)">
                                    <td>
                                      {{ get_text_iva(tipo_iva.iva) }}
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id || tipo_iva.iva=='vat_0_0'" dense
                                                      hide-details kind="account" :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.supplier_account"
                                                      @input="setIvasThirdID(tipo_iva, 'supplier_account', 'supplier_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id || tipo_iva.iva=='vat_0_0'" dense
                                                      hide-details kind="text" :startzeroable="true"
                                                      v-model="tipo_iva.supplier_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.customer_account"
                                                      @input="setIvasThirdID(tipo_iva, 'customer_account', 'customer_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true" v-model="tipo_iva.customer_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                  </template>
                                  <template
                                      v-if="tabs[currentTab].name=='intra' && intras[currentCompanydbType.value] && intras[currentCompanydbType.value].includes(tipo_iva.tipo)">
                                    <td>{{ get_text_iva(tipo_iva.iva) }}</td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.intra_supplier_account"
                                                      @input="setIvasThirdID(tipo_iva, 'intra_supplier_account', 'intra_supplier_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true"
                                                      v-model="tipo_iva.intra_supplier_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.intra_customer_account"
                                                      @input="setIvasThirdID(tipo_iva, 'intra_customer_account', 'intra_customer_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true"
                                                      v-model="tipo_iva.intra_customer_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                  </template>
                                  <template
                                      v-if="tabs[currentTab].name=='extra' && extras[currentCompanydbType.value] && extras[currentCompanydbType.value].includes(tipo_iva.tipo)">
                                    <td>
                                      {{ get_text_iva(tipo_iva.iva) }}
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.extra_supplier_account"
                                                      @input="setIvasThirdID(tipo_iva, 'extra_supplier_account', 'extra_supplier_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true"
                                                      v-model="tipo_iva.extra_supplier_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.extra_customer_account"
                                                      @input="setIvasThirdID(tipo_iva, 'extra_customer_account', 'extra_customer_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true"
                                                      v-model="tipo_iva.extra_customer_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                  </template>
                                  <template
                                      v-if="tabs[currentTab].name=='isps' && isps[currentCon.type] && isps[currentCon.type].includes(tipo_iva.tipo)">
                                    <td>
                                      {{ get_text_iva(tipo_iva.iva) }}
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.isp_supplier_account"
                                                      @input="setIvasThirdID(tipo_iva, 'isp_supplier_account', 'isp_supplier_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true" v-model="tipo_iva.isp_supplier_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="account"
                                                      :digits="currentCon.num_digits"
                                                      v-model="tipo_iva.isp_customer_account"
                                                      @input="setIvasThirdID(tipo_iva, 'isp_customer_account', 'isp_customer_id_contanet')"
                                                      :num_digits="getNumDigitsAccounts()"/>
                                    </td>
                                    <td>
                                      <doc-text-field :disabled="!currentCon.id" dense hide-details kind="text"
                                                      :startzeroable="true" v-model="tipo_iva.isp_customer_id_contanet"
                                                      :readonly="permanentTypeIvaId()"/>
                                    </td>
                                  </template>
                                </template>
                              </tr>
                              </tbody>
                            </app-simple-table>
                            <app-container fluid v-else-if="showWithholdingTab(tab.code)">
                              <app-row>
                                <app-col cols="3" contains-input-fields>
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_professional_account"
                                      label="Cuenta Retención Profesionales"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col cols="3" contains-input-fields>
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_rental_account"
                                      label="Cuenta Retención Alquileres"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col cols="3" contains-input-fields>
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_paycheck_account"
                                      label="Cuenta Retención Nóminas"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col cols="3" contains-input-fields>
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_customer_account"
                                      label="Cuenta Retención Cliente"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col
                                    cols="3" contains-input-fields has-input-fields-above
                                    v-if="currentCon.iva_agrario_pesca && feature_retention_accounts_agrario"
                                >
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_agriculture_account"
                                      label="Cuenta Retención Agricultura"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col
                                    cols="3" contains-input-fields has-input-fields-above
                                    v-if="currentCon.iva_agrario_pesca && feature_retention_accounts_agrario"
                                >
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_livestock_account"
                                      label="Cuenta Retención Ganadería"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col
                                    cols="3" contains-input-fields has-input-fields-above
                                    v-if="got_feature('feature_capital_retention')"
                                >
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_capital_account"
                                      label="Cuenta Retención Capital Mobiliario"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                                <app-col
                                    cols="3" contains-input-fields has-input-fields-above
                                    v-if="got_feature('feature_retention_accounts_transport')"
                                >
                                  <app-doc-text-field
                                      :disabled="!currentCon.id"
                                      kind="account"
                                      v-model="currentCon.configuration.retention_transport_account"
                                      label="Cuenta Retención Transporte"
                                      :num_digits="getNumDigitsAccounts()"
                                  ></app-doc-text-field>
                                </app-col>
                              </app-row>
                            </app-container>
                            <app-container fluid v-else-if="showOtherTab(tab.code)">
                              <app-row>
                                <template v-if="userData.available_features.feature_iva_agrario_pesca_tabaco">
                                  <app-col cols="4">
                                    <v-checkbox
                                        :disabled="!currentCon.id"
                                        label="IVA agrario y pesca"
                                        v-model="currentCon.iva_agrario_pesca"
                                    ></v-checkbox>
                                  </app-col>
                                  <app-col cols="4">
                                    <v-checkbox
                                        :disabled="!currentCon.id"
                                        label="IVA Tabaco"
                                        v-model="currentCon.iva_tabaco"
                                    ></v-checkbox>
                                  </app-col>
                                </template>
                                <app-col cols="4" v-if="feature_criterio_de_caja && !imInboxType">
                                  <v-checkbox
                                      :disabled="!currentCon.id"
                                      label="Criterio de Caja (para facturas de cliente)"
                                      v-model="currentCon.criterio_de_caja"
                                  ></v-checkbox>
                                </app-col>
                                <app-col cols="4" v-if="!imInboxType">
                                  <v-checkbox
                                      :disabled="is_disabled_iva_igic_no_deducible"
                                      label="IVA/IGIC no deducible"
                                      v-model="currentCon.iva_igic_no_deducible"
                                      @change="currentCon.comerciante_minorista = false"
                                  ></v-checkbox>
                                </app-col>
                                <app-col cols="4" v-if="!imInboxType && currentCon.tax_type=='igi'">
                                  <v-checkbox
                                      label="IGI no deducible facturas de cliente"
                                      v-model="currentCon.configuration.igi_no_deducible_customer"
                                  ></v-checkbox>
                                </app-col>
                                <app-col cols="4"
                                         v-if="!imInboxType && currentCompanydbType && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('comerciante_minorista'))))">
                                  <v-checkbox v-if="feature_comerciante_minorista && currentCon.iva_igic_no_deducible"
                                              :disabled="!currentCon.id"
                                              label="Registrar en libro de facturas"
                                              v-model="currentCon.comerciante_minorista"
                                  ></v-checkbox>
                                </app-col>
                                <app-col cols="4" v-if="got_feature('feature_apply_415') && ['iva_igic', 'igic'].indexOf(currentCon.tax_type) > -1">
                                  <v-checkbox
                                    :disabled="!currentCon.id"
                                    label="Aplica 415"
                                    v-model="currentCon.apply_415"
                                  ></v-checkbox>
                                </app-col>
                              </app-row>
                            </app-container>
                          </v-tab-item>
                        </v-tabs-items>
                      </template>
                    </app-expansion-panel>

                    <app-expansion-panel>
                      <template #title>
                        Otras configuraciones
                      </template>

                      <app-container fluid>
                        <app-row v-if="!imInboxType">
                          <app-col cols="3" v-if="got_feature('feature_cartera_checkbox')">
                            <v-checkbox
                              label="Id. Cartera automatico"
                              @change="onCheckboxClicked($event)"
                              v-model="check_cartera"
                            ></v-checkbox>
                          </app-col>
                          <app-col
                            contains-input-fields
                            cols="3"
                            v-if="
                                !got_feature('feature_cartera_checkbox')
                                && (
                                  (currentCon.configuration['hide_cartera'] == undefined)
                                  || (currentCon.configuration['hide_cartera'] == false)
                                )
                              "
                            >
                            <app-text-field
                              v-if=" (
                                  (currentCompanydbType.type=='account_move')
                                  || (
                                   currentCompanydbType.params
                                    && currentCompanydbType.params.show
                                    && currentCompanydbType.params.show.includes('cartera')
                                  )
                                )
                              "
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Id. Cartera proveedores"
                              v-model="currentCon.cartera_supplier"
                            ></app-text-field>
                          </app-col>
                          <app-col
                            contains-input-fields
                            cols="3"
                            v-if=" (
                                (currentCon.configuration['hide_cartera'] == undefined)
                                || (currentCon.configuration['hide_cartera'] == false)
                              )
                            "
                          >
                            <app-doc-text-field
                                v-if=" (
                                    currentCompanydbType.params
                                    && currentCompanydbType.params.show
                                    && currentCompanydbType.params.show.includes('cuenta_cartera')
                                  )
                                "
                                kind="account"
                                autocomplete="off"
                                :disabled="!currentCon.id || !currentCon.cartera_supplier"
                                label="Cuenta Cartera proveedores"
                                v-model="currentCon.cuenta_cartera_supplier"
                                :num_digits="getNumDigitsAccounts()"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields cols="3" v-if="feature_payment_move">
                            <app-autocomplete
                              autocomplete="off"
                              label="Pago Automático"
                              v-model="currentCon.automatic_payment_account"
                              :items="[
                                { value: 'y' , text:'Sí'},
                                { value: 'n' , text:'No'},
                              ]"
                              :readonly="false"
                              class="autocomplete-input"
                              :hide-details="true"
                            ></app-autocomplete>
                          </app-col>
                          <app-col contains-input-fields cols="3" v-if="feature_payment_move">
                            <app-doc-text-field
                              kind="account"
                              v-model="currentCon.payment_account"
                              label="Cuenta de Pagos"
                              :required="currentCon.automatic_payment_account == 'y'"
                              :hidden="currentCon.automatic_payment_account != 'y'"
                              :num_digits="getNumDigitsAccounts()"  />
                          </app-col>                          
                        </app-row>

                        <app-row v-if="!imInboxType">                          
                          <app-col
                            contains-input-fields
                            has-input-fields-above
                            cols="3"
                            v-if=" (
                                (currentCon.configuration['hide_cartera'] == undefined)
                                || (currentCon.configuration['hide_cartera'] == false)
                              )
                            "
                          >
                            <app-text-field
                              v-if=" (
                                  !got_feature('feature_cartera_checkbox')
                                  && (
                                    currentCompanydbType.type=='account_move'
                                    || (
                                      currentCompanydbType.params
                                      && currentCompanydbType.params.show
                                      && currentCompanydbType.params.show.includes('cartera')
                                    )
                                  )
                                )
                              " 
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Id. Cartera clientes"
                              v-model="currentCon.cartera_customer"
                            ></app-text-field>
                          </app-col>
                          <app-col
                            contains-input-fields
                            has-input-fields-above
                            cols="3"
                            v-if=" (
                                (currentCon.configuration['hide_cartera'] == undefined)
                                || (currentCon.configuration['hide_cartera'] == false)
                              )
                            "
                          >
                            <app-doc-text-field
                              v-if=" (
                                  currentCompanydbType.params
                                  && currentCompanydbType.params.show
                                  && currentCompanydbType.params.show.includes('cuenta_cartera')
                                )
                              "
                              kind="account"
                              autocomplete="off"
                              :disabled="!currentCon.id || !currentCon.cartera_customer"
                              label="Cuenta Cartera clientes"
                              v-model="currentCon.cuenta_cartera_customer"
                              :num_digits="getNumDigitsAccounts()"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields cols="3" 
                            v-if="feature_payment_move">
                            <app-autocomplete
                              autocomplete="off"
                              label="Cobro Automático"
                              v-model="currentCon.automatic_charge_account"
                              :items="[
                                { value: 'y' , text:'Sí'},
                                { value: 'n' , text:'No'},
                              ]"
                              :readonly="false"
                              class="autocomplete-input"
                              :hide-details="true"
                            ></app-autocomplete>
                          </app-col>

                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="feature_payment_move">
                            <app-doc-text-field
                              kind="account"
                              v-model="currentCon.charge_account"
                              label="Cuenta de Cobro"
                              :required="currentCon.automatic_charge_account == 'y'"
                              :hidden="currentCon.automatic_charge_account != 'y'"
                              :num_digits="getNumDigitsAccounts()"/>
                          </app-col>                                  
                        </app-row>

                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3" 
                            v-if="userData.available_features.feature_can_auto_fill_due_date">
                            <v-checkbox
                              label="Autorrellenar fecha de vencimiento"
                              v-model="currentCon.auto_fill_due_date"
                            ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCompanydbType && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('prefix_invoice'))))">
                            <v-checkbox                              
                              :disabled="!currentCon.id"
                              label="Forzar mayúsculas en el asiento"
                              v-model="currentCon.to_upper"
                            ></v-checkbox>
                          </app-col>
                        </app-row>

                        <app-row v-if="!imInboxType && currentCon.configuration">                          
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <v-checkbox
                              :disabled="!currentCon.id"
                              label="Habilitar búsqueda de terceros aproximada"
                              v-model="currentCon.search_third_aprox"
                            ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_assert_right_company')">
                            <v-checkbox
                              :disabled="!currentCon.id"
                              label="Valida que el cif de la empresa conste en factura"
                              v-model="currentCon.check_cif_in_docs"
                            ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_assert_right_company')">
                            <v-checkbox
                              :disabled="!currentCon.id"
                              label="Ignorar duplicados"
                              v-model="currentCon.configuration['ignore_duplicated']"
                            ></v-checkbox>
                          </app-col>                        
                        </app-row>


                        <!-- Checkbox copilot -->
                        <app-row class="mb-5" 
                          v-if="(got_feature('feature_copilot') || got_feature('feature_flujo_aprovacion') || got_feature('feature_auto_create_supplier_customer')) && !imInboxType">
                          <app-col has-input-fields-above cols="12" lg="6" v-if="got_feature('feature_copilot') || got_feature('feature_auto_create_supplier_customer')">
                            <app-creation-object-section-card>
                              <template #title>
                                <span class="mx-4">COPILOT</span>
                              </template>
                              <v-container v-if="got_feature('feature_copilot')">
                                <app-row>
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Crear tercero automáticamente"
                                    v-model="currentCon.configuration['auto_create_third']"
                                    ></v-checkbox>
                                  </app-col>
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Contabilizar sin revisión"
                                    v-model="currentCon.configuration['auto_account']"
                                    ></v-checkbox>
                                  </app-col>
                                </app-row>
                              </v-container>
                              <v-container v-else-if="currentCon.configuration && got_feature('feature_auto_create_supplier_customer')">
                                <app-row>
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Crear proveedores automáticamente"
                                    v-model="currentCon.configuration['auto_create_supplier']"
                                    ></v-checkbox>
                                  </app-col>
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Crear clientes automáticamente"
                                    v-model="currentCon.configuration['auto_create_customer']"
                                    ></v-checkbox>
                                  </app-col>
                                </app-row>
                                <app-row v-if="currentCon.configuration.auto_create_customer || currentCon.configuration.auto_create_supplier">
                                  <app-col cols="3" class="pt-0">
                                    <doc-text-field  v-if="currentCon.configuration['auto_create_supplier']"
                                      kind='account'
                                      :num_digits="getNumDigitsAccounts()"
                                      v-model="currentCon.configuration.auto_create_supplier_account"
                                      label="Cuenta gastos"
                                      :disabled="!currentCon.id"
                                      :required="true"
                                    ></doc-text-field>
                                  </app-col>
                                  <app-col cols="3" class="pt-0">
                                    <doc-text-field  v-if="currentCon.configuration['auto_create_supplier'] && !(currentCompanydbType.params && currentCompanydbType.params.hasOwnProperty('accounts_length'))"
                                      v-model="currentCon.configuration.auto_create_supplier_account_family"
                                      label="Tipo cuenta proveedor"
                                      :disabled="!currentCon.id"
                                      :required="true"
                                    ></doc-text-field>
                                  </app-col>
                                  <app-col cols="3" class="pt-0">
                                    <doc-text-field  v-if="currentCon.configuration['auto_create_customer']"
                                      kind='account'
                                      :num_digits="getNumDigitsAccounts()"
                                      v-model="currentCon.configuration.auto_create_customer_account"
                                      label="Cuenta ingresos"
                                      :disabled="!currentCon.id"
                                      :required="true"
                                    ></doc-text-field>
                                  </app-col>
                                  <app-col cols="3" class="pt-0">
                                    <doc-text-field  v-if="currentCon.configuration['auto_create_customer'] && !(currentCompanydbType.params && currentCompanydbType.params.hasOwnProperty('accounts_length'))"
                                      v-model="currentCon.configuration.auto_create_customer_account_family"
                                      label="Tipo cuenta cliente"
                                      :disabled="!currentCon.id"
                                      :required="true"
                                    ></doc-text-field>
                                  </app-col>
                                </app-row>
                                <app-row v-if="got_feature('feature_skip_pending_review')">
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Contabilizar sin revisión"
                                    v-model="currentCon.configuration['auto_account']"
                                    ></v-checkbox>
                                  </app-col>
                                </app-row>
                              </v-container>
                            </app-creation-object-section-card>
                          </app-col>
                          <app-col has-input-fields-above cols="12" lg="6" v-if="got_feature('feature_flujo_aprovacion') && currentCon.configuration && !imInboxType">
                            <app-creation-object-section-card>
                              <template #title>
                                <span class="mx-4">FLUJO DE APROBACIÓN</span>
                              </template>
                              <v-container>
                                <app-row>
                                  <app-col cols="6" class="pt-0">
                                    <v-checkbox
                                    label="Activar flujo"
                                    v-model="currentCon.configuration['flujo_aprovacion']"
                                    ></v-checkbox>
                                  </app-col>
                                </app-row>
                              </v-container>
                            </app-creation-object-section-card>
                          </app-col>
                        </app-row >
                        <!-- FIN Checkbox COPILOT y FLUJO DE APROBACION -->

                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="feature_price_range">
                            <app-doc-text-field
                              kind="number"
                              label="Total factura mínimo esperado"
                              v-model="currentCon.min_price"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="feature_price_range">
                            <app-doc-text-field
                              kind="number"
                              label="Total factura máximo esperado"
                              v-model="currentCon.max_price"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-select v-if="feature_description_order"
                              v-model="currentCon.invoice_description_order" 
                              :disabled="!currentCon.id"
                              :items="invoiceDescriptionOrderItems"
                              label="Orden de Descripción de Factura"
                            ></app-select>
                          </app-col>
                        </app-row>

                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-select
                              v-model="currentCon.cut_inv_num" 
                              :disabled="!currentCon.id"
                              :items="cut_inv_num_items"
                              label="Recortar número de factura de proveedor"
                            ></app-select>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCon.cut_inv_num && currentCon.cut_inv_num != 'no_cut'">
                            <app-text-field                              
                              label="Número de caracteres a mantener"
                              :disabled="!currentCon.id || currentCon.cut_inv_num == 'no_cut'" 
                              autocomplete="off"
                              v-model="currentCon.num_chars_inv_num"
                              :background-color="Boolean(errors['num_chars_inv_num'])?'#ff9898':'#ffffff'"
                            />
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-select 
                              v-if="currentCon.cut_inv_num && currentCon.cut_inv_num != 'no_cut'"
                              autocomplete="off" 
                              label="Caracteres a excluir al recortar" 
                              v-model="currentCon.chars_to_exclude" 
                              :items="[{'name':'Guión','value':'-'},
                                {'name':'Punto','value':'.'},
                                {'name':'Coma','value':','},
                                {'name':'Dos puntos','value':':'},
                                {'name':'Punto y coma','value':';'},
                                {'name': 'Barra', 'value': '/'},
                                {'name': 'Contrabarra', 'value': '\\'},
                                {'name': 'Almohadilla', 'value': '#'},
                                {'name':'Letras','value':'letters'},
                                {'name':'Espacio en blanco','value':'whitespace'}]"
                              item-text="name" 
                              item-value="value" 
                              multiple
                              clearable
                              :disabled="!currentCon.id || currentCon.cut_inv_num == 'no_cut'" 
                            ></app-select>
                          </app-col>                          
                        </app-row>

                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-select 
                              v-model="currentCon.cut_cus_inv_num" 
                              :disabled="!currentCon.id"
                              :items="cut_cus_inv_num_items"
                              label="Recortar número de factura de cliente"
                            ></app-select>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-text-field
                              v-if="currentCon.cut_cus_inv_num && currentCon.cut_cus_inv_num != 'no_cut'"
                              label="Número de caracteres a mantener"
                              :disabled="!currentCon.id || currentCon.cut_cus_inv_num == 'no_cut'" 
                              autocomplete="off"
                              v-model="currentCon.num_chars_cus_inv_num"
                              :background-color="Boolean(errors['num_chars_cus_inv_num'])?'#ff9898':'#ffffff'"
                            />
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-select 
                              v-if="currentCon.cut_cus_inv_num && currentCon.cut_cus_inv_num != 'no_cut'"
                              autocomplete="off" 
                              label="Caracteres a excluir al recortar" 
                              v-model="currentCon.chars_to_exclude_cus" 
                              :items="[{'name':'Guión','value':'-'},
                                {'name':'Punto','value':'.'},
                                {'name':'Coma','value':','},
                                {'name':'Dos puntos','value':':'},
                                {'name':'Punto y coma','value':';'},
                                {'name': 'Barra', 'value': '/'},
                                {'name': 'Contrabarra', 'value': '\\'},
                                {'name': 'Almohadilla', 'value': '#'},
                                {'name':'Letras','value':'letters'},
                                {'name':'Espacio en blanco','value':'whitespace'}]"
                              item-text="name" 
                              item-value="value" 
                              multiple
                              clearable
                            ></app-select>
                          </app-col>
                        </app-row>
                        <app-row>
                          <app-col cols="3" v-if="showActivityField('actividad') && got_feature('feature_actividad_selector') && activities.length > 0">
                            <app-select 
                              v-model="currentCon.configuration.actividad"
                              :items="activities"
                              item-value="code"
                              item-text="name"
                              label="Actividad por defecto"
                              :clearable="true"
                            ></app-select>
                          </app-col>
                          <app-col cols="3" v-else-if="showActivityField('actividad')">
                            <app-text-field
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Actividad por defecto"
                              type="number"
                              v-model="currentCon.configuration.actividad"
                              ></app-text-field>
                          </app-col>

                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCon && currentCon.configuration && currentCompanydbType.type == 'invoice' && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('suplido_account')))) && !imInboxType">
                            <app-text-field
                              :disabled="!currentCon.id"
                              label="Cuenta Suplidos"
                              v-model="currentCon.configuration.suplido_account"
                            ></app-text-field>
                          </app-col>
                          <template v-if="isCompanyDBTypePercentTable()">                 
                            <app-col contains-input-fields has-input-fields-above cols="3">
                              <app-doc-text-field
                                :disabled="!currentCon.id"
                                kind="account"
                                v-model="currentCon.configuration.suplido_account"
                                label="Cuenta Suplidos"
                                :num_digits="getNumDigitsAccounts()"
                              ></app-doc-text-field>
                            </app-col>
                            <app-col contains-input-fields has-input-fields-above cols="3" 
                              v-if="got_feature('feature_join_lines')">
                              <v-checkbox
                                :disabled="!currentCon.id"
                                label="Cuando el tercero no tenga cuenta de suplidos usar la contrapartida"
                                v-model="currentCon.configuration.use_contrapartida_as_suplido_account"
                              ></v-checkbox>
                            </app-col>                   
                          </template>
                        </app-row>


                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCompanydbType && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('prefix_invoice'))))">
                            <app-text-field
                              v-if="currentCompanydbType.type!='invoice'"
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para el asiento del proveedor"
                              v-model="currentCon.tagline_in_invoice"
                            ></app-text-field>
                            <app-text-field
                              v-else
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para las facturas de proveedor"
                              v-model="currentCon.tagline_in_invoice"
                            ></app-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCompanydbType && (currentCompanydbType.params && ((!currentCompanydbType.params.hasOwnProperty('hide')) || (currentCompanydbType.params.hide && !currentCompanydbType.params.hide.includes('prefix_invoice'))))">
                            <app-text-field
                              v-if="currentCompanydbType.type!='invoice'"
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para el asiento del cliente"
                              v-model="currentCon.tagline_out_invoice"
                            ></app-text-field>
                            <app-text-field
                              v-else
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para las facturas de cliente"
                              v-model="currentCon.tagline_out_invoice"
                            ></app-text-field>
                          </app-col>

                        </app-row>
                        <app-row v-if="!imInboxType && currentCompanydbType.type!='invoice'">
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-text-field                             
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para el asiento de pago"
                              v-model="currentCon.tagline_payment_move"
                            ></app-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-text-field                              
                              autocomplete="off"
                              :disabled="!currentCon.id"
                              label="Prefijo para el asiento de cobro" 
                              v-model="currentCon.tagline_charge_move"
                            ></app-text-field>
                          </app-col>
                        </app-row>


                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_document_number_str') || got_feature('feature_fill_num_doc_pending_sync')">
                            <v-checkbox
                              label="Informar Núm. Documento"
                              v-model="currentCon.configuration['document_doc_number']"
                              @change="onCheckboxDocNumberClicked()"
                              ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_document_number_str') && got_feature('feature_document_number_with_filename')">
                            <v-checkbox
                              label="Informar Núm. Documento con Nombre Fichero"
                              v-model="currentCon.configuration['document_number_with_filename']"
                              :disabled="!currentCon.configuration['document_doc_number']"
                              ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="showNextNumDocFields()">
                              <app-doc-text-field
                                autocomplete="off"
                                kind="number"
                                label="Próximo número documento facturas recibidas"
                                v-model="currentCon.configuration['next_num_doc_in_invoice']"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                          v-if="showNextNumDocFields()">
                            <app-doc-text-field
                              autocomplete="off"
                              kind="number"
                              label="Próximo número documento facturas emitidas"
                              v-model="currentCon.configuration['next_num_doc_out_invoice']"
                            ></app-doc-text-field>
                          </app-col>
                        </app-row>
                        <app-row v-if="!imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_serie_in_docs')">
                            <v-checkbox
                              :disabled="!currentCon.id"
                              label="¿Tiene serie?"
                              v-model="currentCon.have_serie"
                            ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="got_feature('feature_serie_in_docs')">
                            <app-combobox
                              v-if="currentCon.have_serie"
                              label="Series"
                              :items="[]"
                              multiple
                              chips
                              v-model="currentCon.series"
                            ></app-combobox>
                          </app-col>
                        </app-row>

                        <app-row v-if="currentCompanydbType && currentCompanydbType.value == 'alfastar' && !imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-text-field
                              autocomplete="off"
                              label="Serie Alfastar Facturas Recibidas"
                              v-model="currentCon.alfastar_serie_in"
                              maxlength="4"
                            ></app-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-text-field
                              autocomplete="off"
                              label="Serie Alfastar Facturas Emitidas"
                              v-model="currentCon.alfastar_serie_out"
                              maxlength="4"
                            ></app-text-field>
                          </app-col>
                        </app-row>
                        <app-row v-if="(got_feature('feature_automatic_mode') || got_feature('feature_report_sii')) && !imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCompanydbType && got_feature('feature_report_sii')">
                            <v-checkbox
                                :disabled="!currentCon.id"
                                label="Informar SII"
                                v-model="currentCon.report_sii"
                            ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCon.configuration && currentCompanydbType && got_feature('feature_automatic_mode')">
                            <v-checkbox
                              label="Contabilizar facturas y terceros en automático"
                              v-model="currentCon.configuration['automatic_mode_documents']"
                              ></v-checkbox>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="currentCon.configuration && currentCompanydbType && got_feature('feature_automatic_mode') && got_feature('feature_can_user_bank_account')">
                            <v-checkbox
                              label="Contabilizar movimientos bancarios en automático"
                              v-model="currentCon.configuration['automatic_mode_transactions']"
                              ></v-checkbox>
                          </app-col>
                        </app-row>

                        <app-row v-if="!imInboxType && got_feature('feature_company_sii')">
                          <app-col cols="3">
                            <v-checkbox
                              label="Empresa sujeta al SII"
                              v-model="currentCon.configuration['company_sii']"
                              ></v-checkbox>
                          </app-col>
                        </app-row>
                                  
                        <app-row v-if="currentCon && currentCon.configuration && currentCompanydbType.type == 'invoice' && (currentCompanydbType.params && currentCompanydbType.params.hasOwnProperty('show') && currentCompanydbType.params.show.includes('default_accounts')) && !imInboxType">
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-doc-text-field
                              kind="account"
                              :disabled="!currentCon.id"
                              label="Cuenta Gastos (si no se detecta proveedor)"
                              v-model="currentCon.configuration.default_expenses_account"
                              :num_digits="getNumDigitsAccounts()"
                            ></app-doc-text-field>
                          </app-col>
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <app-doc-text-field
                              kind="account"
                              :disabled="!currentCon.id"
                              label="Cuenta Ingresos (si no se detecta cliente)"
                              v-model="currentCon.configuration.default_incomes_account"
                              :num_digits="getNumDigitsAccounts()"
                            ></app-doc-text-field>
                          </app-col>
                        </app-row> 
                        <app-row>                                                                            
               
                          <app-col contains-input-fields has-input-fields-above cols="3"
                            v-if="userData.available_features.feature_iva_agrario_pesca_tabaco && !imInboxType">
                            <v-checkbox 
                              v-if="userData.available_features.feature_check_ret && currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('check_ret')"
                              :disabled="!currentCon.id"
                              label="Check bases para Retención"
                              v-model="currentCon.check_ret"
                            ></v-checkbox>
                          </app-col>                                                                                      
                          <app-col cols="3" v-if="!imInboxType && got_feature('feature_required_project')">
                              <v-checkbox
                                label="Impedir contabilizar facturas sin proyecto"
                                v-model="currentCon.required_project"
                              ></v-checkbox>
                          </app-col>
                          
                          <app-col contains-input-fields has-input-fields-above cols="3">
                            <!-- <v-btn v-if="currentCon && currentCon.id" color="secondary" @click="update" :disabled="disabled_save()" :loading="creating">Guardar</v-btn>
                            <v-btn v-else id="create-connector-btn" color="secondary" @click="create" :disabled="disabled_save()" :loading="creating">Crear</v-btn> -->
                            <v-card-text v-if="companydb">{{companydb.last_operation_state}}</v-card-text>
                          </app-col>                          
                        </app-row>


                        <app-row v-if="userData.available_features.feature_can_import_suppliers_customers_with_excel && !imInboxType">
                          <app-col cols="12" >
                            <app-row>
                              <app-col 
                                cols="6"
                                class="pl-0"
                                :class="{dragging_file:dragging_file}"  
                                @drop="dropFiles"
                                @dragover.stop.prevent="dragging_file=true" @dragleave.stop.prevent="dragging_file=false"
                              >
                                <v-file-input 
                                  label="Haga click para seleccionar el excel que desea importar"
                                  v-model="files"
                                  outlined
                                  prepend-icon=""
                                  class="file-input--outlined rounded-lg"
                                >
                                  <template #prepend-inner>
                                    <v-icon color="primary" left>
                                      mdi-paperclip
                                    </v-icon>
                                  </template>
                                </v-file-input>
                              </app-col>
                              <app-col cols="4">                        
                                <JobProgress v-model="jobState" v-on:done="jobDone" :job_id="asyncJobId">
                                  <template v-slot:progress>
                                    <app-row>
                                      <app-col cols="12">
                                        <v-progress-circular
                                          v-if="jobState==='running'"
                                          indeterminate
                                          class="mr-2"              
                                          color="primary"
                                        ></v-progress-circular>
                                      </app-col>
                                    </app-row>
                                  </template>
                                  <!-- <template v-slot:done>

                                  </template> -->
                                  <template v-slot:quiet>
                                    <app-row>
                                      <app-col cols="12" class="pa-0">
                                        <app-row>
                                          <app-col cols="6">
                                            <v-btn color="primary" @click="importFile(files)" :disabled="!currentCon.id || !files">Importar Terceros</v-btn>
                                          </app-col>
                                          <app-col cols="6">
                                            <v-btn v-if="are_errors" color="#FFED00" @click="import_errors_dialog = true" class="black--text">Ver Errores</v-btn>
                                          </app-col>
                                        </app-row>
                                      </app-col>
                                      <!-- {{importErrors}} -->
                                    </app-row>
                                  </template>
                                  <template v-slot:error>
                                    <app-row>
                                      <app-col cols="12">
                                        <v-btn color="secondary" @click="importFile(files)">Importar Terceros</v-btn>
                                      </app-col>
                                    </app-row>
                                  </template>
                                </JobProgress>

                              </app-col>
                            </app-row>
                          </app-col>
                        </app-row>

                        <div v-if="isCompanyDBTypePercentTable()">                 
                          <app-row v-if="userData && userData.can_view_e_invoice && hasEInvoiceContract">
                            <app-col contains-input-fields has-input-fields-above cols="3">
                              <app-doc-text-field
                                  :disabled="!currentCon.id"
                                  kind="number"
                                  v-model="currentCon.configuration.zip_code"
                                  label="Código Postal"
                                  :num_digits="5"
                                ></app-doc-text-field>
                            </app-col>
                          </app-row>
                          
                        </div>
                        
                        <app-row v-if="(got_feature('feature_warning_abono')) && !imInboxType">                          
                          <app-col cols="2" v-if="currentCon && got_feature('feature_warning_abono') && currentCon.abono_keywords !== undefined">
                            <app-row style="margin-top:-3vh">
                              <b>Indicadores factura rectificativa</b>
                            </app-row>
                            <app-row style="margin-top:-1vh">
                            <DetailReferenceSimple :ref_list="currentCon.abono_keywords" @update="updateKeywords"></DetailReferenceSimple> 
                            </app-row>
                          </app-col>
                          <app-col cols="2" v-if="currentCon && got_feature('feature_warning_abono') && got_feature('feature_auto_correct_abono') && currentCon.abono_keywords !== undefined">
                            <v-checkbox
                              :disabled="!currentCon.id"
                              label="Cambio de signo automático en facturas rectificativas positivas"
                              v-model="currentCon.configuration['auto_rectifica']"
                            ></v-checkbox>
                          </app-col>
                        </app-row>                                                  
                        
                                                
                        <taxes-values-table 
                          v-if="currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('taxes_table')"
                          :taxes="currentCon.taxes"
                          @update-taxes="updateTaxes"
                        ></taxes-values-table>

                        <NumberSeriesValuesTable
                          v-if="currentCompanydbType.params && currentCompanydbType.params.show && currentCompanydbType.params.show.includes('number_series_table')"
                          :number_series="currentCon.taxes"
                          @update-number-series="updateNumberSeries"
                        />

                        <app-row v-if="imInboxType && currentCon.id">
                          <app-col cols="12">
                            <data-table-with-api
                              ref="companyReferencesTable"
                              :headers="companyReferencesHeaders"
                              :url="'query'"
                              :api_params="{query:'company.reference.table',args:{company_id:this.currentCon.id}}"
                              :showSelect="false"
                              :search-filters="[]"
                              :action-btn-list="companyRefsActionBtnList"
                              @click-col-action-btn="clickCompanyRefsTableActionBtn"
                              @selected-items-changed="selectedItemsCompanyRefsChanged"
                            >
                              <!-- Botones derecha de buscador -->
                              <template slot="search_right" >
                                <div align="right">
                                  <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="refreshCompanyRefsList" color="primary" icon v-bind="attrs" v-on="on" :loading="companyRefsLoading">
                                                <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="openCompanyRefsDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Nueva Referencia</span>
                                    </v-tooltip>
                                </div>
                              </template>
                            </data-table-with-api>
                          </app-col>
                        </app-row>
                        <app-row v-if="got_feature('feature_change_companydb_type')" >
                          <app-col cols="3" v-if="canViewChangeCDBType">
                            <v-btn color="primary" @click="changeCDBType" :disabled="!currentCon.id">
                              Cambiar a {{ this.allowed_cdbtype_changes[currentCon.companydb_type.value].btn }}
                            </v-btn>
                          </app-col>
                        </app-row>

                        <app-row v-if="got_feature('feature_can_hide_masters')">
                            <app-col cols="3" class="pt-0" v-if="showActivitiesMaster()">
                              <v-checkbox
                                label="No mostrar maestro Actividades"
                                v-model="currentCon.hide_activities_master"
                              ></v-checkbox>
                            </app-col>
                            <app-col cols="3" class="pt-0" v-if="showProjectsMaster()">
                              <v-checkbox
                                label="No mostrar maestro Proyectos"
                                v-model="currentCon.hide_projects_master"
                              ></v-checkbox>
                            </app-col>
                            <app-col cols="3" class="pt-0" v-if="showChannelsMaster()">
                              <v-checkbox
                                label="No mostrar maestro Canales"
                                v-model="currentCon.hide_channels_master"
                              ></v-checkbox>
                            </app-col>
                        </app-row>
                        <app-row >
                          <app-col contains-input-fields cols="3" v-if="got_feature('feature_company_external_password') && currentCon.companydb_type">
                              <app-doc-text-field
                                  :type="showExtPassword ? 'text' : 'password'"
                                  v-model="currentCon.external_password"
                                  :label="label_password"
                                  :append-icon="showExtPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="showExtPassword = !showExtPassword"
                                ></app-doc-text-field>
                            </app-col>
                        </app-row>
                        <app-row>
                          <app-col contains-input-fields cols="3" v-if="currentCon.configuration && got_feature('feature_other_documents')">
                              <app-select v-model="currentCon.configuration['after_done_wf']" label="Workflow post-contabilización" item-value="id" item-text="name"
                              :items="workflowOptions" outlined
                              name="selectorWorkflow"
                            ></app-select>
                          </app-col>
                        </app-row>

                      </app-container>
                    </app-expansion-panel>


                    
                  </v-expansion-panels>
                </app-col>
              </app-row>
                                                                                                                                 

                          
               <!-- <app-row v-if="userData.available_features.feature_config_third_selector">
                 <app-col cols="4">
                   <v-select 
                     autocomplete="off" 
                     label="Valores del selector de terceros" 
                     v-model="currentCon.third_selector_values" 
                     :items="[
                       { 'name': 'CIF', 'value': 'cif' },
                       { 'name': 'Nombre', 'value': 'name' },
                       { 'name': 'Cuenta', 'value': 'account'},
                     ]"
                     item-text="name" 
                     item-value="value" 
                     multiple
                     chips
                     small-chips
                     :background-color="Boolean(errors['third_selector_values'])?'#ff9898':'#ffffff'"
                   ></v-select>
                 </app-col>
               </app-row> -->
               
               
               
               <!-- TODO: He ocultado estos campos con un if false para que no aparezcan mientras estan en desuso -->
               <app-row v-if="false">
                 <app-col cols="8">
                   <v-text-field
                     :disabled="!currentCon.id"
                     label="Ruta de carga facturas de proveedores"
                     v-model="currentCon.path_supplier_folder"
                   ></v-text-field>
                 </app-col>
                 <app-col cols="8">
                   <v-text-field
                     :disabled="!currentCon.id"
                     label="Ruta de carga facturas de clientes"
                     v-model="currentCon.path_customer_folder"
                   ></v-text-field>
                 </app-col>
               </app-row>
                                                            
           </app-container>

         </v-tab-item>
         <v-tab-item 
           key="Usuarios" 
           value="Usuarios" 
           v-if="!got_feature('feature_no_readonly_users') && permission.general.can_admin"
         >
             <app-row>
               <app-col cols="12">
                 <data-table-with-api
                   ref="usersTable"
                   :headers="usersHeaders"
                   :url="'usercompanydbrel_invited?companydb_id='+this.currentCon.id"
                   :footer-items-per-page-text="userItemsPerPageText"
                   :search-filters="userSearchFilters"
                   :showSelect="true"
                   :action-btn-list="userActionBtnList"
                   @click-col-action-btn="clickUserTableActionBtn"
                   @selected-items-changed="selectedItemsUserChanged"
                 >
                   <!-- Botones derecha de buscador -->
                   <template slot="search_right" >
                     <div align="right">
                         <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="refreshUsersList" color="primary" icon v-bind="attrs" v-on="on" :loading="usersLoading">
                                     <v-icon>mdi-refresh</v-icon>
                                 </v-btn>
                             </template>
                             <span>Actualizar</span>
                         </v-tooltip>
                         <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="openCreateUserDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                     <v-icon>mdi-plus</v-icon>
                                 </v-btn>
                             </template>
                             <span>Nuevo usuario</span>
                         </v-tooltip>
                         <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="openAddUserDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                     <!-- <v-icon>mdi-link-variant</v-icon> -->
                                     <v-icon>mdi-eye-plus-outline</v-icon>
                                 </v-btn>
                             </template>
                             <span>Añadir permiso</span>
                         </v-tooltip>
                         <JobProgress v-model="deleteUserJobState" :job_id="deleteUsersAsyncJob" v-on:done="deleteUsersDone" divStyle="display: inline;">
                           <template v-slot:progress>
                               <v-progress-circular
                                   indeterminate
                                   class="mr-2"
                                   color="primary"
                               ></v-progress-circular>
                           </template>
                           <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                               <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                       <v-btn
                                         :key="'btn_delete_user'+slotName"
                                         @click.stop="openDeleteUserDialog()"
                                         :disabled="usersSelected.length==0 && !usersAllSelected"
                                         color="primary"
                                         v-bind="attrs"
                                         v-on="on"
                                         icon >
                                         <v-icon>mdi-eye-off-outline</v-icon>
                                       </v-btn>
                                   </template>
                                   <span>Quitar permiso</span>
                               </v-tooltip>
                           </template>
                         </JobProgress>
                         <ShowHideColumnsDialog v-if="got_feature('feature_settings_read_only')" :read_only="true" title="Selector de columnas visibles para los usuarios de esta empresa" />
                     </div>
                   </template>
                 </data-table-with-api>
               </app-col>
             </app-row>
         </v-tab-item>

         <v-tab-item
           key="Actividad"
           value="Actividad"
           v-if="showActivitiesMasterCanHide()"
         >
             <app-row>
               <app-col cols="12">
                 <data-table-with-api
                   ref="activitiesTable"
                   :headers="activityHeaders"
                   :url="'activities?companydb_id='+this.currentCon.id"
                   :footer-items-per-page-text="activityItemsPerPageText"
                   :search-filters="activitySearchFilters"
                   :showSelect="true"
                   :action-btn-list="activityActionBtnList"
                   :show-btn-list="!got_feature('feature_not_create_thirds_and_masters') && !readonly_activities"
                   @click-col-action-btn="clickActivityTableActionBtn"
                   @selected-items-changed="selectedItemsActivityChanged"
                 >
                   <!-- Botones derecha de buscador -->
                   <template slot="search_right" >
                     <div align="right">
                       <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="refreshActivitiesList" color="primary" icon v-bind="attrs" v-on="on" :loading="activitiesLoading">
                                     <v-icon>mdi-refresh</v-icon>
                                 </v-btn>
                             </template>
                             <span>Actualizar</span>
                         </v-tooltip>
                         <v-tooltip top v-if="!got_feature('feature_not_create_thirds_and_masters') && !readonly_activities">
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="openActivitytDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                     <v-icon>mdi-plus</v-icon>
                                 </v-btn>
                             </template>
                             <span>Nueva Actividad</span>
                         </v-tooltip>
                         <JobProgress v-model="deleteActJobState" :job_id="deleteActivitiesAsyncJob" v-on:done="deleteActivitiesDone" divStyle="display: inline;">
                           <template v-slot:progress>
                               <v-progress-circular
                                   indeterminate
                                   class="mr-2"
                                   color="primary"
                               ></v-progress-circular>
                           </template>
                           <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                               <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                       <v-btn
                                         :key="'btn_delete_act'+slotName"
                                         @click.stop="openDeleteActivityDialog()"
                                         :disabled="activitiesSelected.length==0 && !activitiesAllSelected"
                                         color="primary"
                                         v-bind="attrs"
                                         v-on="on"
                                         icon >
                                         <v-icon>mdi-delete</v-icon>
                                       </v-btn>
                                   </template>
                                   <span>Eliminar Actividad</span>
                               </v-tooltip>
                           </template>
                         </JobProgress>
                     </div>
                   </template>
                 </data-table-with-api>
               </app-col>
             </app-row>
         </v-tab-item>

         <v-tab-item
           key="Proyectos"
           value="Proyectos"
           v-if="showProjectsMasterCanHide() && !imInboxType"
         >  
             <app-row>
               <app-col cols="12">
                 <data-table-with-api
                   ref="projectsTable"
                   :headers="projectHeaders"
                   :url="'projects?companydb_id='+this.currentCon.id"
                   :footer-items-per-page-text="projectItemsPerPageText"
                   :search-filters="projectSearchFilters"
                   :showSelect="true"
                   :show-btn-list="!got_feature('feature_not_create_thirds_and_masters')"
                   :action-btn-list="projectActionBtnList"
                   @click-col-action-btn="clickProjectTableActionBtn"
                   @selected-items-changed="selectedItemsProjectChanged"
                 >
                   <!-- Botones derecha de buscador -->
                   <template slot="search_right" >
                     <div align="right">
                       <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="refreshProjectsList" color="primary" icon v-bind="attrs" v-on="on" :loading="projectsLoading">
                                     <v-icon>mdi-refresh</v-icon>
                                 </v-btn>
                             </template>
                             <span>Actualizar</span>
                         </v-tooltip>
                         <v-tooltip top v-if="!got_feature('feature_not_create_thirds_and_masters')">
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="openProjectDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                     <v-icon>mdi-plus</v-icon>
                                 </v-btn>
                             </template>
                             <span>Nuevo Proyecto</span>
                         </v-tooltip>
                         <JobProgress v-model="deleteProjJobState" :job_id="deleteProjectsAsyncJob" v-on:done="deleteProjectsDone" divStyle="display: inline;">
                           <template v-slot:progress>
                               <v-progress-circular
                                   indeterminate
                                   class="mr-2"
                                   color="primary"
                               ></v-progress-circular>
                           </template>
                           <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                               <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                       <v-btn
                                         :key="'btn_delete_act'+slotName"
                                         @click.stop="openDeleteProjectDialog()"
                                         :disabled="projectsSelected.length==0 && !projectsAllSelected"
                                         color="primary"
                                         v-bind="attrs"
                                         v-on="on"
                                         icon >
                                         <v-icon>mdi-delete</v-icon>
                                       </v-btn>
                                   </template>
                                   <span>Eliminar Proyecto</span>
                               </v-tooltip>
                           </template>
                         </JobProgress>
                     </div>
                   </template>
                 </data-table-with-api>
               </app-col>
           </app-row>
         </v-tab-item>

         <v-tab-item
           key="Canales"
           value="Canales"
           v-if="showChannelsMasterCanHide()"
         >  
             <app-row>
               <app-col cols="12">
                 <data-table-with-api
                   ref="channelsTable"
                   :headers="channelHeaders"
                   :url="'channels?companydb_id='+this.currentCon.id"
                   :footer-items-per-page-text="channelItemsPerPageText"
                   :search-filters="channelSearchFilters"
                   :showSelect="true"
                   :show-btn-list="!got_feature('feature_not_create_thirds_and_masters')"
                   :action-btn-list="channelActionBtnList"
                   @click-col-action-btn="clickChannelTableActionBtn"
                   @selected-items-changed="selectedItemsChannelChanged"
                   item-key="channel_id"
                 >
                   <!-- Botones derecha de buscador -->
                   <template slot="search_right" >
                     <div align="right">
                       <v-tooltip top>
                         <template v-slot:activator="{ on, attrs }">
                           <v-btn @click="refreshChannelsList" color="primary" icon v-bind="attrs" v-on="on" :loading="channelsLoading">
                             <v-icon>mdi-refresh</v-icon>
                           </v-btn>
                         </template>
                         <span>Actualizar</span>
                       </v-tooltip>
                       <v-tooltip top v-if="!got_feature('feature_not_create_thirds_and_masters')">
                         <template v-slot:activator="{ on, attrs }">
                           <v-btn @click="openChannelDialog()" color="primary" icon v-bind="attrs" v-on="on">
                             <v-icon>mdi-plus</v-icon>
                           </v-btn>
                         </template>
                         <span>Nuevo Canal</span>
                       </v-tooltip>
                       <JobProgress v-model="deleteChannelJobState" :job_id="deleteChannelsAsyncJob" v-on:done="deleteChannelsDone" divStyle="display: inline;">
                         <template v-slot:progress>
                           <v-progress-circular
                             indeterminate
                             class="mr-2"
                             color="primary"
                           ></v-progress-circular>
                         </template>
                         <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                           <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                               <v-btn
                                 :key="'btn_delete_act'+slotName"
                                 @click.stop="openDeleteChannelDialog()"
                                 :disabled="channelsSelected.length==0 && !channelsAllSelected"
                                 color="primary"
                                 v-bind="attrs"
                                 v-on="on"
                                 icon
                               >
                                 <v-icon>mdi-delete</v-icon>
                               </v-btn>
                             </template>
                             <span>Eliminar Canal</span>
                           </v-tooltip>
                         </template>
                       </JobProgress>
                     </div>
                   </template>
                 </data-table-with-api>
               </app-col>
             </app-row>
         </v-tab-item>
          <v-tab-item
            key="Puntos de Carga"
            value="Puntos de Carga"
            v-if="currentCon && currentCon.id && got_feature('feature_load_paths')"
          >
            <app-row>
              <app-col cols="12">
                <data-table-with-api
                  ref="loadPathsTable"
                  :headers="loadPathHeaders"
                  :url="'load_paths?companydb_id='+this.currentCon.id"
                  :footer-items-per-page-text="loadPathsItemsPerPageText"
                  :search-filters="loadPathSearchFilters"
                  :showSelect="true"
                  :action-btn-list="loadPathActionBtnList"
                  @click-col-action-btn="clickLoadPathTableActionBtn"
                  @selected-items-changed="selectedItemsLoadPathChanged"
                >
                  <!-- Botones derecha de buscador -->
                  <template slot="search_right" >
                    <div align="right">
                      <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="refreshLoadPathsList" color="primary" icon v-bind="attrs" v-on="on" :loading="loadPathsLoading">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Actualizar</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="openNewLoadPathDialog()" color="primary" icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Nuevo Punto de Carga</span>
                        </v-tooltip>
                        <JobProgress v-model="deleteLoadPathJobState" :job_id="deleteLoadPathsAsyncJob" v-on:done="deleteLoadPathsDone" divStyle="display: inline;">
                          <template v-slot:progress>
                              <v-progress-circular
                                  indeterminate
                                  class="mr-2"
                                  color="primary"
                              ></v-progress-circular>
                          </template>
                          <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                              <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        :key="'btn_delete_act'+slotName"
                                        @click.stop="openDeleteLoadPathDialog()"
                                        :disabled="loadPathsSelected.length==0 && !loadPathsAllSelected"
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        icon >
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                  </template>
                                  <span>Eliminar Punto de Carga</span>
                              </v-tooltip>
                          </template>
                        </JobProgress>
                    </div>
                  </template>
                  <!--Columns customized-->
                  <template slot="load_path_type_name" slot-scope="item">{{ item.load_path_type['name'] }}</template>
                  <template slot="path_name" slot-scope="item" v-if="item.path">{{ item.path['display_path'] }}</template>
                  <template slot="created" slot-scope="item">{{ formatDate(item.created) }}</template>
                </data-table-with-api>
              </app-col>
            </app-row>
             
            <!-- <app-row>
              <app-col cols="12">
                <v-expansion-panels v-model="panelLoadPath">
                  <app-expansion-panel>
                    <template #title>
                      Configuración
                    </template>
      
                    <app-container fluid>
                      <app-row>
                        <app-col contains-input-fields has-input-fields-above cols="6">
                          <v-checkbox
                            label="Descarga automática diaria de facturas pendientes (6:00h-7:00h peninsular aprox.)"
                            v-model="currentCon.configuration['automatic_daily_load_path_upload']"
                            ></v-checkbox>
                        </app-col>
                      </app-row>
                    </app-container>
                  </app-expansion-panel>
                </v-expansion-panels>
              </app-col>
            </app-row> -->
          </v-tab-item>

         <v-tab-item
           key="Suscripcion"
           value="Suscripcion"
           v-if="currentCon && currentCon.id && feature_config_webhook"
         >
         <app-container fluid>
           <app-row v-if="webhook.loading">
             <app-col cols="12">
               <v-progress-circular
                 indeterminate
                 color="primary">
               </v-progress-circular>
             </app-col>
           </app-row>
           <template v-else>
             <app-row>
               <app-col cols="12">
                 <v-text-field 
                   v-model="webhook_url"
                   hint="https://"
                   label="URL"
                   :error-messages="webhook.errors.url"
                 ></v-text-field>
               </app-col>
             </app-row>
             <app-row>
               <app-col cols="12">
                 <v-textarea
                   v-model="webhook_headers"
                   label="Headers"
                   textarea
                   hint='{"Content-Type": "application/json", "Authorization": "Bearer xxxxxxx"}'
                   rows="3"
                   :error-messages="webhook.errors.headers"
                 ></v-textarea>
               </app-col>
             </app-row>
             <app-row>
               <app-col>
                 <v-data-table
                   :headers="listRequest.headers"
                   :items="listRequest.results"
                   :items-per-page="listRequest.limit"
                   :server-items-length="listRequest.count"
                   :loading="listRequest.loading"
                   class="elevation-1"
                   @update:items-per-page="getItemPerPageWebhookRequest"
                   @update:page="setPageWebhookRequest"
                 >
                 </v-data-table> 
               </app-col>
             </app-row>
           </template>
         </app-container>
         </v-tab-item>

         <v-tab-item
           key="Maestro de cuentas"
           value="Maestro de cuentas"
           v-if="currentCon && currentCon.id && got_feature('feature_accounts_master')"
         >
             <app-row>
               <app-col cols="12">
                 <data-table-with-api
                   ref="accountsTable"
                   :headers="accountsHeaders"
                   :url="'accounts?companydb='+this.currentCon.id"
                   :footer-items-per-page-text="accountItemsPerPageText"
                   :search-filters="accountSearchFilters"
                   :showSelect="true"
                   :action-btn-list="accountActionBtnList"
                   @click-col-action-btn="clickAccountTableActionBtn"
                   @selected-items-changed="selectedItemsAccountChanged"
                 >
                   <!-- Botones derecha de buscador -->
                   <template slot="search_right" >
                     <div align="right">
                         <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="refreshAccountsList" color="primary" icon v-bind="attrs" v-on="on" :loading="accountsLoading">
                                     <v-icon>mdi-refresh</v-icon>
                                 </v-btn>
                             </template>
                             <span>Actualizar</span>
                         </v-tooltip>
                         <v-tooltip top>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn @click="openAccountDialog" color="primary" icon v-bind="attrs" v-on="on">
                                     <v-icon>mdi-plus</v-icon>
                                 </v-btn>
                             </template>
                             <span>Nueva cuenta</span>
                         </v-tooltip>
                         <JobProgress v-model="deleteAccJobState" :job_id="deleteAccountsAsyncJob" v-on:done="deleteAccountsDone" divStyle="display: inline;">
                           <template v-slot:progress>
                               <v-progress-circular
                                   indeterminate
                                   class="mr-2"
                                   color="primary"
                               ></v-progress-circular>
                           </template>
                           <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                               <v-tooltip top>
                                   <template v-slot:activator="{ on, attrs }">
                                       <v-btn
                                       :key="'btn_delete_acc'+slotName"
                                       @click.stop="openDeleteAccountsDialog()"
                                       :disabled="accountsSelected.length==0 && !accountsAllSelected"
                                       color="primary" icon v-bind="attrs" v-on="on"
                                       >
                                           <v-icon>mdi-delete</v-icon>
                                       </v-btn>
                                   </template>
                                   <span>Eliminar</span>
                               </v-tooltip>
                           </template>
                         </JobProgress>
                     </div>
                   </template>
                 </data-table-with-api>
               </app-col>
             </app-row>
           
         </v-tab-item>
         <v-tab-item
              v-if="userData && userData.can_view_e_invoice && hasEInvoiceContract && !got_feature('feature_hide_e_invoices')"
              key="Emisor de Facturas"
              value="Emisor de Facturas"
         >
              <div class="pa-6">
                  <PartyEditor
                    title="Datos del emisor de factura"
                    :party="company_as_party"
                    :readonly="false"
                    :emisor="true"
                    :no_border="true"
                    :companyEditor="true"
                    @companyEditorClose="party => companyAsPartyEditorClose(party)">
                  </PartyEditor>
              </div>
              <div class="pa-6" v-if="currentCon.configuration">
                <v-checkbox
                  v-model="currentCon.configuration['auto_send_to_accounting']"
                  label="Enviar facturas emitidas automáticamente al módulo de contabilidad"
                  class="mt-0 mb-0"      
                ></v-checkbox>
                <v-checkbox
                  v-model="currentCon.configuration['auto_send_mail_to_client']"
                  label="Envío automático por email al cliente"
                  class="mt-0 mb-0"
                ></v-checkbox>
              </div>
         </v-tab-item>
         <v-tab-item
             key="GastoIngreso"
             value="GastoIngreso"
             v-if="got_feature('feature_expense_income_type')"
         >
           <app-row>
             <app-col cols="12">
               <data-table-with-api
                   ref="expensIncomeTypeTable"
                   :headers="expensIncomeTypeHeaders"
                   :url="'expens_income_types?companydb_id='+this.currentCon.id"
                   :footer-items-per-page-text="expensIncomeTypeItemsPerPageText"
                   :search-filters="expensIncomeTypeSearchFilters"
                   :showSelect="true"
                   item-key="eit_id"
                   @selected-items-changed="selectedItemsExpensIncomeTypeChanged"
               >
<!--                  :action-btn-list="expensIncomeTypeActionBtnList"-->
<!--                  @click-col-action-btn="clickChannelTableActionBtn"-->
                 <!-- Botones derecha de buscador -->
                 <template slot="search_right" >
                   <div align="right">
                     <v-tooltip top>
                       <template v-slot:activator="{ on, attrs }">
                         <v-btn @click="refreshExpensIncomeTypeList" color="primary" icon v-bind="attrs" v-on="on" :loading="expensIncomeTypeLoading">
                           <v-icon>mdi-refresh</v-icon>
                         </v-btn>
                       </template>
                       <span>Actualizar</span>
                     </v-tooltip>
                     <JobProgress
                         v-model="deleteExpensIncomeTypeJobState"
                         :job_id="deleteExpensIncomeTypeAsyncJob"
                         v-on:done="deleteExpensIncomeTypeDone"
                         divStyle="display: inline;"
                     >
                       <template v-slot:progress>
                         <v-progress-circular
                             indeterminate
                             class="mr-2"
                             color="primary"
                         ></v-progress-circular>
                       </template>
                       <template :slot="slotName" v-for="slotName in ['done', 'error']" >
                         <v-tooltip top>
                           <template v-slot:activator="{ on, attrs }">
                             <v-btn
                                 :key="'btn_delete_act'+slotName"
                                 @click.stop="openDeleteExpensIncomeTypeDialog()"
                                 :disabled="expensIncomeTypeSelected.length==0 && !expensIncomeTypeAllSelected"
                                 color="primary"
                                 v-bind="attrs"
                                 v-on="on"
                                 icon >
                               <v-icon>mdi-delete</v-icon>
                             </v-btn>
                           </template>
                           <span>Eliminar Gasto/Ingreso</span>
                         </v-tooltip>
                       </template>
                     </JobProgress>
                   </div>
                 </template>
               </data-table-with-api>
             </app-col>
           </app-row>
         </v-tab-item>
       </v-tabs-items>

     </template>
   </app-page-card>

   <v-snackbar
       v-model="snackbar.isVisible"
       :color="snackbar.color"
   >
       <b>{{ snackbar.text }}</b>
   </v-snackbar>
   </div>
 </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { client } from "@/api/client";
import MessagePopup from '../components/MessagePopup.vue';
import connector from "../store/modules/connector";
import {isValidDate} from '../utils'
import {TAXES_LABELS} from '../store/constants'
import DocTextField from '../components/DocTextField.vue'
import DateWidget from '../components/DateWidget.vue'
import ListObject from '../components/ListObject.vue'
import JobProgress from '../components/JobProgress.vue'
import CsvFieldsValues from '../components/CsvFieldsValues.vue'
import { jobs } from '../api/jobs.js';
import moment from "moment";
import { validateAccount } from "../utils/account_validation"
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import DraggableShowHideDialog from '../components/DraggableShowHideDialog.vue';
import ExcelDraggableShowHideDialog from '../components/ExcelDraggableShowHideDialog.vue';
import CopySettings from '../components/CopySettings.vue';
import ShowHideColumnsDialog from '../components/ShowHideColumnsDialog.vue';
import DatePicker from '../components/DatePicker.vue';
import TaxesValuesTable from '../components/TaxesValuesTable.vue';
import NumberSeriesValuesTable from '../components/NumberSerieValuesTable.vue';
import SignContract from '../components/SignContract.vue';
import LegalContract from '../components/WelcomeSteps/LegalContract.vue';
import { user as api_user } from "@/api/user";
import DataTableWithApi from '../components/DataTableWithApi.vue'
import AppSimpleTableWithApi2 from '@/components/layout/AppSimpleTableWithApi2.vue';
import DetailReferenceSimple from '../components/DetailReferenceSimple.vue'
import AppPageCard from '@/components/layout/AppPageCard.vue';
import { ACCOUNTING_DATE_OPTIONS } from '../store/constants.js';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppAutocompleteWithApi from '../components/layout/AppAutocompleteWithApi.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AccountField from '@/components/layout/AccountField.vue';
import AppAutocomplete from '@/components/layout/AppAutocomplete.vue';
import AppDatePicker from '@/components/layout/AppDatePicker.vue';
import AppCombobox from '@/components/layout/AppCombobox.vue';
import AppDocTextField from '@/components/layout/AppDocTextField.vue';
import AppSimpleTable from '@/components/layout/AppSimpleTable.vue'
import AppExpansionPanel from '@/components/layout/AppExpansionPanel.vue'
import AppCreationObjectSectionCard from '@/components/layout/AppCreationObjectSectionCard.vue';
import { AddCompanyReference } from "@/modules/companies/application/AddCompanyReference";
import { UpdateCompanyReference } from "@/modules/companies/application/UpdateCompanyReference";
import { DeleteCompanyReferences } from "@/modules/companies/application/DeleteCompanyReferences";
import { sync_command_dispatcher, async_command_dispatcher, query_dispatcher } from "@/api/client";
import PartyEditor from "../components/PartyEditor.vue"
import {ChangeCompanyDBTypeCommand} from "@/modules/company/application/changeCompanyDBType";
import OauthPrompt from "@/components/OauthPrompt.vue";
import ExcludedFilesTable from "@/components/ExcludedFilesTable.vue";
import {ForceDownloadLoadPathFilesCommand} from "@/modules/load_path/app/ForceDownloadLoadPathFiles.ts"
import { WorkflowTemplatesQuery } from "@/modules/document/application/WorkflowTemplatesQuery";
import { Party} from "@/modules/facturae/domain/Invoiceable";

export default {
 name: 'ConnectorDetailV2',

 components: {
   MessagePopup,
   DocTextField,
   DateWidget,
   ListObject,
   JobProgress,
   DraggableShowHideDialog,
   CsvFieldsValues,
   CopySettings,
   ShowHideColumnsDialog,
   DatePicker,
   TaxesValuesTable,
   NumberSeriesValuesTable,
   SignContract,
   LegalContract,
   DataTableWithApi,
   DetailReferenceSimple,
   AppPageCard,
   AppModalPrompt,
   AppTextField,
   AppAutocompleteWithApi,
   AppModalCol,
   AppModalContainer,
   AppModalRow,
   AppSelect,
   AppConfirmModal,
   AccountField,
   AppAutocomplete,
   AppDatePicker,
   AppCombobox,
   AppSimpleTable,
   AppDocTextField,
   AppExpansionPanel,
   AppContainer,
   AppCol,
   AppRow,
   AppCreationObjectSectionCard,
   ExcelDraggableShowHideDialog,
   PartyEditor,
   AppSimpleTableWithApi2,
   OauthPrompt,
   ExcludedFilesTable
 },
 props: {
   id: {
     type: [String, Number]
   },
   con_type: {
     type: String,
   },
 },
 data() {
   let igis_basic_format = [
     'igi_0','igi_ex_0','igi_1', 'igi_2_5', 'igi_4_5', 'igi_9_5', 
   ];
   let vats_igics_basic_format = [
     'vat_21', 'vat_12', 'vat_10_5', 'vat_10', 'vat_75', 'vat_5', 'vat_4', 'vat_2', 'vat_0', 'vat_ns_0', 'vat_ne_0',
     'vat_re_5', 'vat_re_625', 'vat_re_4', 'vat_re_2', 'vat_re_1_75', 'vat_re_1', 'vat_re_026', 'igic_7', 'igic_5', 'igic_3',
     'igic_0', 'igic_ns_0', 'igic_ne_0', 'igic_95', 'igic_15', 'igic_20',
   ];
   let vats_igics_igis_basic_format = vats_igics_basic_format.concat(igis_basic_format);
   let vats_igics_vat_plus_re_format = [
     'vat_21', 'vat_12', 'vat_10_5', 'vat_10', 'vat_75', 'vat_5', 'vat_4', 'vat_2',, 'vat_0', 'vat_ns_0', 'vat_ne_0', 'vat_0_0',
     'vat_4_5', 'vat_5_625', 'vat_11_4', 'vat_26_2', 'vat_75_1', 'vat_2_026', 'igic_7', 'igic_5', 'igic_3', 'igic_0', 'igic_ns_0',
     'igic_ne_0', 'igic_95', 'igic_15', 'igic_20',
   ];
   let vats_igics_vat_plus_re_cm_format = [
      'vat_21', 'vat_12', 'vat_10_5', 'vat_10', 'vat_75', 'vat_5', 'vat_4', 'vat_2',, 'vat_0', 'vat_ns_0', 'vat_ne_0', 'vat_0_0',
      'vat_4_5', 'vat_5_625', 'vat_11_4', 'vat_26_2', 'vat_75_1', 'vat_2_026', 'igic_7', 'igic_5', 'igic_3', 'igic_0', 'igic_ns_0',
      'igic_ne_0', 'igic_95', 'igic_15', 'igic_20','igic_cm_3', 'igic_cm_5', 'igic_cm_7', 'igic_cm_95',
      'igic_cm_15', 'igic_cm_20'
    ];
   let vats_igics_csv_api_format = [
     'vat_21', 'vat_12', 'vat_10_5', 'vat_10', 'vat_75', 'vat_5', 'vat_4', 'vat_2',, 'vat_0', 'vat_ns_0', 'vat_ne_0',
     'vat_4_5', 'vat_5_625', 'vat_11_4', 'vat_26_2', 'vat_75_1', 'vat_2_026', 'igic_7', 'igic_5', 'igic_3', 'igic_0', 'igic_ns_0',
     'igic_ne_0', 'igic_95', 'igic_15', 'igic_20',
   ];
   let intra_extra_isp_basic_format = [
     'vat_21', 'vat_12', 'vat_10_5', 'vat_10', 'vat_75', 'vat_5', 'vat_4', 'vat_2',, 'vat_0', 'vat_ns_0', 'vat_ne_0',
     'igic_7', 'igic_5', 'igic_3', 'igic_0', 'igic_ns_0', 'igic_ne_0', 'igic_95', 'igic_15', 'igic_20',
   ];
   let intra_extra_isp_format_without_agrary = [
     'vat_21', 'vat_10', 'vat_5', 'vat_75', 'vat_4', 'vat_2',, 'vat_0', 'vat_ns_0', 'vat_ne_0',
     'igic_7', 'igic_5', 'igic_3', 'igic_0', 'igic_ns_0', 'igic_ne_0', 'igic_95', 'igic_15',
   ];

   let allowed_cdbtype_changes = {
     "diezsoftware_nube": {
       btn: "DiezSoftware Fichero",
       dest: "diezsoftware_file",
     },
     "diezsoftware_nube_au": {
       btn: "DiezSoftware Fichero AUT.",
       dest: "diezsoftware_file_au",
     },
     "diezsoftware_file": {
       btn: "DiezSoftware Nube",
       dest: "diezsoftware_nube",
     },
     "diezsoftware_file_au": {
       btn: "DiezSoftware Nube AUT.",
       dest: "diezsoftware_nube_au",
     },
     "goldennet_autonomos": {
       btn: "GoldenSoft Autonomos (Tipo Gasto/Ingreso)",
       dest: "goldennet_autonomosn",
     },
   }
   return {
     been_in_einvoice_tab: false,
     company_as_party: new Party(0, '','', ''),
    //  company_as_party:{
    //   "cif": "",
    //   "city": "",
    //   "name": "",
    //   "type": "juridica",
    //   "address": "",
    //   "province": "",
    //   "post_code": "",
    //   "trade_name": "",
    //   "business_name": "",
    //   "first_surname": "",
    //   "second_surname": "", 
    //   "bank_account_number": "",
    //   "bic":""},
      
     show:false,
     modal_add_user: {
       list_users_select: [],
       user: '',
       role_kind: '',
     },
     copying:false,
     // show_message: false,
     panel: 0,
     objectType: "Connector",
     url: "companydbs/",
     path:'',
     creating: false,
     company: undefined,
     companydb: undefined,
     nst_path:undefined,
     nstpaths:[],
     currentCon: {},
     loading:false,
     vats:{
         'contanet': vats_igics_vat_plus_re_cm_format,
         'aplifisa': vats_igics_basic_format,
         'contasol': vats_igics_igis_basic_format,
         'contasol_nube': vats_igics_igis_basic_format,
         'csv_asientos': vats_igics_csv_api_format,
         'api_asientos': vats_igics_csv_api_format,
         'monitor': vats_igics_basic_format,
         'sage': vats_igics_vat_plus_re_format,
         'sage_addon': vats_igics_vat_plus_re_format,
         'sage_despachos': vats_igics_vat_plus_re_format,
         'goldennet': vats_igics_basic_format,
         'contaplus': vats_igics_basic_format,
         'alfastar': vats_igics_basic_format,
         'gesfincas': vats_igics_basic_format,
         'ncs': vats_igics_basic_format,
         'geyce': vats_igics_basic_format,
         'diamacon': vats_igics_basic_format,
         'csv_facturas': igis_basic_format,
     },
     intras:{
         'contanet': intra_extra_isp_basic_format,
         'aplifisa': intra_extra_isp_basic_format,
         'contasol': intra_extra_isp_basic_format,
         'contasol_nube': intra_extra_isp_basic_format,
         'csv_asientos': intra_extra_isp_basic_format,
         'api_asientos': intra_extra_isp_basic_format,
         'monitor': intra_extra_isp_basic_format,
         'sage': intra_extra_isp_basic_format,
         'sage_addon': intra_extra_isp_basic_format,
         'sage_despachos': intra_extra_isp_basic_format,
         'goldennet': intra_extra_isp_basic_format,
         'contaplus': intra_extra_isp_basic_format,
         'alfastar': intra_extra_isp_basic_format,
         'gesfincas': intra_extra_isp_basic_format,
         'ncs': intra_extra_isp_basic_format,
         'geyce': intra_extra_isp_basic_format,
         'diamacon': intra_extra_isp_basic_format,
     },
     extras:{
         'contanet': intra_extra_isp_basic_format,
         'aplifisa': intra_extra_isp_basic_format,
         'contasol': intra_extra_isp_basic_format,
         'contasol_nube': intra_extra_isp_basic_format,
         'monitor': intra_extra_isp_basic_format,
         'sage': intra_extra_isp_basic_format,
         'sage_addon': intra_extra_isp_basic_format,
         'sage_despachos': intra_extra_isp_basic_format,
         'csv_asientos': intra_extra_isp_format_without_agrary,
         'api_asientos': intra_extra_isp_format_without_agrary,
         'goldennet': intra_extra_isp_format_without_agrary,
         'contaplus': intra_extra_isp_format_without_agrary,
         'alfastar': intra_extra_isp_format_without_agrary,
         'gesfincas': intra_extra_isp_format_without_agrary,
         'ncs': intra_extra_isp_format_without_agrary,
         'geyce': intra_extra_isp_format_without_agrary,
         'diamacon': intra_extra_isp_format_without_agrary,
     },
     isps:{
         'contanet': intra_extra_isp_basic_format,
         'aplifisa': intra_extra_isp_basic_format,
         'contasol': intra_extra_isp_basic_format,
         'contasol_nube': intra_extra_isp_basic_format,
         'monitor': intra_extra_isp_basic_format,
         'csv_asientos': intra_extra_isp_format_without_agrary,
         'sage': intra_extra_isp_basic_format,
         'sage_addon': intra_extra_isp_basic_format,
         'sage_despachos': intra_extra_isp_basic_format,
         'goldennet': intra_extra_isp_basic_format,
         'contaplus': intra_extra_isp_basic_format,
         'alfastar': intra_extra_isp_basic_format,
         'gesfincas': intra_extra_isp_basic_format,
         'ncs': intra_extra_isp_basic_format,
         'geyce': intra_extra_isp_basic_format,
         'diamacon': intra_extra_isp_basic_format,
     },
     tabs:[
         {
             code:'iva',
             name:'vat',
             text:'IVA',
             vats:[
                 {'vat':'vat_21','label':'21%'},
                 {'vat':'vat_12','label':'12%'},
                 {'vat':'vat_10_5','label':'10.5%'},
                 {'vat':'vat_10','label':'10%'},
                 {'vat':'vat_75','label':'7.5%'},
                 {'vat':'vat_5','label':'5%'},
                 {'vat':'vat_4','label':'4%'},
                 {'vat':'vat_2','label':'2%'},
                 {'vat':'vat_ne_0','label':'0%'},
                 {'vat':'vat_ns_0','label':'0% NS'},
                 {'vat':'vat_0','label':'0% Ex.'},
                 {'vat':'vat_0_0','label':'0%+0%RE'},
                 {'vat':'vat_4_5','label':'4%+0.5%RE'},
                 {'vat':'vat_5_625','label':'5%+0.62%RE'},
                 {'vat':'vat_11_4','label':'10%+1.4%RE'},
                 {'vat':'vat_26_2','label':'21%+5.2%RE'},
                 {'vat':'vat_75_1','label':'7.5%+1%RE'},
                 {'vat':'vat_2_026','label':'2%+0.26%RE'},
                 {'vat':'vat_re_5','label':'0.5%RE'},
                 {'vat':'vat_re_625','label':'0.62%RE'},
                 {'vat':'vat_re_4','label':'1.4%RE'},
                 {'vat':'vat_re_2','label':'5.2%RE'},
                 {'vat':'vat_re_1_75','label':'1.75%RE'},
                 {'vat':'vat_re_1','label':'1%RE'},
                 {'vat':'vat_re_026','label':'0.26%RE'},
             ],
         },
         {
             code:'igic',
             name:'igic',
             text:'IGIC',
             vats:[
                 {'vat':'igic_7','label':'7%'},
                 {'vat':'igic_5', 'label': '5%'},
                 {'vat':'igic_3','label':'3%'},
                 {'vat':'igic_ne_0','label':'0%'},
                 {'vat':'igic_ns_0','label':'0% NS'},
                 {'vat':'igic_0','label':'0% Ex.'},
                 {'vat':'igic_95','label':'9.5%'},
                 {'vat':'igic_15','label':'15%'},
                 {'vat':'igic_20','label':'20%'},
                 {'vat':'igic_cm_3','label':'3% CM'},
                 {'vat':'igic_cm_5','label':'5% CM'},
                 {'vat':'igic_cm_7','label':'7% CM'},
                 {'vat':'igic_cm_95','label':'9.5% CM'},
                 {'vat':'igic_cm_15','label':'15% CM'},
                 {'vat':'igic_cm_20','label':'20% CM'},
             ],
         },
         {
             code:'igi',
             name:'igi',
             text:'IGI',
             vats:[
                 {'vat':'igi_0','label':'0%'},
                 {'vat':'igi_ex_0','label':'0% Ex.'},
                 {'vat':'igi_1', 'label': '1%'},
                 {'vat':'igi_2_5','label':'2.5%'},
                 {'vat':'igi_4_5','label':'4.5%'},
                 {'vat':'igi_9_5','label':'9.5%'},
             ],
         },
         {
             code:'intra',
             name:'intra',
             text:'Intracomunitarias',
             vats:[
                 {'vat':'vat_21','label':'IVA 21%'},
                 {'vat':'vat_12','label':'IVA 12%'},
                 {'vat':'vat_10_5','label':'IVA 10.5%'},
                 {'vat':'vat_10','label':'IVA 10%'},
                 {'vat':'vat_75','label':'IVA 7.5%'},
                 {'vat':'vat_5','label':'IVA 5%'},
                 {'vat':'vat_4','label':'IVA 4%'},
                 {'vat':'vat_2','label':'IVA 2%'},
                 {'vat':'vat_0','label':'IVA 0%'},
                 {'vat':'igic_7','label':'IGIC 7%'},
                 { 'vat': 'igic_5', 'label': 'IGIC 5%' },
                 {'vat':'igic_3','label':'IGIC 3%'},
                 {'vat':'igic_0','label':'IGIC 0%'},
                 {'vat':'igic_95','label':'IGIC 9.5%'},
                 {'vat':'igic_15','label':'IGIC 15%'},
                 {'vat':'igic_20','label':'IGIC 20%'},
                 ],
         },
         {
             code:'extra',
             name:'extra',
             text:'Extracomunitarias',
             vats:[
                 {'vat':'vat_21','label':'IVA 21%'},
                 {'vat':'vat_12','label':'IVA 12%'},
                 {'vat':'vat_10_5','label':'IVA 10.5%'},
                 {'vat':'vat_10','label':'IVA 10%'},
                 {'vat':'vat_75','label':'IVA 7.5%'},
                 {'vat':'vat_5','label':'IVA 5%'},
                 {'vat':'vat_4','label':'IVA 4%'},
                 {'vat':'vat_2','label':'IVA 2%'},
                 {'vat':'vat_0','label':'IVA 0%'},
                 {'vat':'igic_7','label':'IGIC 7%'},
                 {'vat': 'igic_5', 'label': 'IGIC 5%'},
                 {'vat':'igic_3','label':'IGIC 3%'},
                 {'vat':'igic_0','label':'IGIC 0%'},
                 {'vat':'igic_95','label':'IGIC 9.5%'},
                 {'vat':'igic_15','label':'IGIC 15%'},
                 {'vat':'igic_20','label':'IGIC 20%'},
                 ],
         },
         {
             code:'isps',
             name:'isps',
             text:'ISP',
             vats:[
                 {'vat':'vat_21','label':'IVA 21%'},
                 {'vat':'vat_12','label':'IVA 12%'},
                 {'vat':'vat_10_5','label':'IVA 10.5%'},
                 {'vat':'vat_10','label':'IVA 10%'},
                 {'vat':'vat_75','label':'IVA 7.5%'},
                 {'vat':'vat_5','label':'IVA 5%'},
                 {'vat':'vat_4','label':'IVA 4%'},
                 {'vat':'vat_2','label':'IVA 2%'},
                 {'vat':'vat_0','label':'IVA 0%'},
                 {'vat':'igic_7','label':'IGIC 7%'},
                 {'vat': 'igic_5', 'label': 'IGIC 5%'},
                 {'vat':'igic_3','label':'IGIC 3%'},
                 {'vat':'igic_0','label':'IGIC 0%'},
                 {'vat':'igic_95','label':'IGIC 9.5%'},
                 {'vat':'igic_15','label':'IGIC 15%'},
                 {'vat':'igic_20','label':'IGIC 20%'},
             ],
         },
         {
          code: 'withholding',
          name: 'withholding',
          text: 'Retenciones',
        },
        {
          code: 'other',
          name: 'other',
          text: 'Otros parámetros',
        },
     ],
     clickedTab:undefined,
     clickedZone: undefined,
     clickedCSV: undefined,
     usersHeaders: [
       {
         text: '',
         align: 'start',
         value: 'checkboxes',
         sortable: false,
       },
       {
         text: 'Nombre de usuario',
         sortable: true,
         value: 'user_username'
       },
       {
         text: 'Email',
         value: 'user_email',
         sortable: true,
       },
       {
         text: 'Rol',
         value: 'friendship_kind',
         sortable: false
       },
       {
         text: 'Permiso',
         value: 'role',
         sortable: false
       },
       {
         text: 'Última actividad',
         value: 'user_last_login',
         sortable: true,
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ],

     newUserValues: {
       username: '',
       email: '',
       password: '',
       password_repeat: '',
       companyDB: '',
       friendship_kind: '',
       role_kind: '',
       view_invoices: true,
       view_banks: false,
       view_e_invoice: false,
     },

     newProject: {
       name: "",
       external_id: "",
       references: [],
     },
     newCompanyReference: {
       'company_id': null,
       'reference': '',
     },
     newChannel: {
       name: '',
       external_id: '',
       references: [],
     },
     newActivity: {
       name: "",
       code: ""
     },

     newLoadPath: {
       load_path_type: "",
       path: {path:"", display_path:""},
       doc_kind: "",
       split_doc: false,
       accounting_date: "",
       configurated: null,
       activity: "",
       project: null,
       channel: null,
       oauth_session: null,
      //  values: {},
       email_prefix:"",
       only_new_files: true,
       accept_pdf_only: false,
       allow_check_only_new_files: true,
     },
     newAccount: {
       account: "",
       description: "",
     },
     load_path_form_valid: false,
     createUserDialog: false,
     createUserLoading: false,
     addUserDialog: false,
     addUserLoading: false,
     amProjectDialog: false,
     amCompanyRefsDialog: false,
     amChannelDialog: false,
     amActivityDialog: false,
     amLoadPathDialog: false,
     amAccountDialog: false,
     deleteUserDialog: false,
     deleteProjectDialog: false,
     deleteChannelDialog: false,
     deleteActivityDialog: false,
     deleteLoadPathDialog: false,
     deleteAccountsDialog: false,
     deleteExpensIncomeTypeDialog: false,
     errorDialog: false,
     changePassUserDialog: false,
     changePassLoading: false,
     connectDialog: false,
     deleteUserMsg: "Se van a quitar los permisos a esta empresa de los usuarios seleccionados.",
     errorMsg: "Ha ocurrido un error al borrar elemento.",
     deleteProjectMsg: "Se van a borrar todos los proyectos seleccionados.",
     deleteRefsMsg: "Se van a borrar todos las referencias seleccionadas.",
     deleteChannelMsg: "Se van a borrar todos los canales seleccionados.",
     deleteActivityMsg: "Se van a borrar todas las actividades seleccionadas.",
     deleteLoadPathMsg: "Se van a borrar los puntos de carga seleccionados.",
     deleteAccountsMsg: "Se van a borrar todas las cuentas seleccionadas.",
     deleteExpensIncomeTypeMsg: "Se van a borrar todos los tipos de gasto/ingreso seleccionados.",

     showPassCreateUserDialog: false,
     showPassCreateUserDialog2: false,
     showPassChangePass: false,
     showPassChangePass2: false,
     newPassValues: {
         user_id: null,
         password: '',
         password_repeat: '',
     },

     errors: {},
     decimal_separator_choices:[{value:null,text:'Funcionamiento por defecto'},{value:',',text:'Coma'}, {value:'.',text:'Punto'}], 
     refreshProgressState: 'done',
     refreshProgressId: null,
     interval: null,

     refreshAccountsState: 'done',
     refreshAccountsId: null,
     refreshAccountsArgs: {},
     intervalAccounts: null,
     enabled_move_account: false,
     get_automatic_payment_account_types : [
       { value: 'y' , text:'Sí'},
       { value: 'n' , text:'No'},
       { value: 'm' , text:'Manual'},
     ],
     table_headers: {
       'iva': 'IVA',
       'igic': 'IGIC',
       'igi': 'IGI',
       'intra': 'IVA/IGIC',
       'extra': 'IVA/IGIC',
       'isps': 'IVA',
     },

     files: null,
     
     folderItems: [],
     openFolder:[{path:""}],
     activeFolder:[],
     loadingFolders:false,
     showReadOnly:true,

     import_errors_dialog: false,
     importErrors: {},
     dragging_file: false,
     friendship_kind_select: [
       {name: 'Cliente', value: 'customer'},
       {name: 'Cliente consulta', value: 'customer_consult'},
       {name: 'Empleado', value: 'employee'},
       {name: 'Administrador', value: 'admin'}
     ],
     
     projectToUpdate: null,
     companyRefToUpdate: null,
     channelToUpdate: null,
     activityToUpdate: null,
     amProjectLoading: false,
     amCompanyRefsLoading: false,
     amChannelLoading: false,
     amActivityLoading: false,
     amLoadPathLoading: false,
     amAccountLoading: false,
     loadPathToUpdate: null,
     accountToUpdate: null,
     csv_one_line_dialog: false,
     excel_columns_dialog: false,
     excel_dialog_loading:false,
     csv_one_line_field_values_dialog:false,
     info_dialog: false,
     message: '',
     show_config_dialog: false,
     copy_cdb_from: 0,
     openid_users: [],
     openid_user: null,
     openid_companies: [],
     openid_company:null,
     loading_oauth_cdbs: false,
     oauth_message: '',
     connect_outh2user_data: {},
     workflowOptions:[{'name':'Sin workflow', 'id':null}],
     connectStorageDialog: false,
     folderWarningMessage: '',
     storage_openid_users:[],
     ACCOUNTING_DATE_OPTIONS,
     loading_load_path_dialog:false,
     folderManagerDialog:false,
     pathConfirmationDialog:false,
     connector_tabs: [
       {
         'if':'true',
         'key':'Datos',
         'name':'Datos'
       },{
         'if':'this.currentCon && !this.got_feature("feature_no_readonly_users") && this.permission.general.can_admin && !this.imInboxType',
         'key':'Usuarios',
         'name':'Usuarios'
       },
       {
         'if':"this.showActivitiesMasterCanHide()",
         'key':'Actividad',
         'name':'Actividades'
       },
       {
         'if':"this.showProjectsMasterCanHide()",
         'key':'Proyectos',
         'name':'Proyectos'
       },
       {
         'if':"this.showChannelsMasterCanHide()",
         'key':'Canales',
         'name':'Canales'
       },
       {
         'if':"this.currentCon && this.currentCon.id && this.got_feature('feature_load_paths')",
         'key':'Puntos de Carga',
         'name':'Puntos de Carga'
       },
       {
         'if':"this.currentCon && this.currentCon.id && this.feature_config_webhook",
         'key':'Suscripcion',
         'name':'Suscripción'
       },
       {
         'if':"this.currentCon && this.currentCon.id && this.got_feature('feature_accounts_master')",
         'key':'Maestro de cuentas',
         'name':'Maestro de cuentas'
       },
       {
         'if':"this.got_feature('feature_expense_income_type')",
         'key':'GastoIngreso',
         'name':'Tipo de Gasto/Ingreso'
       },
       {
         'if':"this.currentCon && this.currentCon.id && this.hasEInvoiceContract && this.userData && this.userData.can_view_e_invoice",
         'key':'Emisor de Facturas',
         'name':'Emisor de Facturas'
       },
     ],
     contract_dialog:false,
     accountsHeaders: [
       {
         text: '',
         value: 'checkboxes',
         sortable: false,
         align: 'start',
       },
       {
         text: 'Número de cuenta',
         value: 'account',
         sortable: true,
       },
       {
         text: 'Descripción',
         value: 'description',
         sortable: true,
       },
       {
         text: '',
         value: 'actions',
         sortable: false,
         align: 'end',
       },
     ],
     accountItemsPerPageText: 'Cuentas por página:',
     accountSearchFilters: ['text__icontains'],
     accountsLoading: false,
     deleteAccountsAsyncJob: null,
     deleteAccJobState: 'done',
     accountsSelected: [],
     accountsAllSelected: false,
     accountSearchFiltersInfo: {},
     accountActionBtnList: [{'name': 'Editar Cuenta', 'action': 'update_account', 'icon': 'mdi-pencil-outline'}],
     
     channelItemsPerPageText: 'Canales por página:',
     channelSearchFilters: ['text__icontains'],
     channelsLoading: false,

     deleteChannelsAsyncJob: null,
     deleteChannelJobState: 'done',
     channelsSelected: [],
     channelsAllSelected: false,
     channelSearchFiltersInfo: {},
     channelActionBtnList: [{'name': 'Editar Canal', 'action': 'update_channel', 'icon': 'mdi-pencil-outline'}],

     activityItemsPerPageText: 'Actividades por página:',
     activitySearchFilters: ['text__icontains'],
     activitiesLoading: false,
     deleteActivitiesAsyncJob: null,
     deleteActJobState: 'done',
     activitiesSelected: [],
     activitiesAllSelected: false,
     activitySearchFiltersInfo: {},
     activityActionBtnList: [{'name': 'Editar Actividad', 'action': 'update_activity', 'icon': 'mdi-pencil-outline'}],
     projectItemsPerPageText: 'Proyectos por página:',
     projectSearchFilters: ['text__icontains'],
     projectsLoading: false,
     companyRefsLoading:false,
     deleteProjectsAsyncJob: null,
     deleteReferencesAsyncJob: null,
     deleteProjJobState: 'done',
     deleteRefJobState:'done',
     projectsSelected: [],
     companyRefsSelected: [],
     projectsAllSelected: false,
     companyRefsAllSelected: false,
     projectSearchFiltersInfo: {},
     projectActionBtnList: [{'name': 'Editar Proyecto', 'action': 'update_project', 'icon': 'mdi-pencil-outline'}],
     companyRefsActionBtnList: [{'name': 'Editar Referencia', 'action': 'update_reference', 'icon': 'mdi-pencil-outline'}],
     loadPathsItemsPerPageText: 'Puntos de carga por página:',
     loadPathSearchFilters: ['text__icontains'],
     loadPathsLoading: false,
     deleteLoadPathsAsyncJob: null,
     deleteLoadPathJobState: 'done',
     loadPathsSelected: [],
     loadPathsAllSelected: false,
     loadPathSearchFiltersInfo: {},
     loadPathActionBtnList: [{'name': 'Editar Punto de Carga', 'action': 'update_load_path', 'icon': 'mdi-pencil-outline'}],
     userItemsPerPageText: 'Usuarios por página:',
     userSearchFilters: ['text__icontains'],
     usersLoading: false,
     deleteUsersAsyncJob: null,
     deleteUserJobState: 'done',
     usersSelected: [],
     usersAllSelected: false,
     userSearchFiltersInfo: {},
     userActionBtnList: [{'name': 'Cambiar Contraseña', 'action': 'update_password', 'icon': 'mdi-lock-reset'}],
     textScreenTitle: 'Alta/Modificación Empresa',
     textPassMinLength: 'Mínimo 8 carácteres',
     passMinLength: 8,
     snackbar: {
         isVisible: false,
         text: '',
         color: 'error',
     },
     textSnackbarOk: 'Cambios realizados con éxito.',
     textSnackbarKo: 'Compruebe que los valores en el formulario son válidos.',
     textSnackbarKoApi: 'Ha habido un problema con la operación.',
     textSnackbarDeleteOK: 'Se han eliminado los elementos correctamente.',
     validationRules: {
         required: v => !!v || 'Campo obligatorio',
         passMinLength: v => v && (v.length >= this.passMinLength) || this.textPassMinLength,
         changePassEqRepeat: v => v == this.newPassValues.password || 'Las dos contraseñas deben ser iguales.',
         createUserPassEqRepeat: v => v == this.newUserValues.password || 'Las dos contraseñas deben ser iguales.',
         emailFormat: v => /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'El formato del email no es válido',
         requiredDefaultRoleKindCreate: v => (!!v || !this.newUserValues.view_all_companies) || 'Campo obligatorio',
         requiredDefaultRoleKindUpdate: v => (!!v || !this.updateUserValues.view_all_companies) || 'Campo obligatorio',
         notBlankSpace: v => (!!v && !v.includes(' ')) || 'Campo con espacios en blanco',
         dateLoadPathRequired: v => (!!v && this.newLoadPath.accounting_date == 'configurated') || (this.newLoadPath.accounting_date != 'configurated') || 'Campo obligatorio',
         dateFormat: v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(v) || 'El formato de la fecha no es válido',
     },
     check_cartera:undefined,
     openFolderSelectorJobState: 'done',
     openFolderSelectorJobId : 0,
     loadChildrenInterval: null,
   //   Tipo de Gasto Ingreso
     expensIncomeTypeItemsPerPageText: 'Tipo de Gasto/Ingreso por página:',
     expensIncomeTypeSearchFilters: ['name__icontains'],
     expensIncomeTypeLoading: false,
     deleteExpensIncomeTypeAsyncJob: null,
     deleteExpensIncomeTypeJobState: 'done',
     expensIncomeTypeSelected: [],
     expensIncomeTypeAllSelected: false,
     expensIncomeTypeSearchFiltersInfo: {},
     // expensIncomeTypeActionBtnList: [{'name': 'Editar Tipo de Gasto Ingreso', 'action': 'update_channel', 'icon': 'mdi-pencil-outline'}],
     allowed_cdbtype_changes: allowed_cdbtype_changes,
     showExtPassword: false,
     loadPathAlertPopup: false,
     loadPathAlertMsg: '',
     resolveLoadPathAlert: null,
     popupExcludedFiles:false,
     popupExcludedFilesKey: 0,
     forceDownloadLoading: false,
     panelLoadPath: -1,
     hasEInvoiceContract:false
   };
 },
 watch:{
   nst_path(val,oldval) {
     this.currentCon.name=val['path']
   },
   onAction() {
     if (this.onAction === 'SELECT_CONNECTOR_TYPE') {
       this.$refs.selectTypeRef.activateMenu();
     }
   },
   currentConType() {
     this.tutorialSetConnectorType(this.currentConType);
   },
 },
 computed:{
   ...mapState(['currentCompany']),
   currentConType: function() {
     if(this.currentCon.companydb_type){
       return this.currentCon.companydb_type.id;
     }
     else{
       return ''
     }
   },
   extraLinkCols(){
     let count=0
     if(this.userData.available_features['feature_prorate'] && this.currentCon.prorate){
       count+=2
     }
     if(this.got_feature('feature_validate_link')){
       count+=1
     }
     return count

   },
   imInboxType() {
     return this.currentCon.companydb_type && this.currentCon.companydb_type.value == 'inbox'
   },
   referencable_companydbs(){
     return this.get_companydbs.filter(cdb => cdb.companydb_type.value != 'inbox')
   },
   currentCompanydbType: function() {
     if(this.currentCon.companydb_type) {
       return this.currentCon.companydb_type
     }
     return {'id':'', 'value': '', 'name': '', 'type': '' };
   },
   getTaxType() {
      let tax_types = [{value:'iva_igic',text:'IVA/IGIC'}, {value:'iva',text:'IVA'}, {value:'igic',text:'IGIC'}];
      if (this.got_feature('feature_igi_andorra')) {
        tax_types.push({value:'igi',text:'IGI - Andorra'});
      }
      if (this.got_feature('feature_igic2019')) {
        tax_types.push({value:'igic2019',text:'IGIC 2019'});
      }
      return tax_types;
    },
   company_has_locations: function() {
     let has_locations = false;
     if (this.currentCompanydbType && this.currentCompanydbType.has_locations && this.locations.length && this.feature_config_locations) {
       has_locations = true;
     }
     return has_locations;
   },
   label_review: function () {
     if(this.currentCompanydbType.name)
       return "Revisar antes de contabilizar en " + this.currentCompanydbType.name
     return "Revisar antes de contabilizar"
   },
   label_path: function () {
     let label = "Código de empresa";
     if (this.currentCompanydbType && this.currentCompanydbType.value) {
       let labels = Object.keys(this.companyid_labels);
       if (labels.includes(this.currentCompanydbType.value)) {
         label = this.companyid_labels[this.currentCompanydbType.value];
       } else { 
         label = label + ' de ' + this.currentCon.companydb_type['name']  
       }
     }
     return label;
   },
   are_errors: function () {
     let are_errors = false;
     for (let i in this.importErrors) {
       if (this.importErrors[i].length) {
         are_errors = true;
       }
     }
     return are_errors;
   },
   label_password: function () {
     if(this.currentCon.companydb_type)
       return "Contraseña de " + this.currentCon.companydb_type.name
     return "Contraseña"
   },
   readonly_activities: function () {
    let readonly = 'readonly_activities' in this.currentCon.companydb_type.params && this.currentCon.companydb_type.params['readonly_activities'];
    return readonly;
   },
   ...mapGetters([
     'get_companydbs',
     'got_feature',
   ]),
   ...mapGetters("connector", [
     "connectorFetched",
     "currentConnector",
     "get_nstpaths",
   ]),
   ...mapGetters({
     onAction: 'tutorial/onAction',
     userData: 'me/userData',
     availableDocs: 'me/availableDocs',
     listRequest: 'webhook_request/list',
     permission: 'permissions/permission',
   }),
   ...mapFields('webhook', {webhook: 'webhook'}),
   ...mapFields('webhook',vuexPrefix('webhook_', ['url', 'headers'], 'webhook.')),
   ...mapFields(['zones', "projects", "activities", "oauth_params_storage"]),
   currentTab:{
     get(){
          if(this.clickedTab!=undefined){
            return this.clickedTab;
          }
          else if (this.showTiposIvaTabs('iva')) {
            return 0;
          }
          else if (this.showTiposIvaAndorraTab('igi')) {
            return 2;
          }
          return 7; //Others
     },
     set(newValue){
         if(newValue!=this.currentTab)
             this.clickedTab=newValue
     },
   },
   ...mapFields('me',vuexPrefix('',[
     'feature_payment_move', 'feature_comerciante_minorista',
     'feature_project_by_reference', 'feature_description_order', 'feature_copy_config_from_cdb',
     'feature_retention_accounts_agrario', 'feature_vat_5', 'feature_load_paths',
     'feature_decimal_separator', 'feature_config_locations','feature_price_range',
     'feature_date_in_invoice_description','feature_cuenta_cartera_contasol', 'feature_accounts_master',
     'feature_exenta_no_sujeta', 'feature_criterio_de_caja', 'feature_writer_users',
     'feature_config_webhook'
   ],'userData.available_features.')),
   ...mapFields('connector', {
     show_message: 'show_message',
     type_choices: 'type_choices',
     companydb_types: 'companydb_types',
     jobState: 'jobState',
     asyncJobId: 'asyncJobId',
     companyid_labels: 'companyid_labels',
     csv_one_line_headers: 'csv_one_line_headers',
     csv_one_line_hidden_headers: 'csv_one_line_hidden_headers',
     csv_multi_line_headers: 'csv_multi_line_headers',
     csv_multi_line_hidden_headers: 'csv_multi_line_hidden_headers',
     showMessages: 'showMessages',
     cdbs_with_settings: 'cdbs_with_settings',
     oauth_params: 'oauth_params',
     load_path_types: 'load_path_types',
     locations: 'locations',
     taxes: 'taxes',
   }),
   ...mapFields('config',{
     csv_one_line_field_values: 'csv_one_line_field_values', 
     excel_headers: 'excel_headers',
     excel_hidden_headers: 'excel_hidden_headers',
   }),
   ...mapState([
     'session_information'
   ]),
   currentZone: {
     get() {
       if (this.clickedZone!=undefined) {
         return this.clickedZone;
       } else {
         return 'Datos';
       }
     },
     set(newValue) {
       if (newValue != this.currentZone) {
         this.clickedZone = newValue;
       }
     },

     
   },
   currantCSVTab: {
     get() {
       if (this.clickedCSV!=undefined) {
         return this.clickedCSV;
       } else {
         return 0;
       }
     },
     set(newValue) {
       if (newValue != this.currantCSVTab) {
         this.clickedCSV = newValue;
       }
     },
   },
   accountRules() {
     return [
       (v) => !v ||  validateAccount(v) || 'La cuenta debe contener únicamente dígitos'
     ]
   },

   isDeleteLinkDisabled: function () {
     let isDisabled = true;
     if (this.currentCon.companydb_type && this.currentCon.links.length > 1) {
       let count = 0;
       for (let i in this.currentCon.links) {
         if (this.currentCon.links[i].deleted == false) {
           count++;
         }
       }
       if (count > 1) {
         isDisabled = false;
       }
     }
     return isDisabled;
   },

    errorLinks: function () {
      let errs = [];
      if (this.currentCon && this.currentCon.links && this.currentCon.links.length) {
        for (let i in this.currentCon.links) {
          let err = [];
          if (!this.currentCon.links[i].deleted && this.currentCon.links[i].start_ejercicio && this.currentCon.links[i].end_ejercicio) {
            let min_date = this.currentCon.links[i].min_date;
            let max_date = this.currentCon.links[i].max_date;

            let start_year = this.currentCon.links[i].start_ejercicio.split('-')[0];
            let end_year = this.currentCon.links[i].end_ejercicio.split('-')[0];
            let year = this.currentCon.links[i].year_ejercicio + '';
            if ([start_year, end_year].indexOf(year) == -1) {
              if (this.can_edit_ejercicio(this.currentCon.links[i])) {
                err.push('start_ejercicio');
                err.push('end_ejercicio');
              }
              err.push('year_ejercicio');
            }

            for (let j in this.currentCon.links) {
              if (i != j && !this.currentCon.links[j].deleted) {
                let aux_min_date = this.currentCon.links[j].min_date;
                let aux_max_date = this.currentCon.links[j].max_date;
                if (min_date <= aux_max_date && min_date >= aux_min_date) {
                  err.push('min_date')
                }
                if (max_date >= aux_min_date && max_date <= aux_max_date) {
                  err.push('max_date')
                }
              }
            } 
          }
          errs.push(err);
        }
      }
      return errs;
    },
   projectHeaders() {
     return [
       { 
         text: 'Nombre del Proyecto',
         sortable: true,
         value: 'name' 
       },
       { 
         text: 'Código de ' + this.currentCompanydbType.name, 
         value: 'external_id', 
         sortable: true,
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ];
   },
   companyReferencesHeaders(){
     return [
       { 
         text: 'Nombre de la Empresa',
         sortable: true,
         value: 'name' 
       },
       { 
         text: 'Referencia', 
         value: 'reference', 
         sortable: true,
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ];
   },
   channelHeaders() {
     return [
       {
         text: '',
         value: 'checkboxes',
         sortable: false,
         align: 'start',
       },
       { 
         text: 'Nombre del Canal',
         sortable: true,
         value: 'name',
       },
       { 
         text: 'Código de ' + this.currentCompanydbType.name, 
         value: 'external_id', 
         sortable: true, 
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ];
   },
   activityHeaders() {
     return [
       {
         text: '',
         value: 'checkboxes',
         sortable: false,
         align: 'start',
       },
       { 
         text: 'Nombre de la Actividad',
         sortable: true,
         value: 'name',
       },
       { 
         text: 'Código de ' + this.currentCompanydbType.name, 
         value: 'code', 
         sortable: true,
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ];
   },
   loadPathHeaders() {
     return [
       { 
         text: 'Tipo', 
         value: 'load_path_type_name',
         sortable: false,
       },
       { 
         text: 'Punto de carga',
         value: 'path_name',
         sortable: true,
       },
       { 
         text: 'Email',
         value: 'email',
         sortable: true,
       },
       {
         text: 'Tipo de documento',
         value: 'doc_kind_desc',
         sortable: false,
       },
       {
         text: 'Fecha contable',
         value: 'accounting_date_desc',
         sortable: false,
       },
       {
          text: 'Fecha de creación',
          value: 'created',
          sortable: true,
        },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
       
     ];
   },
   receivedEmailsHeaders() {
     return [
       {
         text: 'Fecha',
         value: 'date',
         sortable: true,
       },
       {
          text: 'Asunto',
          value: 'subject',
          sortable:false
       },
       {
         text: 'Remitente',
         value: 'from_email',
         sortable: false,
       },
       {
         text: 'IDs Documentos asociados',
         value: 'associated_invoices',
         sortable: false,
       },
        {
         text: 'Archivo de correo',
         value: 'path',
         sortable: false,
         align: 'start',
         type: 'blob_link',
         link_text: 'Descargar'
       }
     ];
   },
   expensIncomeTypeHeaders() {
     return [
       {
         text: '',
         value: 'checkboxes',
         sortable: false,
         align: 'start',
       },
       {
         text: 'Nombre del Tipo de Gasto/Ingreso',
         sortable: true,
         value: 'name',
       },
       {
         text: 'Código de ' + this.currentCompanydbType.name,
         value: 'code',
         sortable: true,
       },
       {
         text: 'Tipo',
         value: 'type_display',
         sortable: true,
       },
       {
         text: '',
         align: 'end',
         value: 'actions',
         sortable: false,
       },
     ];
   },
   activity_type(){
     let activity_format = 'text';
     if (this.currentCompanydbType && this.currentCompanydbType.params && this.currentCompanydbType.params.activity_format === 'number'){
       activity_format = 'number';
     }
     return activity_format
   },
   currentLoadPathType() {
     for (let i in this.load_path_types) {
       if (this.load_path_types[i]['id'] == this.newLoadPath.load_path_type) {
         return this.load_path_types[i];
       }
     }
     return {};
   },
   connectorTabs(){
     return this.connector_tabs.filter(connector => eval(connector.if))
   },
   SessionLabel(){
     if (this.newLoadPath.load_path_type){
       return this.loadPathSessionlabel;
     }
     else
       return this.currentCompanydbType.name;
   },
   loadPathSessionlabel(){
     if (this.newLoadPath.load_path_type) {
       let current_load_path_type = this.newLoadPath.load_path_type;
       let load_path_type_name = this.load_path_types.find(type => type.id === current_load_path_type).name;
       return load_path_type_name;
     }
     return '';
   },
   storageOpenidUsersByValue(){
     let load_path_type_id = this.newLoadPath.load_path_type
     let storage = this.load_path_types.find(({ id }) => id === load_path_type_id)
     let sessions = {};
     if (storage){
       sessions = this.storage_openid_users.filter( session => session.oauth_app === storage.value)
     }
     return [{id: 0,account_name: 'Añadir Sesión'}].concat(sessions);
   },
   canUpdateLoadPathPrimaryData(){
     return Boolean(this.loadPathToUpdate)
   },
   invoiceDescriptionOrderItems() {
     let items = [
       {'text': 'No. Factura - Tercero', 'value': 'inv_prov'}, 
       {'text': 'Tercero - No. Factura', 'value': 'prov_inv'}
     ];
     if (this.feature_date_in_invoice_description) {
       items.push({'text': 'No. Factura - Fecha', 'value': 'inv_date'});
       items.push({'text': 'Fecha - No. Factura', 'value': 'date_inv'});
     }
     return items;
   },
   hasInfo() {
     let has_info = false;
     if (this.currentCompanydbType && Object.keys(this.currentCompanydbType).includes('extra_info') && this.currentCompanydbType['extra_info']) {
       has_info = true;
     }
     return has_info;
   },
   cut_inv_num_items() {
     let values = [
       {'text': 'Mantener todos los caracteres', 'value': 'no_cut'}, 
       {'text': 'Mantener los primeros caracteres', 'value': 'cut_first'}, 
       {'text': 'Mantener los últimos caracteres', 'value': 'cut_last'}
     ];
     if (this.currentCompanydbType.params && this.currentCompanydbType.params['default_cut_inv_number'] && this.currentCompanydbType.params['default_cut_inv_number']['values']) {
       values =  this.currentCompanydbType.params['default_cut_inv_number']['values']
     }
     return values;
   },
   cut_cus_inv_num_items() {
     let values = [
       {'text': 'Mantener todos los caracteres', 'value': 'no_cut'}, 
       {'text': 'Mantener los primeros caracteres', 'value': 'cut_first'}, 
       {'text': 'Mantener los últimos caracteres', 'value': 'cut_last'}
     ];
     if (this.currentCompanydbType.params && this.currentCompanydbType.params['default_cut_cus_inv_number'] && this.currentCompanydbType.params['default_cut_cus_inv_number']['values']) {
       values =  this.currentCompanydbType.params['default_cut_cus_inv_number']['values']
     }
     return values;
   },
   is_disabled_iva_igic_no_deducible() {
     let is_disabled = true;
     if (this.currentCon.id) {
       is_disabled = false;
     } else if (this.currentCon.companydb_type && 'params' in this.currentCon.companydb_type && 'default_iva_igic_no_deducible' in this.currentCon.companydb_type.params) {
       is_disabled = false;
     }
     return is_disabled
   },
   canViewChangeCDBType() {
     if (!this.currentCon.id) {
       return false;
     }
     return this.currentCompanydbType.value in this.allowed_cdbtype_changes;
   },
   showMailField() {
     let show = false;
     if (this.currentLoadPathType.params && 'need_mail' in this.currentLoadPathType.params) {
       show = true;
     }
     return show;
   },
 },
 methods:{
   ...mapActions({
     fetchConnector: "connector/fetchConnector",
     resetConnector: "connector/resetConnector",
     createCompanyDBUser: "connector/createCompanyDBUser",
     addCompanyDBUser: "connector/addCompanyDBUser",
     deleteCompanyDBUser: "connector/deleteCompanyDBUser",
     getFreeInvitedUsers: "connector/getFreeInvitedUsers",
     changePassCDBUser: "connector/changePassCDBUser",
     tutorialSetConnectorType: "tutorial/tutorialSetConnectorType",
     refreshContanetPaths: "connector/refreshContanetPaths",
     fetchRefreshProgressState: "connector/fetchRefreshProgressState",
     refreshAccounts: "connector/refreshAccounts",
     getLastGetContanetDBListOp: "connector/getLastGetContanetDBListOp",
     getLastGetAccountsContanetOp: "connector/getLastGetAccountsContanetOp",
     setNstpaths: "connector/setNstpaths",
     refreshUserData: "me/refreshUserData",
     importFile: "connector/importFile",
     setCompanyDBTypes: "connector/setCompanyDBTypes",
     getColumnsCsvOneLine: "connector/getColumnsCsvOneLine",
     setColumnsCsvOneLine: "connector/setColumnsCsvOneLine",
     activeTrainingMessage: 'connector/activeTrainingMessage',
     inactiveTrainingMessage: 'connector/inactiveTrainingMessage',
     activeInstalationMessage: 'connector/activeInstalationMessage',
     inactiveInstalationMessage: 'connector/inactiveInstalationMessage',
     initialInstalationConnector: 'me/initialInstalationConnector',
     getCdbWithSettings: 'connector/getCdbWithSettings',
     setColumnDataIfParams: 'connector/setColumnDataIfParams',
     getOpenIdUserSessions: 'connector/getOpenIdUserSessions',
     connectOuth2User: 'connector/connectOuth2User',
     validateUser: 'connector/validateUser',
     getUserCompanies: 'connector/getUserCompanies',
     createConnProject: 'connector/createConnProject',
     updateConnProject: 'connector/updateConnProject',
     deleteConnProject: 'connector/deleteConnProject',
     createConnChannel: 'connector/createConnChannel',
     updateConnChannel: 'connector/updateConnChannel',
     deleteConnChannel: 'connector/deleteConnChannel',
     createConnActivity: 'connector/createConnActivity',
     deleteConnActivity: 'connector/deleteConnActivity',
     updateConnActivity: 'connector/updateConnActivity',

     createConnLoadPath: 'connector/createConnLoadPath',
     deleteConnLoadPath: 'connector/deleteConnLoadPath',
     updateConnLoadPath: 'connector/updateConnLoadPath',
     createConnAccount: 'connector/createConnAccount',
     deleteConnAccounts: 'connector/deleteConnAccounts',
     updateConnAccount: 'connector/updateConnAccount',
     setLoadPathTypes: 'connector/setLoadPathTypes',
     getLocations: 'connector/getLocations',
     getFolders: 'connector/getFolders',
     getWebhook: 'webhook/getData',
     saveWebhook: 'webhook/save',
     getWebhookRequest: 'webhook_request/getData',
     getItemPerPageWebhookRequest: 'webhook_request/getItemPerPage',
     setPageWebhookRequest: 'webhook_request/setPage',
     setUserData: "me/setUserData",
     updateAbonoKeywords: 'connector/updateAbonoKeywords',
     textToLowerCase: "config/textToLowerCase",
     setMessageModal: 'messageModal/setModal',
     closeMessageModal: 'messageModal/closeModal',
     getColumnsExcel: "config/getColumnsExcel",
     setColumnsExcel: "config/setColumnsExcel",
     deleteConnExpensIncomeType: 'connector/deleteConnExpensIncomeType',
   }),
   ...mapActions(["setCompanydbs","setCompanydbs2", "setCurrentCompany", "setProjects", "setActivities", "copySettingsFromCdb","resetCurrentCompany", "setZones"]),
   delete_link(link){
     link.deleted=true
   },
   TabSelected(tab){
     if (tab=='Emisor de Facturas'){
       this.been_in_einvoice_tab=true
     }
   },
   getValidationCircleColor(link){
     switch (link.validation_state) {
       case 'pending':
         return '#FAD817';
       case 'error':
         return '#FD552C';
       case 'validated':
         return '#46C139';
       default:
         return 'D3D3D3';
     }
   },
   getValidationTooltipText(link){
     switch (link.validation_state) {
       case 'pending':
         return 'Validando ejercicio en destino...';
       case 'error':
         return 'Error de validación de ejercicio en destino';
       case 'validated':
         return 'Ejercicio validado en destino';
       default:
         return 'Ejercicio sin validar en destino';
     }
   },
   async contasolConsentedCompanyCodes(){
     return await new Promise((resolve, reject) => {
       client.get('get_contasol_consent/').then((response) => {
         resolve(response.data)
       }).catch(err=>{
           console.log(response)
         reject(err);
       });
     })
   },
   async type_selected(){
     this.validateCreate();
     if ('has_locations' in this.currentCompanydbType && this.currentCompanydbType.has_locations) {
       this.getLocations(this.currentCompanydbType.value);
     }
     if((this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('actividad')) && !('actividad' in this.currentCon.configuration)){
       if (this.got_feature('feature_revision_required_actividad')) {
         this.currentCon.configuration['actividad'] = null;
       } else {
         this.currentCon.configuration['actividad'] = '0';
       }
     }
     if (this.currentCompanydbType.params && this.currentCompanydbType.params['default_cut_inv_number']) {
       if (this.currentCompanydbType.params['default_cut_inv_number']['cut_inv_num']) {
         this.currentCon.cut_inv_num = this.currentCompanydbType.params['default_cut_inv_number']['cut_inv_num'];
       }
       if (this.currentCompanydbType.params['default_cut_inv_number']['num_chars_inv_num']) {
         this.currentCon.num_chars_inv_num = this.currentCompanydbType.params['default_cut_inv_number']['num_chars_inv_num'];
       }
       if (this.currentCompanydbType.params['default_cut_inv_number']['chars_to_exclude']) {
         this.currentCon.chars_to_exclude = this.currentCompanydbType.params['default_cut_inv_number']['chars_to_exclude'];
       }
     } else {
       this.currentCon.cut_inv_num = '';
       this.currentCon.chars_to_exclude = [];
     }
     if (this.currentCompanydbType.params && this.currentCompanydbType.params['default_cut_cus_inv_number']) {
       if (this.currentCompanydbType.params['default_cut_cus_inv_number']['cut_inv_num']) {
         this.currentCon.cut_cus_inv_num = this.currentCompanydbType.params['default_cut_cus_inv_number']['cut_inv_num'];
       }
       if (this.currentCompanydbType.params['default_cut_cus_inv_number']['num_chars_inv_num']) {
         this.currentCon.num_chars_cus_inv_num = this.currentCompanydbType.params['default_cut_cus_inv_number']['num_chars_inv_num'];
       }
       if (this.currentCompanydbType.params['default_cut_cus_inv_number']['chars_to_exclude']) {
         this.currentCon.chars_to_exclude_cus = this.currentCompanydbType.params['default_cut_cus_inv_number']['chars_to_exclude'];
       }
     } else {
       this.currentCon.cut_cus_inv_num = '';
       this.currentCon.chars_to_exclude_cus = [];
     }
     if(this.currentCompanydbType.params && this.currentCompanydbType.params.auth_type && this.currentCompanydbType.params.auth_type == 'openid'){
       let sessions = await this.getOpenIdUserSessions({'value':this.currentCompanydbType.value});
       this.oauth_message = this.get_oauth_message(this.currentCompanydbType.name) 
       this.connect_outh2user_data = {
         'value':this.currentCompanydbType.value,
         'state':this.currentCompanydbType.value
       }
       this.openid_users = [{id: 0,account_full_name: 'Añadir Sesión'}].concat(sessions);
     }
     if (this.currentCompanydbType.params && 'default_iva_igic_no_deducible' in this.currentCompanydbType.params) {
       this.currentCon.iva_igic_no_deducible = this.currentCompanydbType.params['default_iva_igic_no_deducible'];
     } else {
       this.currentCon.iva_igic_no_deducible = false;
     }
   },
   show_vat(vat){
     if(['vat_10_5','vat_12'].includes(vat) && !this.currentCon.iva_agrario_pesca){
         return false
     }
     if(['vat_re_1_75'].includes(vat) && !this.currentCon.iva_tabaco){
         return false
     }
     if(['vat_5'].includes(vat) && !this.feature_vat_5){
         return false
     }
     if(['vat_ns_0','vat_ne_0','igic_ns_0','igic_ne_0'].includes(vat) && (!this.got_feature('feature_exenta_no_sujeta') || ['intra', 'extra', 'isps'].includes(this.tabs[this.currentTab].name))){
         return false
     }
     if(['vat_re_625','vat_5_625'].includes(vat) && !this.got_feature('feature_vat_re_625')){
         return false
     }
     if(['vat_0_0'].includes(vat) && !this.got_feature('feature_codigo_re_0')){
         return false
     }
     if (['igic_5'].includes(vat) && !this.got_feature('feature_igic_5')) {
         return false;
     }
     if(['igic_cm_3','igic_cm_5','igic_cm_7','igic_cm_95','igic_cm_15','igic_cm_20'].includes(vat) && !this.got_feature('feature_igics_cm_company')){
          return false;
     }
     return true
   },
   async copySettings(copy_cdb_from){
     this.copying = true;
     const data = await this.copySettingsFromCdb({"settings_code":"csv_facturas_one_line_headers","cdb_id":this.id,"copy_cdb_from":copy_cdb_from})
     this.setColumnDataIfParams(data)
     this.csv_one_line_dialog = false;
     this.copying = false;
   },
   async copySettingsValues(copy_cdb_from){
     this.copying = true;
     const data = await this.copySettingsFromCdb({'settings_code':'csv_facturas_one_line_configure_field_values',"cdb_id":this.id,"copy_cdb_from":copy_cdb_from})
     if (data['params']){
       this.csv_one_line_field_values = data['params'];
     }
     this.csv_one_line_field_values_dialog = false;
     this.copying = false;
   },
   set_link_values(index){
     this.currentCon.links[index].link_path = this.openid_company.correlationId;
     this.currentCon.links[index].link_name = this.openid_company.companyName;
   },
   add_link(){
     if (this.currentCon.links.length) {
       let index = this.currentCon.links.length - 1;
       let min_date_aux = moment(this.currentCon.links[index].max_date, 'YYYY-MM-DD').add(1, 'days')
       let min_date = min_date_aux.format('YYYY-MM-DD');
       let max_date = moment(this.currentCon.links[index].max_date, 'YYYY-MM-DD').add(1, 'years').format('YYYY-MM-DD');
       let company_link_data={
         link_path: "",
         min_date: min_date,
         max_date: max_date,
         start_ejercicio: min_date,
         end_ejercicio: max_date,
         year_ejercicio: min_date_aux.year(),
         prorate_percent: 'N/A',
         deleted:false, 
         active: true
       }
       if (this.currentCompanydbType.params && this.currentCompanydbType.params.use_name_link){
         company_link_data.link_name=this.currentCon.links[0].link_name
       }
       if (this.currentCompanydbType.params && this.currentCompanydbType.params.same_cdb_code){
         company_link_data.link_path=this.currentCon.links[0].link_path
       }
       this.currentCon.links.push(company_link_data);
     } else {
        const start = moment('01/01','DD/MM')
        const end = moment('31/12','DD/MM')
        this.currentCon.links.push({
          link_path: "",
          min_date: start.format('YYYY-MM-DD'),
          max_date: end.format('YYYY-MM-DD'),
          start_ejercicio: start.format('YYYY-MM-DD'),
          end_ejercicio: end.format('YYYY-MM-DD'),
          year_ejercicio: start.year(),
          prorate_percent: 'N/A',
          deleted:false, active: true
        });
     }
   },
   updateKeywords(val){
     this.updateAbonoKeywords(val)
   },
   refresh_contanet_paths() {
     this.message = 'Refrescar las rutas .NST puede tardar unos momentos...';
     this.show_config_dialog = true; 
     this.refreshProgressState = 'pending';
     this.refreshContanetPaths().then((response) => {
       this.refreshProgressId = response.data.results.id;
       this.interval = setInterval(this.fetch_refresh_progress_state, 2000);
     }).catch(err=>{
       this.refreshProgressState = 'done';
     });
   },

   fetch_refresh_progress_state() {
     try {
       this.fetchRefreshProgressState(this.refreshProgressId).then(response => {
         this.refreshProgressState = response.data.state;
         if (this.refreshProgressState === "done") {
           clearInterval(this.interval);
           this.setNstpaths().then(()=>{
             this.nstpaths=this.get_nstpaths;
           });
         } else if (this.refreshProgressState === "error") {
           clearInterval(this.interval);
         }
       });
     } catch (error) {
       console.debug(error);
       clearInterval(this.interval);
     }
   },

   refresh_accounts() {
     this.refreshAccountsState = 'pending';
     this.refreshAccounts([this.currentCon.id]).then((response) => {
       this.refreshAccountsId = response.data.results.ids[0];
       this.intervalAccounts = setInterval(this.fetch_refresh_accounts_state, 2000);
     }).catch(err=>{
       this.refreshProgressState = 'done';
     });
   },

   fetch_refresh_accounts_state() {
     try {
       this.fetchRefreshProgressState(this.refreshAccountsId).then(response => {
         this.refreshAccountsState = response.data.state;
         this.refreshAccountsArgs = response.data.args;
         if (this.refreshAccountsState === "done") {
           clearInterval(this.intervalAccounts);
           this.refreshAccountsList();
         } else if (this.refreshAccountsState === "error") {
           clearInterval(this.intervalAccounts);
         }
       });
     } catch (error) {
       console.debug(error);
       clearInterval(this.intervalAccounts);
     }
   },

   is_link_path_correct(link) {
     let is_correct = true;
     if (!link.link_path) {
       is_correct = false;
     } else if (this.currentCompanydbType.params && this.currentCompanydbType.params.company_num_format) {
       let regex_expression = this.currentCompanydbType.params.company_num_format.value;
       if (regex_expression.includes('min_date_year')) {
         let year = link.min_date.split('-')[0];      
         regex_expression = regex_expression.replace('min_date_year', year);
       }
       if (!RegExp(regex_expression).test(link.link_path)) {
         is_correct = false;
       }
     }
     return is_correct;
   },

    can_edit_ejercicio(link) {
      if (link.id) {
        const ini = moment(link.start_ejercicio);
        const end = moment(link.end_ejercicio).add(1, 'days');
        const diffYear = end.diff(ini, 'years', true); 
        return diffYear != 1
      }
      return true
    },

   is_prorate_percent_correct(percent) {
     let is_correct = false;
       if (percent == 'N/A') {
         is_correct = true;
       } else {
         let regex = '^[0-9]*(\\.[0-9]*)?$'
         if (RegExp(regex).test(percent)) {
           if (parseFloat(percent) >= 0 && parseFloat(percent) <= 100) {
             is_correct = true;
           }
         }
       }
     return is_correct;
   },

   disabled_save(){
     let disabled = true;
     let only_refresh_accounts = this.refreshAccountsArgs && 'only_refresh_accounts' in this.refreshAccountsArgs && this.refreshAccountsArgs['only_refresh_accounts'];
     let is_staff = this.userData.is_staff || this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username);
     if (!['pending','running_batch'].includes(this.refreshAccountsState) || only_refresh_accounts || is_staff) {
       if(this.currentCon.links){
         disabled = false
         for (let i in this.currentCon.links) {
           if (!this.currentCon.links[i].deleted) {
            if (this.userData.available_features['feature_periodo_ejercicio']) {
              disabled = disabled || !this.currentCon.links[i].start_ejercicio || !this.currentCon.links[i].end_ejercicio || !this.currentCon.links[i].year_ejercicio
            }
             disabled = disabled || !this.currentCon.links[i].min_date || !this.currentCon.links[i].max_date || this.errorLinks[i].length > 0 || !this.is_link_path_correct(this.currentCon.links[i]) 
           }
         }
       }
     }
     let needs_fam = !(this.currentCompanydbType.params && this.currentCompanydbType.params.hasOwnProperty('accounts_length'))
     if (this.currentCon.configuration && this.currentCon.configuration['auto_create_supplier']){
       if((!this.currentCon.configuration['auto_create_supplier_account_family'] && needs_fam) || !this.currentCon.configuration['auto_create_supplier_account']){
         disabled = true
       }
     }
     if (this.currentCon.configuration && this.currentCon.configuration['auto_create_customer']){
       if((!this.currentCon.configuration['auto_create_customer_account_family'] && needs_fam) || !this.currentCon.configuration['auto_create_customer_account']){
         disabled = true
       }
     }
     if (this.imInboxType){
       return false
     }
     return disabled
   },
   updateObject(){
     this.creating=true;
     this.update_companydb().then((response) => {
       if(response.data.min_date){
         let d_str_split = response.data.min_date.split('-')
         response.data.min_date = d_str_split[2]+'/'+d_str_split[1]+'/'+d_str_split[0]
       }
       if(response.data.max_date){
         let d_str_split = response.data.max_date.split('-')
         response.data.max_date = d_str_split[2]+'/'+d_str_split[1]+'/'+d_str_split[0]
       }
       this.currentCon = new connector.models.Connector(response.data);
       this.setCompanydbs2(); //per si per exemple canvies el nom de la cdb
       let curr_con = {...this.currentCon} //sino fa punter
       this.setCurrentCompany(curr_con);
       this.creating=false;
     }).catch(err=>{
       this.creating=false
       console.error(err)
     });
   },
   update() {
     if(!this.disabled_save()){
       setTimeout(this.updateObject);
     }
   },
   async createObject() {
     this.creating=true;
     if (['contasol_nube','estimasol_nube'].includes(this.currentCompanydbType.value )){ //si es contasol nube, comprovem que tenim els permisos
       let miss = await this.missingContasolConsent();
       if(miss!=''){
         this.creating=false;
         this.setMessageModal({
           textTitle: 'Error',
           text: 'No se puede crear la empresa porque no hemos recibido los permisos de Contasol para el código de empresa '+miss +'. ( Si ya has dado los permisos, espera unos minutos y vuelve a intentarlo )' ,
           actionConfirmButton: this.closeMessageModal
         });
         return;
       }
     }

     this.create_companydb().then((response) => {
       this.fetchConnector({ id: response.data.id }).then(()=>{
         this.show_message=true;
         this.creating=false;
         this.currentCon = new connector.models.Connector(this.currentCon);
         
       })
       //this.check_operation()
     }).catch(err=>{
       this.creating=false
       console.error(err)
     });
     
   },
   initInstalation() {
     this.inactiveTrainingMessage();
     this.inactiveInstalationMessage();
     this.initialInstalationConnector().then((response) => {
       this.$router.push("/welcome");
     });
   },
   validateCreate() {
     let valid = true;
     this.inactiveTrainingMessage();
     this.inactiveInstalationMessage();
     if (!this.currentCompanydbType.params.works_without_connector && this.userData.training_status != 'DONE_TRAINING') {
       valid = false;
       if (this.userData.training_status === 'PENDING_TRAINING') {
         this.activeTrainingMessage();
       } else  {
         this.activeInstalationMessage();
       }
     }
     return valid;
   },

   async missingContasolConsent(){
     if (['contasol_nube','estimasol_nube'].includes(this.currentCompanydbType.value )){
       for(let link of this.currentCon.links){
         let consentCodeList = await this.contasolConsentedCompanyCodes()
         if(!consentCodeList.includes(link.link_path.slice(0, -4))) {
           return link.link_path;
         }
       }
     }
     return '';
   },
   create() {
     if (this.validateCreate()) {
       setTimeout(this.createObject);
     }
   },
   get_text_iva(id_iva) {
     let text=id_iva
     let res = this.tabs[this.currentTab].vats.find(x=>(x.vat==id_iva))
     if(res){
       text=res.label
     }
     if((id_iva == 'vat_0' || id_iva=='igic_0') && !this.got_feature('feature_exenta_no_sujeta') && !['intra', 'extra', 'isps'].includes(this.tabs[this.currentTab].name)){
       text = '0%'
     }
     return text
   },
   check_operation() {
       if(this.companydb.last_operation_state=='Configurando...'){
         client.get(this.url+this.companydb.id).then((response) => {
           this.companydb = response.data
           setTimeout(this.check_operation, 2000)
         }).catch(err=>{
           console.error(err)
           setTimeout(this.check_operation, 2000)
         });
       }
       else{
         this.creating=false
         this.show_message=false;
         this.setCompanydbs();
       }
   },
   isValidDate(d_str){
     return isValidDate(d_str)
   },
   create_companydb() {
     return new Promise((resolve, reject) => {
       let params = {
         num_digits:this.currentCon.num_digits,
         json_links:JSON.stringify(this.currentCon.links),
         companydb_type_id:this.currentCon.companydb_type.id,
         oauth_session:this.currentCon.oauth_session,
         configuration:this.currentCon.configuration,
       };
       if (this.currentCon.location_fk_id) {
         params['location_id'] = this.currentCon.location_fk_id;
       }
       if (this.currentCon.iva_igic_no_deducible) {
         params['iva_igic_no_deducible'] = this.currentCon.iva_igic_no_deducible;
       }
       if (this.isTypeCSV()) {
        params['name'] = this.currentCon.name;
        params['cif'] = this.currentCon.cif;
        params['tax_type'] = this.currentCon.tax_type;
       }
       client.post(this.url, params).then((response) => {
           this.errors = {}
           resolve(response)
           this.$router.replace({ name: "connector-update", params: {id:response.data.id} });
       }).catch(err=>{
         this.errors = JSON.parse(err.request.response);
         reject(err);
       });
     })
   },
   companyAsPartyEditorClose(party) {
    this.company_as_party = party;
   },
   update_companydb() {
     return new Promise((resolve, reject) => {
       setTimeout(()=>{
         this.errors = {};
         let params = {
           companydb_type_id:this.currentCon.companydb_type.id,
           name:this.currentCon.name,
           cif:this.currentCon.cif,
           tax_type:this.currentCon.tax_type,
           configuration:this.currentCon.configuration,
           review:this.currentCon.review,
           cartera_supplier:this.currentCon.cartera_supplier,
           cartera_customer:this.currentCon.cartera_customer,
           cuenta_cartera_supplier:this.currentCon.cuenta_cartera_supplier,
           cuenta_cartera_customer:this.currentCon.cuenta_cartera_customer,
           tolerancy:this.currentCon.tolerancy,
           path_supplier_folder:this.currentCon.path_supplier_folder,
           path_customer_folder:this.currentCon.path_customer_folder,
           iva_igic_no_deducible:this.currentCon.iva_igic_no_deducible,
           comerciante_minorista:this.currentCon.comerciante_minorista,
           apply_415: this.currentCon.apply_415,
           num_digits:this.currentCon.num_digits,
           json_links:JSON.stringify(this.currentCon.links),
           automatic_payment_account: this.currentCon.automatic_payment_account,
           payment_account : this.currentCon.payment_account,
           automatic_charge_account: this.currentCon.automatic_charge_account,
           charge_account : this.currentCon.charge_account,
           to_upper: this.currentCon.to_upper,
           tagline_in_invoice: this.currentCon.tagline_in_invoice,
           tagline_out_invoice: this.currentCon.tagline_out_invoice,
           have_serie: this.currentCon.have_serie,
           series: this.currentCon.series,
           cut_inv_num: this.currentCon.cut_inv_num,
           // num_chars_inv_num: this.currentCon.num_chars_inv_num,
           cut_cus_inv_num: this.currentCon.cut_cus_inv_num,
           tagline_payment_move: this.currentCon.tagline_payment_move,
           tagline_charge_move: this.currentCon.tagline_charge_move,
           search_third_aprox: this.currentCon.search_third_aprox,
           iva_agrario_pesca: this.currentCon.iva_agrario_pesca,
           iva_tabaco: this.currentCon.iva_tabaco,
           check_ret: this.currentCon.check_ret,
           auto_fill_due_date: this.currentCon.auto_fill_due_date,
           prorate: this.currentCon.prorate,
           invoice_description_order: this.currentCon.invoice_description_order,
           decimal_separator: this.currentCon.decimal_separator,
           max_price: this.currentCon.max_price,
           min_price: this.currentCon.min_price,
           //third_selector_values: this.currentCon.third_selector_values,
           criterio_de_caja: this.currentCon.criterio_de_caja,
           abono_keywords: this.currentCon.abono_keywords,
           check_cif_in_docs: this.currentCon.check_cif_in_docs,
           required_project:this.currentCon.required_project,
           alfastar_serie_in: this.currentCon.alfastar_serie_in,
           alfastar_serie_out: this.currentCon.alfastar_serie_out,
           report_sii: this.currentCon.report_sii,
           hide_projects_master: this.currentCon.hide_projects_master,
           hide_channels_master: this.currentCon.hide_channels_master,
           hide_activities_master: this.currentCon.hide_activities_master,
           external_password: this.currentCon.external_password,
         }
         if (this.currentCon.min_price==''){
           params['min_price']=null
         }
         if (this.currentCon.max_price==''){
           params['max_price']=null
         }
         if (this.currentCon.tolerancy<0.005){
           params['tolerancy']=0.005
         }
         if (this.currentCon.cut_inv_num != 'no_cut') {
           if (this.currentCon.num_chars_inv_num) {
             params['num_chars_inv_num'] = this.currentCon.num_chars_inv_num;
           } else {
             this.errors['num_chars_inv_num'] = 'El campo número de caracteres a mantener es obligatorio.'
           }
           params['chars_to_exclude'] = this.currentCon.chars_to_exclude;
         }

         if (this.currentCon.cut_cus_inv_num != 'no_cut') {
           if (this.currentCon.num_chars_cus_inv_num) {
             params['num_chars_cus_inv_num'] = this.currentCon.num_chars_cus_inv_num;
           } else {
             this.errors['num_chars_cus_inv_num'] = 'El campo número de caracteres a mantener es obligatorio.'
           }
           params['chars_to_exclude_cus'] = this.currentCon.chars_to_exclude_cus;
         }

         if (this.currentCon.location_fk_id) {
           params['location_id'] = this.currentCon.location_fk_id;
         }
         // if (this.currentCon.third_selector_values.length < 1) {
         //   this.errors['third_selector_values'] = 'Los valores del selector de terceros no pueden estar vacíos.'
         // }

         if (this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('taxes_table')) {
           params['taxes'] = this.currentCon.taxes;
         }
         if (this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('number_series_table')) {
           params['taxes'] = this.currentCon.taxes;
         }
         if (this.company_as_party && this.been_in_einvoice_tab){
           params['configuration']['company_as_party'] = this.company_as_party.toPrimitive(this.company_as_party);
         }
         if (Object.keys(this.errors).length == 0) {
           client.patch('companydbs_detail/'+this.currentCon.id+'/', params).then((response) => {
             this.errors = {}
             resolve(response)
           }).catch(err=>{
             this.errors = JSON.parse(err.request.response);
             reject(err);
           });
         } else {
           reject(this.errors);
         }
       })
     })
   },
   updateTaxes(val) {
     this.currentCon.taxes = val;
   },
   updateNumberSeries(val) {
     this.currentCon.taxes = val;
   },
   closeMessage() {
     this.show_message=false;
     this.$router.push({name: 'connectors'});
   },

   openDialogNoUsersCreated() {
      this.setMessageModal({
        text: 'No existen usuarios pendientes de añadir permisos a esta empresa.',
        actionConfirmButton: this.closeMessageModal
      })
    },

    openAddUserDialog() {
     this.modal_add_user.list_users_select = [];
     this.getFreeInvitedUsers(this.id).then((response) => {
       this.modal_add_user.list_users_select = response.data.results;
       if (this.modal_add_user.list_users_select.length > 0) {
          if (this.$refs && this.$refs.addUserDialogForm) {
            this.$refs.addUserDialogForm.reset();
          }
          this.resetModalAddUserValues();
          this.addUserDialog = true;
       } else {
         this.openDialogNoUsersCreated();
       }
     }).catch((error) => {
       console.error(error);
     })
   },

   openCreateUserDialog() {
     if (this.$refs && this.$refs.createUserDialogForm) {
         this.$refs.createUserDialogForm.reset();
     }
     this.resetModalNewUserValues();
     this.createUserDialog = true;
   },

   openActivitytDialog() {
     if (this.$refs && this.$refs.amActivityDialogForm) {
         this.$refs.amActivityDialogForm.reset();
     }
     this.resetAMActivity();
     this.amActivityDialog = true;
   },
   openColumnOrderDialog() {
     this.csv_one_line_dialog = true;

   },
   async openExcelColumnsDialog(){
     await this.getColumnsExcel(this.id);
     this.excel_columns_dialog = true;
   },
   clickChannelTableActionBtn(action, item) {
     if (action == 'update_channel') {
       this.channelToUpdate = item;
       this.newChannel.name = item.name;
       this.newChannel.external_id = item.external_id;
       this.amChannelDialog = true;
     }
   },
   clickActivityTableActionBtn(action, item) {
     if (action == 'update_activity') {
       this.activityToUpdate = item;
       this.newActivity.name = item.name;
       this.newActivity.code = item.code;
       this.amActivityDialog = true;
     }
   },

   openAccountDialog() {
     if (this.$refs && this.$refs.amAccountDialogForm) {
         this.$refs.amAccountDialogForm.reset();
     }
     this.resetAMAccount();
     this.amAccountDialog = true;
   },

   clickAccountTableActionBtn(action, item) {
     if (action == 'update_account') {
       this.accountToUpdate = item;
       this.newAccount.account = item.account;
       this.newAccount.description = item.description;
       this.amAccountDialog = true;
     }
   },

   selectedItemsAccountChanged(items, selected_all_items, search_params) {
     this.accountSearchFiltersInfo = search_params;
     this.accountsAllSelected = selected_all_items;
     this.accountsSelected = items.map(function(item) {
       return item['id'];
     });
   },

   openInfo() {
     this.info_dialog = true;
   },

   selectedItemsProjectChanged(items, selected_all_items, search_params) {
     this.projectSearchFiltersInfo = search_params;
     this.projectsAllSelected = selected_all_items;
     this.projectsSelected = items.map(function(item) {
       return item['id'];
     });
   },

   selectedItemsCompanyRefsChanged(items, selected_all_items) {
     console.log(items, selected_all_items)
     this.companyRefsAllSelected = selected_all_items;
     this.companyRefsSelected = items
   },

   openProjectDialog() {
     if (this.$refs && this.$refs.amProjectDialogForm) {
         this.$refs.amProjectDialogForm.reset();
     }
     this.resetAMProject();
     this.amProjectDialog = true;
   },

   openCompanyRefsDialog() {
     if (this.$refs && this.$refs.amCompanyRefsDialogForm) {
         this.$refs.amCompanyRefsDialogForm.reset();
     }
     this.resetAMCompanyRef();
     this.amCompanyRefsDialog = true;
   },

   resetAMCompanyRef() {
     this.newCompanyReference.company_id = null;
     this.newCompanyReference.reference = '';
     this.companyRefToUpdate = null;
   },

   resetAMProject() {
     this.newProject.name = "";
     this.newProject.external_id = "";
     this.newProject.references = [];
     this.projectToUpdate = null;
   },

   cancelAMProject() {
     this.amProjectDialog = false;
     this.resetAMProject();
   },

   cancelAMChannel() {
     this.amChannelDialog = false;
     this.resetAMChannel();
   },

   clickProjectTableActionBtn(action, item) {
     if (action == 'update_project') {
       this.projectToUpdate = item;
       this.newProject.name = item.name;
       this.newProject.external_id = item.external_id;
       this.newProject.references = [];
       if(item.references) {
         this.newProject.references = [...item.references];
       }
       this.amProjectDialog = true;
     }
   },

   clickCompanyRefsTableActionBtn(action, item) {
     console.log(action,item)
     if (action == 'update_reference') {
       this.companyRefToUpdate = item;
       this.newCompanyReference.company_id = item.company_id;
       this.newCompanyReference.reference = item.reference;
       this.amCompanyRefsDialog = true;
     }
   },


   openChannelDialog() {
     if (this.$refs && this.$refs.amChannelDialogForm) {
       this.$refs.amChannelDialogForm.reset();
     }
     this.resetAMChannel();
     this.amChannelDialog = true;
   },

   resetAMChannel() {
     this.newChannel.name = "";
     this.newChannel.external_id = "";
     this.newChannel.references = [];
     this.channelToUpdate = null;
   },

   clickChannelTableActionBtn(action, item) {
     if (action == 'update_channel') {
       this.channelToUpdate = item;
       this.newChannel.name = item.name;
       this.newChannel.external_id = item.external_id;
       this.newChannel.references = [];
       if(item.references) {
         this.newChannel.references = [...item.references];
       }
       this.amChannelDialog = true;
     }
   },


   add_ref(){
     this.newProject.references.push('')
   },
   del_ref(i){
     this.newProject.references.splice(i,1)
   },
   add_channel_ref() {
     this.newChannel.references.push('')
   },
   del_channel_ref() {
     this.newChannel.references.splice(i,1)
   },

   openDeleteProjectDialog() {
     this.deleteProjectDialog = true;
   },
   noDeleteProject() {
     this.deleteProjectDialog = false;
   },

   noDeleteChannel() {
     this.deleteChannelDialog = false;
   },
   noDeleteExpensIncomeType() {
     this.deleteExpensIncomeTypeDialog = false;
   },
   deleteProjectsDone() {
     this.refreshProjectsList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   deleteRefsDone() {
     this.refreshCompanyRefsList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   refreshProjectsList() {
     if (this.$refs.projectsTable) {
       this.projectsLoading = true;
       this.$refs.projectsTable.getItems().then(() => {
         this.projectsLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   refreshCompanyRefsList() {
     if (this.$refs.companyReferencesTable) {
       this.companyRefsLoading = true;
       this.$refs.companyReferencesTable.getItems().then(() => {
         this.companyRefsLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   confirmAMProject() {
     if (this.projectToUpdate) {
       this.updateProject();
     }
     else {
       this.createProject();
     }
   },

   confirmAMCompanyRefs() {
     if (this.companyRefToUpdate) {
       this.updateCompanyRef();
     }
     else {
       this.createCompanyRef();
     }
   },

   cancelAMCompanyRefs() {
     this.amCompanyRefsDialog = false;
     this.resetAMCompanyRef();
   },

   confirmAMChannel() {
     if (this.channelToUpdate) {
       this.updateChannel();
     } else {
       this.createChannel();
     }
   },

   cleanAMProjectReferences() {
     let i = 0;
     while(i < this.newProject.references.length) {
       if(this.newProject.references[i] == '') {
         this.newProject.references.splice(i,1);
         i-=1;
       }
       i+=1;
     }
   },

   cleanAMChannelReferences() {
     let i = 0;
     while (i < this.newChannel.references.length) {
       if (this.newChannel.references[i] == '') {
         this.newChannel.references.splice(i,1);
         i-=1;
       }
       i+=1;
     }
   },

   async createCompanyRef(){
     this.amCompanyRefsLoading = true;
     console.log('creatin', this.newCompanyReference)
     await new AddCompanyReference(sync_command_dispatcher).run(this.id, this.newCompanyReference)
     this.resetAMCompanyRef();
     this.refreshCompanyRefsList();
     this.setSnackbar('success', this.textSnackbarOk);
     this.amCompanyRefsLoading = false;
     this.amCompanyRefsDialog = false;
   },

   async updateCompanyRef(){
     
     this.amCompanyRefsLoading = true;
     let old_ref = {'company_id': this.companyRefToUpdate.company_id, 'reference': this.companyRefToUpdate.reference}
     await new UpdateCompanyReference(sync_command_dispatcher).run(this.id, this.newCompanyReference, old_ref)
     this.resetAMCompanyRef();
     this.refreshCompanyRefsList();
     this.setSnackbar('success', this.textSnackbarOk);
     this.amCompanyRefsLoading = false;
     this.amCompanyRefsDialog = false;
   },

   async deleteCompanyRef(){
     
     this.amCompanyRefsLoading = true;
     let ref_to_delete = {'company_id': this.companyRefToUpdate.company_id, 'reference': this.companyRefToUpdate.reference}
     await new DeleteCompanyReferences(sync_command_dispatcher).run(this.id, ref_to_delete)
     this.resetAMCompanyRef();
     this.deleteRefsDone()
     this.amCompanyRefsLoading = false;
     this.amCompanyRefsDialog = false;
     
   },

   async createProject(){
     this.amProjectLoading = true;
     const formIsValid = this.$refs.amProjectDialogForm.validate();
     if (formIsValid) {
       this.cleanAMProjectReferences();
       let params =  {
           "name": this.newProject.name,
           "external_id": this.newProject.external_id,
           "companydb": this.id,
           "references":this.newProject.references,
       }
       await this.createConnProject(params).then(response => {
         this.amProjectLoading = false;
         this.amProjectDialog = false;
         this.resetAMProject();
         this.refreshProjectsList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amProjectLoading = false;
       });
     }
     else {
       this.amProjectLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async updateProject(){
     this.amProjectLoading = true;
     const formIsValid = this.$refs.amProjectDialogForm.validate();
     if (formIsValid) {
       this.cleanAMProjectReferences();
       let params =  {
           "name": this.newProject.name,
           "external_id": this.newProject.external_id,
           "project": this.projectToUpdate.id,
           "references":this.newProject.references,
       }
       await this.updateConnProject(params).then(response => {
         this.amProjectLoading = false;
         this.amProjectDialog = false;
         this.resetAMProject();
         this.refreshProjectsList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amProjectLoading = false;
       });
     }
     else {
       this.amProjectLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async deleteProject(){
     let params = {
         project_ids : this.projectsSelected,
         search_filters: this.projectSearchFiltersInfo,
         companydb_id: this.id
     };
     let response =  await this.deleteConnProject(params)
       if (response.hasOwnProperty("error")) {
         this.setSnackbar('error', response.error);
       } else {
         this.deleteProjectsAsyncJob = response['AsyncJob'];
         this.deleteProjJobState = 'running';
         this.projectsSelected = [];
         this.deleteProjectDialog = false;
       }
   },




   async createChannel(){
     this.amChannelLoading = true;
     const formIsValid = this.$refs.amChannelDialogForm.validate();
     if (formIsValid) {
       this.cleanAMChannelReferences();
       let params =  {
           "name": this.newChannel.name,
           "external_id": this.newChannel.external_id,
           "companydb": this.id,
           "references":this.newChannel.references,
       }
       await this.createConnChannel(params).then(response => {
         this.amChannelLoading = false;
         this.amChannelDialog = false;
         this.resetAMChannel();
         this.refreshChannelsList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amChannelLoading = false;
       });
     }
     else {
       this.amChannelLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async updateChannel(){
     this.amChannelLoading = true;
     const formIsValid = this.$refs.amChannelDialogForm.validate();
     if (formIsValid) {
       this.cleanAMChannelReferences();
       let params =  {
           "name": this.newChannel.name,
           "external_id": this.newChannel.external_id,
           "channel": this.channelToUpdate.channel_id,
           "references":this.newChannel.references,
       }
       await this.updateConnChannel(params).then(response => {
         this.amChannelLoading = false;
         this.amChannelDialog = false;
         this.resetAMChannel();
         this.refreshChannelsList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amChannelLoading = false;
       });
     }
     else {
       this.amChannelLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async deleteChannel(){
     let params = {
       channel_ids : this.channelsSelected,
       search_filters: this.channelSearchFiltersInfo,
       companydb_id: this.id
     };
     let response =  await this.deleteConnChannel(params)
     if (response.hasOwnProperty("error")) {
       this.setSnackbar('error', response.error);
     } else {
       this.deleteChannelsAsyncJob = response['AsyncJob'];      
       this.deleteChannelJobState = 'running';
       this.channelsSelected = [];
       this.deleteChannelDialog = false;
     }
   },

   selectedItemsChannelChanged(items, selected_all_items, search_params) {
     this.channelSearchFiltersInfo = search_params;
     this.channelsAllSelected = selected_all_items;
     this.channelsSelected = items.map(function(item) {
       return item['channel_id'];
     });
   },


   confirmAMActivity() {
     if (this.activityToUpdate) {
       this.updateActivity();
     }
     else {
       this.createActivity();
     }
   },

   async createActivity(){
     this.amActivityLoading = true;
     const formIsValid = this.$refs.amActivityDialogForm.validate();
     if (formIsValid) {
       await this.createConnActivity({code:this.newActivity.code, name: this.newActivity.name}).then(response => {
         this.amActivityLoading = false;
         this.amActivityDialog = false;
         this.resetAMActivity();
         this.refreshActivitiesList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amActivityLoading = false;
       });
     }
     else {
       this.amActivityLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async updateActivity() {
     this.amActivityLoading = true;
     const formIsValid = this.$refs.amActivityDialogForm.validate();
     if (formIsValid) {
       let params = {code:this.newActivity.code, name: this.newActivity.name, activity : this.activityToUpdate.id}
       await this.updateConnActivity(params).then(response => {
         this.amActivityLoading = false;
         this.amActivityDialog = false;
         this.resetAMActivity();
         this.refreshActivitiesList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amActivityLoading = false;
       });
     }
     else {
       this.amActivityLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async deleteActivity() {
     let params = {
         act_ids : this.activitiesSelected,
         search_filters: this.activitySearchFiltersInfo,
         companydb_id: this.id
     };
     let response =  await this.deleteConnActivity(params)
       if (response.hasOwnProperty("error")) {
         this.errors = { "error": response.error }
         this.errorDialog = true;
         this.errorMsg = response.error;
       } else {
         this.deleteActivitiesAsyncJob = response['AsyncJob'];
         this.deleteActJobState = 'running';
         this.activitiesSelected = [];
         this.deleteActivityDialog = false;
       }
   },

   selectedItemsActivityChanged(items, selected_all_items, search_params) {
     this.activitySearchFiltersInfo = search_params;
     this.activitiesAllSelected = selected_all_items;
     this.activitiesSelected = items.map(function(item) {
       return item['id'];
     });
   },

   openNewLoadPathDialog() {
     this.cancelAMLoadPath()
     this.amLoadPathDialog = true;
   },

   clickLoadPathTableActionBtn(action, item) {
     if (action == 'update_load_path') {
       this.loadPathToUpdate = item;
       this.newLoadPath.load_path_type = item.load_path_type.id;
       this.newLoadPath.path = item.path;
       this.newLoadPath.doc_kind = item.doc_kind;
       this.newLoadPath.split_doc = item.split_doc;
       this.newLoadPath.accounting_date = item.accounting_date;
       this.newLoadPath.configurated = item.configurated;
       this.newLoadPath.activity = item.activity;
       this.newLoadPath.project = item.project;
       this.newLoadPath.channel = item.channel;
      //  this.newLoadPath.values = item.values;
       this.newLoadPath.oauth_session = item.oauth_session;
       this.newLoadPath.email_prefix = ''
       this.newLoadPath.only_new_files = item.only_new_files;
       this.newLoadPath.accept_pdf_only = item.accept_pdf_only;
       this.newLoadPath.allow_check_only_new_files = item.allow_check_only_new_files;
       if(item.email){
         this.newLoadPath.email_prefix = item.email.split("@")[0];
       }
       this.amLoadPathDialog = true;
     }
   },

   selectedItemsLoadPathChanged(items, selected_all_items, search_params) {
     this.loadPathSearchFiltersInfo = search_params;
     this.loadPathsAllSelected = selected_all_items;
     this.loadPathsSelected = items.map(function(item) {
       return item['id'];
     });
   },

    beforeconfirmAMLoadPath() {
      if (this.newLoadPath.allow_check_only_new_files && this.loadPathSessionlabel != 'Email') {
        if (this.newLoadPath.only_new_files) {
          this.loadPathAlertMsg = 'Ha marcado que solo se carguen los ficheros nuevos, cualquier fichero que ya estuviese en el punto de carga no se cargará.'
        } else {
          this.loadPathAlertMsg = 'Ha desmarcado que se carguen todos los ficheros, cualquier fichero que ya estuviese en el punto de carga y que previamente no se cargó, se cargará. (Esta acción es irreversible)'
        }
        this.loadPathAlertPopup = true;
        return true;
      }
      else {
        return false;
      }
    },

    confirm(){
      let alertVisible = this.beforeconfirmAMLoadPath();
      return new Promise((resolve,reject)=>{
        if (!alertVisible) {
          resolve(true)
        } else {
          this.resolveLoadPathAlert = resolve;
        }
      })
    },
    confirmLoadPathAlertPopup(res){
      this.loadPathAlertPopup = false;
      this.resolveLoadPathAlert(res)
    },

    confirmAMLoadPath() {
      this.newLoadPath.email = this.newLoadPath.email_prefix + this.userData.email_entrypoint_domain;
      if (this.loadPathToUpdate) {
        this.updateLoadPath();
      }
      else {
        this.createLoadPath();
      }
    },

   async createLoadPath() {
     this.loadPathsLoading = true;
     let formIsValid = this.$refs.amLoadPathDialogForm.validate();
     if (formIsValid){
       await this.confirm().then(async (res) => {
        if (res) {
          await this.createConnLoadPath({ load_path_data: this.newLoadPath}).then(response => {
            this.loadPathsLoading = false;
            if (response.hasOwnProperty("error")) {
              this.setSnackbar('error', response['error']);
            }
            else {
              this.loadPathsLoading = false;
              this.amLoadPathDialog = false;
              this.resetAMLoadPath();
              this.refreshLoadPathsList();
              this.setSnackbar('success', this.textSnackbarOk);
            }
          }).catch(error => {
            console.error(error);
            if (error.response.status === 400) {
              this.setSnackbar('error', error.response.data.detail);
            }
            else {
              this.setSnackbar('error', this.textSnackbarKoApi);
            }
            this.loadPathsLoading = false;
          });
        } else {
          this.loadPathsLoading = false;
        }
       })
     }
     else {
       this.loadPathsLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   selectedItemsExpensIncomeTypeChanged(items, selected_all_items, search_params) {
     this.expensIncomeTypeSearchFiltersInfo = search_params;
     this.expensIncomeTypeAllSelected = selected_all_items;
     this.expensIncomeTypeSelected = items.map(function(item) {
       return item['eit_id'];
     });
   },


   async updateLoadPath() {
     this.loadPathsLoading = true;
     let formIsValid = this.$refs.amLoadPathDialogForm.validate();
     if (formIsValid){
        await this.confirm().then(async (res) => {
          if (res) {
            let params = {load_path : this.loadPathToUpdate.id, load_path_data: this.newLoadPath};
            await this.updateConnLoadPath(params).then(response => {
              if (response.hasOwnProperty("error")) {
                this.setSnackbar('error', response['error']);
                this.loadPathsLoading = false;
              }
              else {
                this.loadPathsLoading = false;
                this.amLoadPathDialog = false;
                this.resetAMLoadPath();
                this.refreshLoadPathsList();
                this.setSnackbar('success', this.textSnackbarOk);
              }
            }).catch(error => {
              console.error(error);
              if (error.response.status == 400) {
                this.setSnackbar('error', error.response.data.detail[0]);
              }
              else {
                this.setSnackbar('error', this.textSnackbarKoApi);
              }
              this.loadPathsLoading = false;
            });
          } else {
            this.loadPathsLoading = false;
          }
        })
     }
     else {
       this.loadPathsLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },

   async deleteLoadPath() {
     let params = {
         loadpath_ids : this.loadPathsSelected,
         search_filters: this.loadPathSearchFiltersInfo,
         companydb_id: this.id
     };
     let response =  await this.deleteConnLoadPath(params)
       if (response.hasOwnProperty("error")) {
         this.errors = { "error": response.error }
         this.errorDialog = true;
         this.errorMsg = response.error;
       } else {
         this.deleteLoadPathsAsyncJob = response['AsyncJob'];
         this.deleteLoadPathJobState = 'running';
         this.loadPathsSelected = [];
         this.deleteLoadPathDialog = false;
       }
   },

   noSetPathFolder(){
     this.folderManagerDialog = false;
     this.amLoadPathDialog = true;
     this.activeFolder = [];
     this.openFolder = [{path:""}];
     this.folderItems = [];
   },

   reOpenFolderSelector(){
     this.pathConfirmationDialog = false;
     this.folderManagerDialog = true;
   },

   validatePathFolder(){
     if (this.activeFolder.length > 0 && this.activeFolder[0].path) {
       let currentPath = this.activeFolder[0].path;
       let {load_path_type,path} = this.newLoadPath;
       const filtered_load_paths = this.currentCon.load_paths.filter((item)=> item.path !== null)
       let exists = filtered_load_paths.find((item)=> (currentPath.startsWith(item.path.path) || item.path.path.startsWith(currentPath)) && item.load_path_type.id === load_path_type && path.path != item.path.path)
       let exists_equal = filtered_load_paths.find((item)=> currentPath === item.path.path && path.path !== item.path.path && item.load_path_type.id === load_path_type)

       if (exists_equal){
         this.folderWarningMessage = `La ruta seleccionada: "${exists.path.display_path}" ya existe. Los mismos Documentos se cargarán de ambos puntos de carga.`
         this.pathConfirmationDialog = true;
         this.folderManagerDialog = false;
       }
       else if(exists) {
         this.folderWarningMessage = `La ruta seleccionada está incluida en la ruta "${exists.path.display_path}". Los mismos Documentos se cargarán de ambos puntos de carga.`
         this.pathConfirmationDialog = true;
         this.folderManagerDialog = false;
       }
       else{
         this.setPathFolder();
       }
     }
     else {
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },

   setPathFolder(){
     this.folderManagerDialog = false;
     this.amLoadPathDialog = true;
     this.pathConfirmationDialog = false;
     this.newLoadPath.path = this.activeFolder[0];
     this.activeFolder = [];
     this.openFolder = [{path:""}];
     this.folderItems = [];
   },
   async loadChildren(item){
     if (item.path){
       let {data,status} = await this.getFolders({session:this.newLoadPath.oauth_session,path:item.path,showReadOnly:this.showReadOnly})
       if (status === 200){
         if (data.hasOwnProperty('AsyncJob')) {
           const outputInfo = await this.loadChildrenJobDone(data['AsyncJob']);
           if (outputInfo) {
             item.children.push(...outputInfo)
           }
         }
         else{
           item.children.push(...data)
         }
       }
     }
   },
   async loadChildrenJobDone(asyncJobId){
     return new Promise((resolve, reject) => {
       this.loadChildrenInterval = setInterval(() => {
         jobs.getJob({ id: asyncJobId })
           .then((response) => {
             if (response.data.state === 'done') {
               clearInterval(this.loadChildrenInterval);
               resolve(response.data.output_info);
             }
         })
         .catch(error => {
           clearInterval(this.loadChildrenInterval);
           reject(error);
       });
       }, 2000);
     });         
   },
   async openFolderSelectorJobDone() {
     let response = await jobs.getJob({ id: this.openFolderSelectorJobId });
     const data = response.data;
     const status = data.state;
     
     this.openFolderSelectorJobState = status;
     
     if (status === 'error') {
       console.log('Error!!!!')
     } else {
       if (data.output_info.hasOwnProperty("status") && data.output_info.status == 401) {
         this.folderManagerDialog = false;
         this.connectDialog= true;
       } else {
         this.folderItems = data.output_info;
         this.loadingFolders = false;
       }
     }
   },
   async openFolderSelector(){
     this.amLoadPathDialog = false;
     this.folderManagerDialog = true;
     this.loadingFolders = true
     let {data, status} = await this.getFolders({session:this.newLoadPath.oauth_session,path:''})
     this.loadingFolders = false;      
     if (status === 200) {
       if (data.hasOwnProperty('AsyncJob')) {
         this.openFolderSelectorJobState = 'running';
         this.openFolderSelectorJobId = data['AsyncJob'];
       } else {
         this.folderItems = data;
         this.loadingFolders = false
       }
     } else if (status === 401) {
       this.folderManagerDialog = false;
       this.connectDialog= true;
     }
   },
   resetAMLoadPath() {
     this.newLoadPath.load_path_type = '';
     this.newLoadPath.path = {path:"", display_path:""};

     this.newLoadPath.doc_kind = '';
     this.newLoadPath.split_doc = false;
     this.newLoadPath.accounting_date = '';
     this.newLoadPath.configurated = null;
     this.newLoadPath.activity = '';
     this.newLoadPath.project = null;
     this.newLoadPath.oauth_session = null;
    //  this.newLoadPath.values = {};
     this.newLoadPath.email_prefix = '';
     this.newLoadPath.only_new_files = true;
     this.newLoadPath.accept_pdf_only = false;
     this.newLoadPath.allow_check_only_new_files = true;
     this.loadPathToUpdate = null;
   },

   cancelAMLoadPath() {
     this.amLoadPathDialog = false;
     this.resetAMLoadPath();
     if(this.$refs.amLoadPathDialogForm){
       this.$refs.amLoadPathDialogForm.resetValidation();
     }
   },

   deleteLoadPathsDone() {
     this.refreshLoadPathsList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   refreshLoadPathsList() {
     if (this.$refs.loadPathsTable) {
       this.loadPathsLoading = true;
       this.$refs.loadPathsTable.getItems().then(() => {
         this.loadPathsLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   openDeleteLoadPathDialog() {
     this.deleteLoadPathDialog = true;
   },

   noDeleteLoadPath() {
     this.deleteLoadPathDialog = false;
   },

   closeSessionDialog() {
     this.connectDialog = false;
     if (!this.currentCon.id)
       this.currentCon.oauth_session = null;
     else
       this.newLoadPath.oauth_session = null;
   },

   confirmConnectOuth2User: function (mail) {
     if (mail){
       this.connect_outh2user_data.state+=`,${mail}`
     }
     this.connectOuth2User(this.connect_outh2user_data);
   },

   async session_selected(){
     this.openid_users.forEach(element => {
       if (element.id === this.currentCon.oauth_session){
         this.currentCon.oauth_session_state = element.state
       }
     });
     if (this.currentCon.oauth_session && this.currentCon.oauth_session != 0 && this.currentCon.oauth_session_state === 'ok') {
       this.loading_oauth_cdbs = true;
       this.openid_companies = await this.getUserCompanies(this.currentCon.oauth_session);
       this.loading_oauth_cdbs = false;
     }
     else{
       this.connectDialog= true;
     }
   },
   async storage_session_selected(){
     this.storage_openid_users.forEach(element => {
       if (element.id === this.newLoadPath.oauth_session){
         this.newLoadPath.oauth_session_state = element.state
       }
     });
     if (this.newLoadPath.oauth_session && this.newLoadPath.oauth_session != 0 && this.newLoadPath.oauth_session_state === 'ok') {
       this.newLoadPath.path={path:"", display_path:""};
     }
     else{
       this.connectDialog= true;
     }
   },
   closeTermsDialog(){
     this.contract_dialog = false;
     this.newLoadPath.load_path_type = null;
   },
   async saveTermsDialog(){
     this.contract_dialog = false;
     const response = await api_user.setUserInfo(
       {
         privacy_policy_contract:this.privacy_policy_contract,
         terms_accepted:true,
       }
     );
     this.setUserData(response.data.results);
     this.setLoadPathTypes();
   },
   getContractData(data) {
     this.privacy_policy_contract = data['full_version']
   },
   async load_path_type_selected(){
     let load_path_type_id = this.newLoadPath.load_path_type
     let storage = this.load_path_types.find(({ id }) => id === load_path_type_id)
     if (storage.show_contract_dialog === true){
       this.contract_dialog = true;
     }
     this.oauth_message = this.get_oauth_message(storage.name)
     this.connect_outh2user_data = {"state": this.currentCon.id, 'value':storage.value}
     this.newLoadPath.oauth_session=null;
   },

   deleteAccountsDone() {
     this.refreshAccountsList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   refreshAccountsList() {
     if (this.$refs.accountsTable) {
       this.accountsLoading = true;
       this.$refs.accountsTable.getItems().then(() => {
         this.accountsLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   confirmAMAccount() {
     if (this.accountToUpdate) {
       this.updateAccount();
     }
     else {
       this.createAccount();
     }
   },

   async createAccount() {
     this.amAccountLoading = true;
     const formIsValid = this.$refs.amAccountDialogForm.validate();
     if (formIsValid) {
       await this.createConnAccount({ account: this.newAccount.account, description: this.newAccount.description}).then(response => {
         if (response.hasOwnProperty("error")) {
           this.setSnackbar('error', response['error']);
           this.amAccountLoading = false;
         }
         else {
           this.amAccountLoading = false;
           this.amAccountDialog = false;
           this.resetAMAccount();
           this.refreshAccountsList();
           this.setSnackbar('success', this.textSnackbarOk);
         }
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amAccountLoading = false;
       });
     }
     else {
       this.amAccountLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async updateAccount() {
     this.amAccountLoading = true;
     const formIsValid = this.$refs.amAccountDialogForm.validate();
     if (formIsValid) {
       let params = {
         account : this.newAccount.account,
         description : this.newAccount.description,
         account_id : this.accountToUpdate.id
       };
       await this.updateConnAccount(params).then(response => {
         if (response.hasOwnProperty("error")) {
           this.setSnackbar('error', response['error']);
           this.amAccountLoading = false;
         }
         else {
           this.amAccountLoading = false;
           this.amAccountDialog = false;
           this.resetAMAccount();
           this.refreshAccountsList();
           this.setSnackbar('success', this.textSnackbarOk);
         }
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.amAccountLoading = false;
       });
     }
     else {
       this.amAccountLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   async deleteAccounts() {
     let params = {
         acc_ids : this.accountsSelected,
         search_filters: this.accountSearchFiltersInfo,
         companydb_id: this.id
     };
     let response =  await this.deleteConnAccounts(params)
       if (response.hasOwnProperty("error")) {
         this.errors = { "error": response.error }
         this.errorDialog = true;
         this.errorMsg = response.error;
       } else {
         this.deleteAccountsAsyncJob = response['AsyncJob'];
         this.deleteAccJobState = 'running';
         this.accountsSelected = [];
         this.deleteAccountsDialog = false;
       }
   },

   deleteChannelsDone() {
     this.refreshChannelsList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },
   refreshChannelsList() {
     if (this.$refs.channelsTable) {
       this.channelsLoading = true;
       this.$refs.channelsTable.getItems().then(() => {
         this.channelsLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },
   deleteActivitiesDone() {
     this.refreshActivitiesList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   refreshActivitiesList() {
     if (this.$refs.activitiesTable) {
       this.activitiesLoading = true;
       this.$refs.activitiesTable.getItems().then(() => {
         this.activitiesLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },
   async deleteExpensIncomeType(){
     let params = {
       eit_ids : this.expensIncomeTypeSelected,
       search_filters: this.expensIncomeTypeSearchFiltersInfo,
       companydb_id: this.id
     };
     let response =  await this.deleteConnExpensIncomeType(params)
     if (response.hasOwnProperty("error")) {
       this.setSnackbar('error', response.error);
     } else {
       this.deleteExpensIncomeTypeAsyncJob = response['AsyncJob'];
       this.deleteExpensIncomeTypeJobState = 'running';
       this.expensIncomeTypeSelected = [];
       this.deleteExpensIncomeTypeDialog = false;
     }
   },
   deleteExpensIncomeTypeDone() {
     this.refreshExpensIncomeTypeList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },
   refreshExpensIncomeTypeList() {
     if (this.$refs.expensIncomeTypeTable) {
       this.expensIncomeTypeLoading = true;
       this.$refs.expensIncomeTypeTable.getItems().then(() => {
         this.expensIncomeTypeLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   usernameToLowerCase() {
     this.textToLowerCase(this.newUserValues.username).then((res) => {
       this.newUserValues.username = res;
     }).catch(err => {
         console.error(err);
     });
   },

   roleKindSelectItems(modal) {
      let friendship_kind = '';
      if (modal == 'create_user') {
        friendship_kind = this.newUserValues.friendship_kind;
      }
      else if (modal == 'add_user' && this.modal_add_user && this.modal_add_user.user) {
        friendship_kind = this.modal_add_user.user.friendship_kind;
      }
      let items = [{name: 'Lectura', value: 'read_only'}];
      if (friendship_kind && friendship_kind != 'customer' && friendship_kind != 'customer_consult') {
        items.push({name: 'Escritura', value: 'writer'});
      }
      return items;
   },

   clearNewUserRoleKind() {
     this.newUserValues.role_kind = '';
   },

   deleteUsersDone() {
     this.refreshUsersList();
     this.setSnackbar('success', this.textSnackbarDeleteOK);
   },

   refreshUsersList() {
     if (this.$refs.usersTable) {
       this.usersLoading = true;
       this.$refs.usersTable.getItems().then(() => {
         this.usersLoading = false;
       }).catch(err=>{
         console.error(err)
       });
     }
   },

   resetModalNewUserValues() {
     this.newUserValues.username = "";
     this.newUserValues.email = "";
     this.newUserValues.password = "";
     this.newUserValues.password_repeat = "";
     this.newUserValues.friendship_kind = "";
     this.newUserValues.role_kind = "";
     this.newUserValues.view_invoices = true;
     this.newUserValues.view_banks = false;
     this.newUserValues.view_e_invoice = false;
     this.showPassCreateUserDialog = false;
     this.showPassCreateUserDialog2 = false;
   },

   resetModalAddUserValues() {
     this.modal_add_user.user = "";
     this.modal_add_user.role_kind = "";
   },

   clearAddUserRoleKind() {
     this.modal_add_user.role_kind = '';
   },

   cancelCreateUser() {
     this.createUserDialog = false;
     this.resetModalNewUserValues();
   },

   cancelAddUser() {
     this.addUserDialog = false;
     this.resetModalAddUserValues();
   },

   confirmCreateUser() {
     this.createUserLoading = true;
     const formIsValid = this.$refs.createUserDialogForm.validate();
     if (formIsValid) {
       this.newUserValues.companyDB = this.id;
       this.createCompanyDBUser(this.newUserValues).then(response => {
         if(response.data.hasOwnProperty("error")) {
             this.setSnackbar('error', response.data['error']);
             this.createUserLoading = false;
         }
         else {
           this.createUserLoading = false;
           this.createUserDialog = false;
           this.resetModalNewUserValues();
           this.refreshUsersList();
           this.setSnackbar('success', this.textSnackbarOk);
         }
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.createUserLoading = false;
       });
     }
     else {
       this.createUserLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },

   confirmAddUser() {
     this.addUserLoading = true;
     const formIsValid = this.$refs.addUserDialogForm.validate();
     if (formIsValid) {
       let params = {userId: this.modal_add_user.user.id, companyDBId: this.id, role_kind: this.modal_add_user.role_kind};
       this.addCompanyDBUser(params).then(response => {
         this.addUserLoading = false;
         this.addUserDialog = false;
         this.resetModalAddUserValues();
         this.refreshUsersList();
         this.setSnackbar('success', this.textSnackbarOk);
       }).catch(error => {
         console.error(error);
         this.setSnackbar('error', this.textSnackbarKoApi);
         this.addUserLoading = false;
       });
     }
     else {
       this.addUserLoading = false;
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },

   selectedItemsUserChanged(items, selected_all_items, search_params) {
     this.userSearchFiltersInfo = search_params;
     this.usersAllSelected = selected_all_items;
     this.usersSelected = items.map(function(item) {
       return item['id'];
     });
   },

   resetAMActivity() {
     this.newActivity.name = '';
     this.newActivity.code = '';
     this.activityToUpdate = null;
   },

   cancelAMActivity() {
     this.resetAMActivity();
     this.amActivityDialog = false;
   },
   resetAMAccount() {
     this.newAccount.account = '';
     this.newAccount.description = '';
     this.accountToUpdate = null;
   },
   cancelAMAccount() {
     this.amAccountDialog = false;
     this.resetAMAccount();
   },

   openDeleteUserDialog() {
     this.deleteUserDialog = true;
   },
   openDeleteActivityDialog() {
     this.deleteActivityDialog = true;
   },
   openDeleteChannelDialog() {
     this.deleteChannelDialog = true;
   },
   openDeleteAccountsDialog() {
     this.deleteAccountsDialog = true;
   },
   openDeleteExpensIncomeTypeDialog() {
     this.deleteExpensIncomeTypeDialog = true;
   },

   clickUserTableActionBtn(action, item) {
     if (action == 'update_password') {
       this.changePassUserDialog = true;
       if (this.$refs && this.$refs.changePassUserDialogForm) {
           this.$refs.changePassUserDialogForm.reset();
       }
       this.newPassValues.user_id = item.user;
       this.changePassUserDialog = true;
     }
   },
   
   async deleteUser() {
     let params = {
         ucdbr_ids: this.usersSelected,
         companydb_id: this.id,
         search_filters: this.userSearchFiltersInfo,
     };
     let response =  await this.deleteCompanyDBUser(params)
       if (response.hasOwnProperty("error")) {
         this.errors = { "error": response.error }
         this.errorDialog = true;
         this.errorMsg = response.error;
       } else {
         this.deleteUsersAsyncJob = response.data['AsyncJob'];
         this.deleteUserJobState = 'running';
         this.usersSelected = [];
         this.deleteUserDialog = false;
       }
   },

   noDeleteUser() {
     this.deleteUserDialog = false;
   },

   resetChangePassUserDialog() {
       this.newPassValues.user_id = null;
       this.newPassValues.password = '';
       this.newPassValues.password_repeat = '';
       this.showPassChangePass = false;
       this.showPassChangePass2 = false;
       this.setSnackbar('', '');
   },
   cancelChangePassUserDialog() {
       this.changePassUserDialog = false;
       this.resetChangePassUserDialog();
   },
   confirmChangePassUserDialog() {
       this.changePassLoading = true;
       const formIsValid = this.$refs.changePassUserDialogForm.validate();
       if (formIsValid) {
           this.changePassCDBUser({user_id: this.newPassValues.user_id, pass: this.newPassValues.password}).then(response => {
               this.changePassUserDialog = false;
               this.resetChangePassUserDialog();
               this.changePassLoading = false;
               this.setSnackbar('success', this.textSnackbarOk);
           }).catch(error => {
               console.error(error);
               this.setSnackbar('error', this.textSnackbarKoApi);
               this.changePassLoading = false;
           });
       } else {
           this.changePassLoading = false;
           this.setSnackbar('error', this.textSnackbarKo);
       }
   },

   setSnackbar(color, text) {
       if (text != '') {
           this.snackbar.text = text;
           this.snackbar.isVisible = true;
           this.snackbar.color = color;
       }
       else {
           this.snackbar.text = '';
           this.snackbar.isVisible = false;
       }
   },
   noDeleteActivity() {
     this.deleteActivityDialog = false;
   },
   noDeleteAccounts() {
     this.deleteAccountsDialog = false;
   },
   closeErrorDialog() {
     this.errorDialog = false;
   },
   change_automatic_move_account(value) {
     console.debug(value)
     this.enabled_move_account = (value === 'Sí') || (value === 'y')
   },
   setIvasThirdID(tipo_iva, field_account, field_id) {
     if (this.permanentTypeIvaId()) {
       if (validateAccount(tipo_iva[field_account])) {
         let text_iva = this.get_text_iva(tipo_iva.iva);
         let id = '';
         if (['intra', 'extra', 'isps'].includes(this.tabs[this.currentTab].name)) {
           id = text_iva.replace('%','').replace('IVA', '').replace('IGIC', '');
         } else {
           id = text_iva.split('%')[0]
         }
         tipo_iva[field_id] = id;
       } else {
         tipo_iva[field_id] = '';
       }
     }
   },

   async jobDone() {
     const response = await jobs.getJob({ id: this.asyncJobId });
     this.importErrors = response.data.output_info.errors;
   },
   dropFiles(e){
     // if(this.files != null)
     //   this.files.push(...Array.from(e.dataTransfer.files));
     // else
     this.files = Array.from(e.dataTransfer.files)[0];
     
     this.dragging_file = false;
     e.preventDefault();
   },
   filteredItems(link_path) {
     let items = [];
     for (let i in this.nstpaths) {
       if (this.nstpaths[i].path.includes(link_path)) {
         items.push(this.nstpaths[i]);
       }
     }
     return items;
   },

   updateCSVOneLineColumns(data) {
     this.csv_one_line_headers = data['show']
     this.csv_one_line_hidden_headers = data['hide']
     this.setColumnsCsvOneLine(this.id).then(() => {
       this.csv_one_line_dialog = false;
     }).catch(err => {
       console.error(err);
       this.csv_one_line_dialog = false;
     });
   },

   updateExcelColumns(data) {
       this.excel_headers = data['show']
       this.excel_hidden_headers = data['hide']
       this.excel_dialog_loading = true

       this.setColumnsExcel(this.id).then(() => {
           this.setSnackbar('success', 'Cambios realizados con éxito.')
           setTimeout(() => {this.excel_columns_dialog = false}, 500)

       }).catch(() => {
           this.setSnackbar('error', 'Ha habido un error durante el proceso.')
           this.excel_columns_dialog = false;
       }).finally(() => {
           this.excel_dialog_loading = false
       })
   },
   isTypeCSV() {
    let companyies_csv = ['csv_facturas', 'csv_asientos'];
    return this.currentCompanydbType && companyies_csv.indexOf(this.currentCompanydbType.value) >= 0;
   },
   showNameField() {
     let companyies_csv = ['csv_facturas', 'csv_asientos'];
     return this.currentCon && (this.currentCon.id || this.isTypeCSV());
   },
   get_oauth_message(value) {
     return `A continuación se redireccionará a ${value} para conectar su cuenta.`;
   },
   canCreateWriterUsers() {
     return this.currentCompany && this.currentCompany.available_features && this.currentCompany.available_features.feature_writer_users;
   },
   showActivityField(field) {
     return this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes(field);
   },
   onCheckboxClicked(value) {
     if (value) {
       this.currentCon.cartera_customer = 1
       this.currentCon.cartera_supplier = 1
     } else {
       this.currentCon.cartera_customer = ''
       this.currentCon.cartera_supplier = ''
     }
   },
   onCheckboxDocNumberClicked() {
     if (!this.currentCon.configuration['document_doc_number'] && this.got_feature('feature_document_number_with_filename')) {
       this.currentCon.configuration['document_number_with_filename'] = false;
     }
   },
   async changeCDBType(){
     try {
       await new ChangeCompanyDBTypeCommand(sync_command_dispatcher, this).run(this.currentCon.id,this.allowed_cdbtype_changes[this.currentCon.companydb_type.value].dest)
     } catch (e) {
       console.log(e)
       this.setSnackbar('error', this.textSnackbarKo);
     }
   },
   showProjectsMaster() {
      return this.got_feature('feature_document_projects') && (this.currentCon && this.currentCon.id && this.currentCompanydbType && this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('project'));
    },
    showProjectsMasterCanHide() {
      return this.showProjectsMaster() && !this.currentCon.hide_projects_master;
    },
    showChannelsMaster() {
      return this.got_feature('feature_channel') && (this.currentCon && this.currentCon.id && this.currentCompanydbType && this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('channel'));
    },
    showChannelsMasterCanHide() {
      return this.showChannelsMaster() && !this.currentCon.hide_channels_master;
    },
    showActivitiesMaster() {
      return this.got_feature('feature_actividad_selector') && (this.showActivityField('actividad') || this.showActivityField('actividad_str'));
    },
    showActivitiesMasterCanHide() {
      return this.showActivitiesMaster() && !this.currentCon.hide_activities_master;
    },
    openExcludedFiles() {
      this.popupExcludedFilesKey++;
      this.popupExcludedFiles = true;
    },
    updateExcludedFiles(ok) {
      if (ok) {
        this.setSnackbar('success', "Cambios realizados con éxito.");
      } else {
        this.setSnackbar('error', "Ha habido un error durante el proceso.");
      }
      this.popupExcludedFiles = false;
    },
    async forceLoadPathDownload() {
      this.forceDownloadLoading = true;
      try {
        await new ForceDownloadLoadPathFilesCommand(async_command_dispatcher).run(this.loadPathToUpdate.id, this.loadPathToUpdate.load_path_type.value);
        this.forceDownloadLoading = false;
        this.setSnackbar('success', "Proceso de descarga iniciado.");
      } catch (e) {
        console.log(e)
        this.forceDownloadLoading = false;
        this.setSnackbar('error', "Ha habido un error durante el proceso.");
      }
    },
    isCompanyDBTypePercentTable() {
      return this.currentCon && this.currentCon.configuration && (this.currentCompanydbType.type == 'account_move' || (this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('companydb_percent_table')));
    },
    showTiposIvaTabs(tab_code) {
      return ['iva', 'igic', 'intra', 'extra', 'isps'].includes(tab_code) && this.isCompanyDBTypePercentTable();
    },
    showTiposIvaAndorraTab(tab_code) {
      return tab_code == 'igi' && this.currentCon.tax_type=='igi';
    },
    showWithholdingTab(tab_code) {
      return tab_code == 'withholding' && this.isCompanyDBTypePercentTable();
    },
    showOtherTab(tab_code) {
      return tab_code == 'other';
    },
    getNumDigitsAccounts() {
      return this.currentCompanydbType && this.currentCompanydbType.params && this.currentCompanydbType.params.hasOwnProperty('accounts_length') ? false : this.currentCon && this.currentCon.num_digits;
    },
    permanentTypeIvaId() {
      return this.currentCompanydbType && this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('permanent_type_iva_id');
    },
    showNextNumDocFields() {
      return this.got_feature('feature_fill_num_doc_pending_sync') && this.currentCon && this.currentCon.configuration && 'document_doc_number' in this.currentCon.configuration && this.currentCon.configuration['document_doc_number'];
    },
    showTipoImpuestoLine(tipo_iva, tab_name) {
      if (tab_name == 'igi')
        return tipo_iva.includes(tab_name) && !tipo_iva.includes('igic')      
      return tipo_iva.includes(tab_name)
    },
    formatDate(isoString) {
      let date = new Date(isoString);
      date.setHours(date.getHours() + 1);
      let day = String(date.getDate()).padStart(2, '0');
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let year = date.getFullYear();
      let hours = String(date.getHours()).padStart(2, '0');
      let minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
 },
 async mounted() {
   this.setNstpaths().then(()=>{
     this.nstpaths=this.get_nstpaths
   });

   await this.refreshUserData();
   await this.setCompanyDBTypes();
   if(this.id){
     this.loading=true;
     this.getWebhook({ company_id: this.id });
     this.getWebhookRequest({company_id: this.id})
     this.fetchConnector({ id: this.id }).then(async ()=>{
       this.currentCon = new connector.models.Connector(this.currentConnector);
       if (this.currentCompanydbType.has_locations) {
         this.getLocations(this.currentCompanydbType.value);
       }
       if((this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('actividad')) && !('actividad' in this.currentCon.configuration)){
         this.currentCon.configuration['actividad']=0
       }
       if (this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('nst_files')) {
         for (let i in this.currentCon.links) {
           this.currentCon.links[i].link_path_aux = this.currentCon.links[i].link_path;
         }
       }
       if (this.currentCon.configuration && this.currentCon.configuration['company_as_party']){
        //  this.company_as_party = this.currentCon.configuration['company_as_party']
        //  if (!this.company_as_party['name']){
        //    this.company_as_party['name'] = this.currentCon.name
        //  }
        //  if (!this.company_as_party['first_surname']){
        //    this.company_as_party['first_surname'] = ''
        //  }
        //  if (!this.company_as_party['second_surname']){
        //    this.company_as_party['second_surname'] = ''
        //  }
        this.company_as_party = this.company_as_party.fromPrimitive(this.currentCon.configuration['company_as_party'])
       }
       else{ //inicializamos datos emisor factura 
          this.company_as_party.id = this.currentCon.id
          this.company_as_party.company_id = this.currentCon.id
          this.company_as_party.cif = this.currentCon.cif
          this.company_as_party.name = this.currentCon.name
          this.company_as_party.business_name = this.currentCon.name
          this.company_as_party.trade_name = this.currentCon.name

        //  this.company_as_party['cif'] = this.currentCon.cif
        //  this.company_as_party['name'] = this.currentCon.name
        //  this.company_as_party['business_name'] = this.currentCon.name
        //  this.company_as_party['trade_name'] = this.currentCon.name
       }
       if(this.currentCompanydbType.params && this.currentCompanydbType.params.auth_type && this.currentCompanydbType.params.auth_type == 'openid'){
         this.openid_users = await this.getOpenIdUserSessions({'value':this.currentCompanydbType.value, 'companydb_id': this.id});
       }
       this.loading=false
       if (this.feature_load_paths) {
         this.setLoadPathTypes();
         this.storage_openid_users = await this.getOpenIdUserSessions({'storage':'all','state':'ok'})
       }
       if(this.oauth_params_storage){
         this.loading=true;
         this.currentZone = "Puntos de Carga"
         let to_send = {
           oauth_params:this.oauth_params_storage.params,
           data:{'value':this.oauth_params_storage.type}
         }
         this.amLoadPathDialog=true;
         this.loading_load_path_dialog=true;
         const {data,status_code} = await this.validateUser(to_send);
         let oauth_params_storage_type = this.oauth_params_storage.type;
         let load_path_type = this.load_path_types.find(path => path.value === oauth_params_storage_type);
         this.newLoadPath.load_path_type = load_path_type.id;
         if(status_code===200){
           this.storage_openid_users = await this.getOpenIdUserSessions({'storage':'all'})
           const {oauth_session, state} = data;
           let splitted_state = state.split(",")
           if (splitted_state.length) {
             this.newLoadPath.email_prefix = splitted_state.pop();
           }
           this.newLoadPath.oauth_session = oauth_session;
         }
         else {
           this.setMessageModal({
             text: `No se ha podido crear la sesión de ${this.loadPathSessionlabel}.`,
             actionConfirmButton: this.closeMessageModal
           })
         }
         this.loading_load_path_dialog=false;
         this.oauth_params_storage = undefined;
         this.loading=false;
     }
     this.setCompanydbs2()
     let curr_con = {...this.currentCon}
     this.setCurrentCompany(curr_con);
     });
     this.getColumnsCsvOneLine(this.id);
     await this.setZones(this.id)
     // this.getCdbWithSettings(this.id)

     if (this.currentCompanydbType.params && this.currentCompanydbType.params.show && this.currentCompanydbType.params.show.includes('nst_files')) {
       let contanetDBListOp = await this.getLastGetContanetDBListOp();
       if (Object.keys(contanetDBListOp).includes('id')) {
         this.refreshProgressId = contanetDBListOp['id'];
         this.refreshProgressState = contanetDBListOp['state'];
         if (this.refreshProgressState == 'pending') {
           this.interval = setInterval(this.fetch_refresh_progress_state, 2000);
         }
       }
     }
     if (this.id && (this.currentCompanydbType.params && ((!this.currentCompanydbType.params.hasOwnProperty('hide')) || (this.currentCompanydbType.params.hide && !this.currentCompanydbType.params.hide.includes('sync_thirds'))))) {
       let refreshAccountOp = await this.getLastGetAccountsContanetOp(this.id);
       if (Object.keys(refreshAccountOp).includes('id')) {
         this.refreshAccountsId = refreshAccountOp['id'];
         this.refreshAccountsState = refreshAccountOp['state'];
         if (['pending','running_batch'].includes(this.refreshAccountsState)) {
           this.intervalAccounts = setInterval(this.fetch_refresh_accounts_state, 2000);
         }
       }
     }
   }
   else{
     this.resetConnector()
     this.currentCon = new connector.models.Connector(this.currentConnector);
     if (this.got_feature('feature_cliente_glasof')) {
      this.companydb_types = this.companydb_types.filter(({ value }) => value.includes('glasof'));
     } else if(this.oauth_params){
       this.loading=true
       const oauthParamsParsed = new URLSearchParams(this.oauth_params);
       const {data,status_code} = await this.validateUser(
           {
             oauth_params:this.oauth_params,
             data:{'value':oauthParamsParsed.get('state')}
           });
       if(status_code===200){
         const {state: companydb_type_value, oauth_session, companies} = data;
         this.openid_users = await this.getOpenIdUserSessions({'value': companydb_type_value});
         this.currentCon.companydb_type = this.companydb_types.find(({ value }) => value === companydb_type_value);
         this.currentCon.oauth_session = oauth_session; 
         this.openid_companies = companies;
       }
       this.oauth_params = '';
       this.loading=false
     }
   }
   if (this.got_feature('feature_cartera_checkbox') &&
     this.currentConnector.cartera_supplier == 1 &&
     this.currentConnector.cartera_supplier == 1){
     this.check_cartera = true
   }
   if(this.got_feature('feature_other_documents')){
    await new WorkflowTemplatesQuery(query_dispatcher, this).run()
   }   
   let res = await query_dispatcher.dispatch('check.user.has.active.envoice.contract', { user_id: this.userData.id, company_id: Number(this.id) })
   this.hasEInvoiceContract = res['company']
 },
 beforeDestroy() {
   if (this.interval) {
     clearInterval(this.interval);
   }
   if (this.intervalAccounts) {
     clearInterval(this.intervalAccounts);
   }
 }
};
</script>

<style scoped>
   .circle-container {
     display: flex;
     align-items: center; /* Center vertically */
     justify-content: center; /* Center horizontally */
   }
   .buttom-border {
     border-bottom-style:solid;
     border-color:#663399;
     border-width: thin;
   }
   .top-border {
     border-top-style:solid;
     border-color:#663399;
     border-width: thin;
   }
   .left-border {
     border-left-style:solid;
     border-color:#663399;
     border-width: thin;
   }
   .right-border {
     border-right-style:solid;
     border-color:#663399;
     border-width: thin; 
   }
   .table-head {
       border-left-style:solid;
       border-right-style:solid;
       border-color:#663399;
       border-width: thin;
   }
   .table-row{
       border-left-style:solid;
       border-right-style:solid;
       border-color:#663399;
       border-width: thin;
   }
   .title-color {
       color:#663399;
   }
   .dragging_file{
     background: #f2f2f2!important;
     border-radius: 5px;
     border: 2px dashed #ccc;
   }

   .primary-bckground {
     background-color: #663399;
   }
   .primary-border {
     border-color: #663399 !important;
   }
   .table-row >>> div > .v-input {
     margin-top: 0px;
   }
   .table-row >>> div > .v-input > .v-input__control > .v-input__slot {
     padding-bottom: 4px;
   }
   .progress-circular {
     margin: 7%;
   }
   .modalCheckBox {
        margin-top: -4px;
        padding-top: 0px;
        margin-bottom: 4px;
    }

   .info_btn {
     color: transparent;
   }
   .title-tabs {
     padding-bottom: 0px;
   }
   .items-tabs {
     margin-top: 0px !important;
   }
   ::v-deep .v-tabs-bar__content {
       background: #F8F8FA;
   }
   .v-tab {
       text-transform: capitalize !important;
       font-weight: 400;
       font-size: 18px;
   }

   .connector-detail__title__company-name {
     color: #56565B;
     font-size: 20px;
     font-weight: 300; 
     overflow-wrap: normal;
     word-break: normal;
     hyphens: none;
   }
  .connector-detail__tab-bar__action-btn:not(:first-of-type):not(:last-of-type) {
    margin-left: 16px;
    margin-right: 16px;
  }

  >>> .file-input--outlined.v-text-field--outlined:not(.error--text) fieldset {
    border-color: #66359B;
  }

  >>> .file-input--outlined > .v-input__control > .v-input__slot {
    -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
    box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  }

  >>> .app-expansion-panel__header.v-expansion-panel-header {
    font-size:17px;
    letter-spacing: 0.0892857143em;
    color:#6A6A6B;
  }
  >>> .app-expansion-panel__header.v-expansion-panel-header--active {
    color:#663399;
  }

  .excluded__files {
    background-color: white !important;
    border: 1px solid #663399;
    color: #663399;
  }
</style>
